import React, { useState, useEffect } from 'react';
import './ScallopPay.css';

function ScallopPay() {
  const [hoveredPaymentCard, setHoveredPaymentCard] = useState(0);

  useEffect(() => {
    const maxOffset = 14;
    const handleWindowMouseMove = (e) => {
      const relX = e.clientX / window.innerWidth - 0.5;
      const relY = e.clientY / window.innerHeight - 0.5;
      document.querySelectorAll('.framer-1w6qppx').forEach((image) => {
        image.style.transform = `translate(${relX * maxOffset}px, ${relY * maxOffset}px)`;
      });
    };
    window.addEventListener('mousemove', handleWindowMouseMove);
    return () => window.removeEventListener('mousemove', handleWindowMouseMove);
  }, []);

  return (
    <div className="page-scalloppay">
      <div
        style={{
          position: 'absolute',
          width: 0,
          height: 0,
          overflow: 'hidden',
        }}
        aria-hidden="true"
      >
        <>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            id="svg482887068_1078"
          >
            <path
              d="M25.9584 14.434C25.9107 14.3066 25.8253 14.1968 25.7136 14.1192C25.6018 14.0417 25.4691 14.0001 25.3331 14H17.2831L21.9264 4.972C21.979 4.87035 22.0045 4.75686 22.0004 4.64248C21.9964 4.5281 21.9629 4.41669 21.9033 4.319C21.8437 4.22131 21.7599 4.14064 21.66 4.08476C21.5601 4.02889 21.4475 3.99969 21.3331 4C21.1732 4.00007 21.0187 4.05756 20.8977 4.162L15.9997 8.392L6.23106 16.8287C6.12811 16.9175 6.0548 17.0357 6.02096 17.1675C5.98713 17.2992 5.99439 17.4381 6.04176 17.5656C6.08914 17.6931 6.17437 17.803 6.28602 17.8806C6.39767 17.9583 6.53039 17.9999 6.66639 18H14.7164L10.0731 27.028C10.0205 27.1297 9.99497 27.2431 9.99901 27.3575C10.0031 27.4719 10.0365 27.5833 10.0961 27.681C10.1558 27.7787 10.2396 27.8594 10.3395 27.9152C10.4393 27.9711 10.5519 28.0003 10.6664 28C10.8262 27.9999 10.9807 27.9424 11.1017 27.838L15.9997 23.608L25.7684 15.1713C25.8715 15.0825 25.945 14.9643 25.979 14.8325C26.013 14.7006 26.0058 14.5616 25.9584 14.434Z"
              fill="black"
            />
          </svg>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            id="svg-1654727920_5119"
          >
            <path
              d="M12.4706 4H6.82353C6.07537 4.00223 5.35849 4.30043 4.82946 4.82946C4.30043 5.35849 4.00223 6.07537 4 6.82353V12.4706C4.00223 13.2187 4.30043 13.9356 4.82946 14.4647C5.35849 14.9937 6.07537 15.2919 6.82353 15.2941H12.4706C13.2187 15.2919 13.9356 14.9937 14.4647 14.4647C14.9937 13.9356 15.2919 13.2187 15.2941 12.4706V6.82353C15.2919 6.07537 14.9937 5.35849 14.4647 4.82946C13.9356 4.30043 13.2187 4.00223 12.4706 4ZM12.4706 12.4706H6.82353V6.82353H12.4706V12.4706ZM12.4706 16.7059H6.82353C6.07537 16.7081 5.35849 17.0063 4.82946 17.5353C4.30043 18.0644 4.00223 18.7813 4 19.5294V25.1765C4.00223 25.9246 4.30043 26.6415 4.82946 27.1705C5.35849 27.6996 6.07537 27.9978 6.82353 28H12.4706C13.2187 27.9978 13.9356 27.6996 14.4647 27.1705C14.9937 26.6415 15.2919 25.9246 15.2941 25.1765V19.5294C15.2919 18.7813 14.9937 18.0644 14.4647 17.5353C13.9356 17.0063 13.2187 16.7081 12.4706 16.7059ZM12.4706 25.1765H6.82353V19.5294H12.4706V25.1765ZM25.1765 4H19.5294C18.7813 4.00223 18.0644 4.30043 17.5353 4.82946C17.0063 5.35849 16.7081 6.07537 16.7059 6.82353V12.4706C16.7081 13.2187 17.0063 13.9356 17.5353 14.4647C18.0644 14.9937 18.7813 15.2919 19.5294 15.2941H25.1765C25.9246 15.2919 26.6415 14.9937 27.1705 14.4647C27.6996 13.9356 27.9978 13.2187 28 12.4706V6.82353C27.9978 6.07537 27.6996 5.35849 27.1705 4.82946C26.6415 4.30043 25.9246 4.00223 25.1765 4ZM25.1765 12.4706H19.5294V6.82353H25.1765V12.4706ZM8.94118 11.0588H10.3529C10.536 11.0463 10.7084 10.9679 10.8381 10.8381C10.9679 10.7084 11.0463 10.536 11.0588 10.3529V8.94118C11.0463 8.7581 10.9679 8.58574 10.8381 8.45598C10.7084 8.32622 10.536 8.24783 10.3529 8.23529H8.94118C8.7581 8.24783 8.58574 8.32622 8.45598 8.45598C8.32622 8.58574 8.24783 8.7581 8.23529 8.94118V10.3529C8.24783 10.536 8.32622 10.7084 8.45598 10.8381C8.58574 10.9679 8.7581 11.0463 8.94118 11.0588ZM8.94118 23.7647H10.3529C10.536 23.7522 10.7084 23.6738 10.8381 23.544C10.9679 23.4143 11.0463 23.2419 11.0588 23.0588V21.6471C11.0463 21.464 10.9679 21.2916 10.8381 21.1619C10.7084 21.0321 10.536 20.9537 10.3529 20.9412H8.94118C8.7581 20.9537 8.58574 21.0321 8.45598 21.1619C8.32622 21.2916 8.24783 21.464 8.23529 21.6471V23.0588C8.24783 23.2419 8.32622 23.4143 8.45598 23.544C8.58574 23.6738 8.7581 23.7522 8.94118 23.7647ZM21.6471 11.0588H23.0588C23.2419 11.0463 23.4143 10.9679 23.544 10.8381C23.6738 10.7084 23.7522 10.536 23.7647 10.3529V8.94118C23.7522 8.7581 23.6738 8.58574 23.544 8.45598C23.4143 8.32622 23.2419 8.24783 23.0588 8.23529H21.6471C21.464 8.24783 21.2916 8.32622 21.1619 8.45598C21.0321 8.58574 20.9537 8.7581 20.9412 8.94118V10.3529C20.9537 10.536 21.0321 10.7084 21.1619 10.8381C21.2916 10.9679 21.464 11.0463 21.6471 11.0588ZM17.4118 22.3529H18.8235C19.0066 22.3404 19.179 22.262 19.3087 22.1323C19.4385 22.0025 19.5169 21.8301 19.5294 21.6471V20.2353C19.5419 20.0522 19.6203 19.8799 19.7501 19.7501C19.8799 19.6203 20.0522 19.5419 20.2353 19.5294H21.6471C21.8301 19.5169 22.0025 19.4385 22.1323 19.3087C22.262 19.179 22.3404 19.0066 22.3529 18.8235V17.4118C22.3404 17.2287 22.262 17.0563 22.1323 16.9266C22.0025 16.7968 21.8301 16.7184 21.6471 16.7059H17.4118C17.2287 16.7184 17.0563 16.7968 16.9266 16.9266C16.7968 17.0563 16.7184 17.2287 16.7059 17.4118V21.6471C16.7184 21.8301 16.7968 22.0025 16.9266 22.1323C17.0563 22.262 17.2287 22.3404 17.4118 22.3529ZM27.2941 16.7059H25.8824C25.6993 16.7184 25.5269 16.7968 25.3972 16.9266C25.2674 17.0563 25.189 17.2287 25.1765 17.4118V21.6471C25.189 21.8301 25.2674 22.0025 25.3972 22.1323C25.5269 22.262 25.6993 22.3404 25.8824 22.3529H27.2941C27.4772 22.3404 27.6496 22.262 27.7793 22.1323C27.9091 22.0025 27.9875 21.8301 28 21.6471V17.4118C27.9875 17.2287 27.9091 17.0563 27.7793 16.9266C27.6496 16.7968 27.4772 16.7184 27.2941 16.7059ZM18.8235 25.1765H17.4118C17.2287 25.189 17.0563 25.2674 16.9266 25.3972C16.7968 25.5269 16.7184 25.6993 16.7059 25.8824V27.2941C16.7184 27.4772 16.7968 27.6496 16.9266 27.7793C17.0563 27.9091 17.2287 27.9875 17.4118 28H18.8235C19.0066 27.9875 19.179 27.9091 19.3087 27.7793C19.4385 27.6496 19.5169 27.4772 19.5294 27.2941V25.8824C19.5169 25.6993 19.4385 25.5269 19.3087 25.3972C19.179 25.2674 19.0066 25.189 18.8235 25.1765ZM27.2941 25.1765H25.8824C25.6993 25.1639 25.5269 25.0855 25.3972 24.9558C25.2674 24.826 25.189 24.6537 25.1765 24.4706V23.0588C25.1639 22.8757 25.0855 22.7034 24.9558 22.5736C24.826 22.4439 24.6537 22.3655 24.4706 22.3529H20.2353C20.0522 22.3655 19.8799 22.4439 19.7501 22.5736C19.6203 22.7034 19.5419 22.8757 19.5294 23.0588V24.4706C19.5419 24.6537 19.6203 24.826 19.7501 24.9558C19.8799 25.0855 20.0522 25.1639 20.2353 25.1765H21.6471C21.8301 25.189 22.0025 25.2674 22.1323 25.3972C22.262 25.5269 22.3404 25.6993 22.3529 25.8824V27.2941C22.3655 27.4772 22.4439 27.6496 22.5736 27.7793C22.7034 27.9091 22.8757 27.9875 23.0588 28H27.2941C27.4772 27.9875 27.6496 27.9091 27.7793 27.7793C27.9091 27.6496 27.9875 27.4772 28 27.2941V25.8824C27.9875 25.6993 27.9091 25.5269 27.7793 25.3972C27.6496 25.2674 27.4772 25.189 27.2941 25.1765Z"
              fill="black"
            />
          </svg>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            id="svg2126699191_710"
          >
            <path
              d="M15.8971 6C9.81641 6.00651 4.51042 10.1276 3 16.013C4.52344 21.8919 9.82943 25.9935 15.8971 26C21.9779 25.9935 27.2839 21.8724 28.7943 15.9805C27.2708 10.1081 21.9648 6.00651 15.8971 6ZM15.8971 9.33333C19.582 9.33333 22.5638 12.3151 22.5638 16C22.5638 19.6849 19.582 22.6667 15.8971 22.6667C12.2122 22.6667 9.23047 19.6849 9.23047 16C9.23047 12.3151 12.2122 9.33333 15.8971 9.33333ZM15.8971 12.6667C14.0547 12.6667 12.5638 14.1576 12.5638 16C12.5638 17.8424 14.0547 19.3333 15.8971 19.3333C17.7396 19.3333 19.2305 17.8424 19.2305 16C19.2305 14.1576 17.7396 12.6667 15.8971 12.6667Z"
              fill="black"
            />
          </svg>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            id="svg-1051763948_641"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M16 4C9.37258 4 4 9.37258 4 16C4 22.6275 9.37258 28 16 28C22.6275 28 28 22.6275 28 16C28 9.37258 22.6275 4 16 4ZM21.0571 13.8013C21.384 13.4744 21.384 12.9443 21.0571 12.6173C20.7301 12.2904 20.2001 12.2904 19.8732 12.6173L14.7089 17.7815C14.6 17.8904 14.4233 17.8904 14.3143 17.7815L12.1269 15.594C11.7999 15.2671 11.2698 15.2671 10.9429 15.594C10.6159 15.921 10.6159 16.4511 10.9429 16.778L13.1303 18.9655C13.8931 19.7284 15.1301 19.7284 15.8929 18.9655L21.0571 13.8013Z"
              fill="black"
            />
          </svg>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            id="svg-213069468_783"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4C22.6274 4 28 9.37258 28 16ZM11.4182 16.1091C11.4182 13.5815 13.4724 11.5273 16 11.5273C16.7712 11.5273 17.5043 11.7182 18.1382 12.0618L19.2531 10.9469C18.3138 10.3513 17.1989 10 16 10C12.6247 10 9.89091 12.7338 9.89091 16.1091H7.6L10.6545 19.1637L13.7091 16.1091H11.4182ZM21.3454 13.0545L18.2909 16.1091H20.5818C20.5818 18.6368 18.5277 20.6909 16 20.6909C15.2288 20.6909 14.4957 20.5 13.8618 20.1563L12.7469 21.2712C13.6862 21.8669 14.8011 22.2182 16 22.2182C19.3752 22.2182 22.1091 19.4843 22.1091 16.1091H24.4L21.3454 13.0545Z"
              fill="black"
            />
          </svg>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            id="svg-892036779_709"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M28.7997 15.9997C28.7997 23.0712 23.0671 28.8039 15.9956 28.8039C8.92402 28.8039 3.19141 23.0712 3.19141 15.9997C3.19141 8.92817 8.92402 3.19556 15.9956 3.19556C23.0671 3.19556 28.7997 8.92817 28.7997 15.9997ZM21.156 12.1196C21.5311 12.4947 21.5311 13.1027 21.156 13.4777L14.754 19.8798C14.3789 20.2548 13.771 20.2548 13.3959 19.8798L10.8351 17.3189C10.4601 16.9439 10.4601 16.336 10.8351 15.9609C11.2101 15.5859 11.8181 15.5859 12.1932 15.9609L14.0749 17.8426L16.9364 14.9812L19.798 12.1196C20.1731 11.7446 20.781 11.7446 21.156 12.1196Z"
              fill="#16A34A"
            />
          </svg>
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            id="svg-1469766317_873"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.5248 19.3919C20.8376 19.7039 20.8376 20.216 20.5248 20.528C20.2128 20.84 19.7056 20.84 19.3928 20.528L16.004 17.136L12.5912 20.5519C12.276 20.8639 11.7656 20.8639 11.4504 20.5519C11.136 20.2319 11.136 19.72 11.4504 19.408L14.8632 15.9919L11.4744 12.608C11.1616 12.296 11.1616 11.7839 11.4744 11.4719C11.7856 11.1599 12.2928 11.1599 12.6056 11.4719L15.9944 14.8639L19.4328 11.424C19.748 11.112 20.2576 11.112 20.5728 11.424C20.8872 11.744 20.8872 12.2479 20.5728 12.5679L17.1352 16.008L20.5248 19.3919ZM15.9992 3.19995C8.92962 3.19995 3.19922 8.92795 3.19922 16C3.19922 23.072 8.92962 28.7999 15.9992 28.7999C23.0688 28.7999 28.7992 23.072 28.7992 16C28.7992 8.92795 23.0688 3.19995 15.9992 3.19995Z"
              fill="#DC2626"
            />
          </svg>
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            id="svg350258615_1351"
          >
            <rect width="48" height="48" rx="24" fill="#2563EB" />
            <path
              d="M31.5833 18.5833V15.3333C31.5833 15.046 31.4692 14.7705 31.266 14.5673C31.0629 14.3641 30.7873 14.25 30.5 14.25H16.4167C15.842 14.25 15.2909 14.4783 14.8846 14.8846C14.4783 15.2909 14.25 15.842 14.25 16.4167C14.25 16.9913 14.4783 17.5424 14.8846 17.9487C15.2909 18.3551 15.842 18.5833 16.4167 18.5833H32.6667C32.954 18.5833 33.2295 18.6975 33.4327 18.9006C33.6359 19.1038 33.75 19.3793 33.75 19.6667V24M33.75 24H30.5C29.9254 24 29.3743 24.2283 28.9679 24.6346C28.5616 25.0409 28.3333 25.592 28.3333 26.1667C28.3333 26.7413 28.5616 27.2924 28.9679 27.6987C29.3743 28.1051 29.9254 28.3333 30.5 28.3333H33.75C34.0373 28.3333 34.3129 28.2192 34.516 28.016C34.7192 27.8129 34.8333 27.5373 34.8333 27.25V25.0833C34.8333 24.796 34.7192 24.5205 34.516 24.3173C34.3129 24.1141 34.0373 24 33.75 24Z"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.25 16.4165V31.5832C14.25 32.1578 14.4783 32.7089 14.8846 33.1152C15.2909 33.5216 15.842 33.7498 16.4167 33.7498H32.6667C32.954 33.7498 33.2295 33.6357 33.4327 33.4325C33.6359 33.2294 33.75 32.9538 33.75 32.6665V28.3332"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            id="svg-1385710129_1267"
          >
            <rect width="48" height="48" rx="24" fill="#2563EB" />
            <path
              d="M28.3346 33.75V31.5833C28.3346 30.4341 27.8781 29.3319 27.0654 28.5192C26.2528 27.7065 25.1506 27.25 24.0013 27.25H17.5013C16.352 27.25 15.2498 27.7065 14.4372 28.5192C13.6245 29.3319 13.168 30.4341 13.168 31.5833V33.75"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20.7513 22.9167C23.1445 22.9167 25.0846 20.9766 25.0846 18.5833C25.0846 16.1901 23.1445 14.25 20.7513 14.25C18.3581 14.25 16.418 16.1901 16.418 18.5833C16.418 20.9766 18.3581 22.9167 20.7513 22.9167Z"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M34.832 33.7498V31.5831C34.8313 30.623 34.5117 29.6903 33.9235 28.9315C33.3353 28.1726 32.5117 27.6307 31.582 27.3906"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M28.332 14.3906C29.2641 14.6293 30.0903 15.1714 30.6803 15.9315C31.2703 16.6915 31.5905 17.6264 31.5905 18.5885C31.5905 19.5507 31.2703 20.4855 30.6803 21.2456C30.0903 22.0057 29.2641 22.5478 28.332 22.7865"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            id="svg585653685_904"
          >
            <rect width="48" height="48" rx="24" fill="#2563EB" />
            <path
              d="M14.625 24C14.625 21.5136 15.6127 19.129 17.3709 17.3709C19.129 15.6127 21.5136 14.625 24 14.625C26.6209 14.6349 29.1365 15.6575 31.0208 17.4792L33.375 19.8333"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M33.3763 14.625V19.8333H28.168"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M33.375 24C33.375 26.4864 32.3873 28.871 30.6291 30.6291C28.871 32.3873 26.4864 33.375 24 33.375C21.3791 33.3651 18.8635 32.3425 16.9792 30.5208L14.625 28.1667"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19.8333 28.1665H14.625V33.3748"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            id="svg1436678953_1486"
          >
            <rect width="48" height="48" rx="24" fill="#2563EB" />
            <path
              d="M15.3331 26.1664C15.1281 26.1671 14.9271 26.1096 14.7535 26.0006C14.5799 25.8916 14.4407 25.7356 14.3522 25.5507C14.2637 25.3658 14.2295 25.1595 14.2536 24.9559C14.2776 24.7524 14.359 24.5598 14.4881 24.4006L25.2131 13.3506C25.2936 13.2577 25.4032 13.1949 25.524 13.1726C25.6448 13.1503 25.7697 13.1697 25.878 13.2276C25.9863 13.2856 26.0718 13.3786 26.1202 13.4915C26.1687 13.6044 26.1774 13.7304 26.1448 13.8489L24.0648 20.3706C24.0035 20.5347 23.9829 20.7113 24.0048 20.8852C24.0267 21.059 24.0904 21.225 24.1906 21.3688C24.2907 21.5126 24.4242 21.63 24.5797 21.7108C24.7351 21.7917 24.9079 21.8336 25.0831 21.8331H32.6665C32.8715 21.8324 33.0725 21.8898 33.2461 21.9988C33.4197 22.1078 33.5589 22.2638 33.6474 22.4488C33.7359 22.6337 33.7701 22.8399 33.746 23.0435C33.7219 23.2471 33.6406 23.4397 33.5115 23.5989L22.7865 34.6489C22.706 34.7418 22.5964 34.8045 22.4756 34.8268C22.3547 34.8492 22.2299 34.8298 22.1216 34.7718C22.0132 34.7139 21.9278 34.6208 21.8793 34.5079C21.8309 34.395 21.8222 34.269 21.8548 34.1506L23.9348 27.6289C23.9961 27.4647 24.0167 27.2882 23.9948 27.1143C23.9729 26.9404 23.9092 26.7745 23.809 26.6307C23.7089 26.4869 23.5754 26.3695 23.4199 26.2886C23.2644 26.2078 23.0917 26.1658 22.9165 26.1664H15.3331Z"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            id="svg1697830745_861"
          >
            <rect width="48" height="48" rx="24" fill="#2563EB" />
            <path
              d="M24.0013 34.8332C29.9844 34.8332 34.8346 29.9829 34.8346 23.9998C34.8346 18.0168 29.9844 13.1665 24.0013 13.1665C18.0182 13.1665 13.168 18.0168 13.168 23.9998C13.168 29.9829 18.0182 34.8332 24.0013 34.8332Z"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M24.0013 13.1665C21.2196 16.0873 19.668 19.9663 19.668 23.9998C19.668 28.0334 21.2196 31.9123 24.0013 34.8332C26.783 31.9123 28.3346 28.0334 28.3346 23.9998C28.3346 19.9663 26.783 16.0873 24.0013 13.1665Z"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.168 24H34.8346"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            id="svg-488446441_777"
          >
            <rect width="48" height="48" rx="24" fill="#2563EB" />
            <path
              d="M34.2095 21.9165C34.6853 24.2512 34.3462 26.6784 33.249 28.7933C32.1517 30.9083 30.3626 32.5832 28.1799 33.5387C25.9972 34.4942 23.5529 34.6725 21.2546 34.0439C18.9564 33.4154 16.9431 32.0179 15.5505 30.0846C14.1578 28.1513 13.4701 25.799 13.6019 23.42C13.7337 21.041 14.6771 18.7791 16.2748 17.0114C17.8725 15.2438 20.0279 14.0773 22.3815 13.7065C24.7351 13.3357 27.1447 13.783 29.2085 14.9738"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M20.875 22.9582L24 26.0832L34.4167 15.6665"
              stroke="white"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <svg viewBox="0 0 180 60" overflow="visible" id="svg1322499166_10645">
            <g>
              <path d="M 0 60 L 0 0 L 180 0 L 180 60 Z" fill="transparent" />
              <path
                d="M 169.5 0.75 L 10.5 0.75 C 5.115 0.75 0.75 5.115 0.75 10.5 L 0.75 49.5 C 0.75 54.885 5.115 59.25 10.5 59.25 L 169.5 59.25 C 174.885 59.25 179.25 54.885 179.25 49.5 L 179.25 10.5 C 179.25 5.115 174.885 0.75 169.5 0.75 Z"
                fill="rgb(12,13,16)"
              />
              <path
                d="M 169.5 0.75 L 10.5 0.75 C 5.115 0.75 0.75 5.115 0.75 10.5 L 0.75 49.5 C 0.75 54.885 5.115 59.25 10.5 59.25 L 169.5 59.25 C 174.885 59.25 179.25 54.885 179.25 49.5 L 179.25 10.5 C 179.25 5.115 174.885 0.75 169.5 0.75 Z"
                fill="transparent"
                strokeWidth={1.5}
                stroke="rgb(166,166,166)"
                strokeMiterlimit={10}
                strokeDasharray=""
              />
              <path
                d="M 122.291 28.802 L 122.291 32.239 L 120.137 32.239 L 120.137 34.492 L 122.291 34.492 L 122.291 42.15 C 122.291 44.764 123.474 45.81 126.449 45.81 C 126.972 45.81 127.471 45.748 127.906 45.673 L 127.906 43.445 C 127.533 43.482 127.296 43.507 126.885 43.507 C 125.553 43.507 124.968 42.884 124.968 41.465 L 124.968 34.492 L 127.906 34.492 L 127.906 32.239 L 124.968 32.239 L 124.968 28.802 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 135.486 45.997 C 139.445 45.997 141.873 43.345 141.873 38.95 C 141.873 34.579 139.433 31.915 135.486 31.915 C 131.526 31.915 129.086 34.579 129.086 38.95 C 129.086 43.345 131.514 45.997 135.486 45.997 Z M 135.486 43.619 C 133.158 43.619 131.85 41.913 131.85 38.95 C 131.85 36.011 133.158 34.293 135.486 34.293 C 137.802 34.293 139.122 36.011 139.122 38.95 C 139.122 41.901 137.802 43.619 135.486 43.619 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 143.949 45.736 L 146.626 45.736 L 146.626 37.73 C 146.626 35.825 148.058 34.542 150.088 34.542 C 150.56 34.542 151.358 34.629 151.582 34.704 L 151.582 32.064 C 151.295 31.989 150.785 31.952 150.386 31.952 C 148.618 31.952 147.112 32.923 146.726 34.256 L 146.527 34.256 L 146.527 32.176 L 143.949 32.176 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 158.229 34.193 C 160.209 34.193 161.504 35.575 161.567 37.705 L 154.718 37.705 C 154.868 35.588 156.249 34.193 158.229 34.193 Z M 161.555 42.075 C 161.057 43.133 159.948 43.719 158.33 43.719 C 156.188 43.719 154.806 42.212 154.718 39.834 L 154.718 39.684 L 164.294 39.684 L 164.294 38.751 C 164.294 34.492 162.015 31.915 158.243 31.915 C 154.419 31.915 151.992 34.666 151.992 39 C 151.992 43.333 154.37 45.997 158.255 45.997 C 161.355 45.997 163.521 44.503 164.132 42.075 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 104.734 40.728 C 104.941 44.058 107.716 46.187 111.845 46.187 C 116.259 46.187 119.021 43.955 119.021 40.393 C 119.021 37.592 117.446 36.044 113.626 35.153 L 111.574 34.65 C 109.148 34.082 108.167 33.321 108.167 31.992 C 108.167 30.314 109.69 29.217 111.974 29.217 C 114.142 29.217 115.639 30.288 115.91 32.005 L 118.724 32.005 C 118.556 28.868 115.794 26.662 112.013 26.662 C 107.948 26.662 105.238 28.868 105.238 32.185 C 105.238 34.921 106.773 36.547 110.142 37.334 L 112.542 37.915 C 115.007 38.496 116.091 39.348 116.091 40.767 C 116.091 42.419 114.388 43.619 112.065 43.619 C 109.574 43.619 107.845 42.496 107.599 40.728 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 77.004 31.952 C 75.161 31.952 73.567 32.873 72.745 34.417 L 72.546 34.417 L 72.546 32.176 L 69.969 32.176 L 69.969 50.243 L 72.646 50.243 L 72.646 43.681 L 72.857 43.681 C 73.567 45.113 75.099 45.96 77.028 45.96 C 80.453 45.96 82.632 43.258 82.632 38.95 C 82.632 34.642 80.453 31.952 77.004 31.952 Z M 76.244 43.557 C 74.003 43.557 72.596 41.789 72.596 38.962 C 72.596 36.123 74.003 34.355 76.257 34.355 C 78.523 34.355 79.88 36.086 79.88 38.95 C 79.88 41.826 78.523 43.557 76.244 43.557 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 91.996 31.952 C 90.153 31.952 88.559 32.873 87.737 34.417 L 87.538 34.417 L 87.538 32.176 L 84.961 32.176 L 84.961 50.243 L 87.638 50.243 L 87.638 43.681 L 87.85 43.681 C 88.559 45.113 90.091 45.96 92.021 45.96 C 95.445 45.96 97.624 43.258 97.624 38.95 C 97.624 34.642 95.445 31.952 91.996 31.952 Z M 91.236 43.557 C 88.995 43.557 87.588 41.789 87.588 38.962 C 87.588 36.123 88.995 34.355 91.249 34.355 C 93.515 34.355 94.872 36.086 94.872 38.95 C 94.872 41.826 93.515 43.557 91.236 43.557 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 65.166 45.736 L 68.237 45.736 L 61.514 27.113 L 58.403 27.113 L 51.68 45.736 L 54.648 45.736 L 56.364 40.793 L 63.462 40.793 Z M 59.81 30.495 L 60.029 30.495 L 62.727 38.367 L 57.1 38.367 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 53.477 13.066 L 53.477 22.05 L 56.72 22.05 C 59.397 22.05 60.947 20.4 60.947 17.53 C 60.947 14.703 59.385 13.066 56.72 13.066 Z M 54.871 14.336 L 56.565 14.336 C 58.426 14.336 59.528 15.519 59.528 17.548 C 59.528 19.609 58.445 20.779 56.565 20.779 L 54.871 20.779 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 65.696 22.18 C 67.676 22.18 68.89 20.854 68.89 18.657 C 68.89 16.471 67.67 15.139 65.696 15.139 C 63.716 15.139 62.496 16.471 62.496 18.657 C 62.496 20.854 63.71 22.18 65.696 22.18 Z M 65.696 20.991 C 64.532 20.991 63.878 20.138 63.878 18.657 C 63.878 17.188 64.532 16.328 65.696 16.328 C 66.854 16.328 67.514 17.188 67.514 18.657 C 67.514 20.132 66.854 20.991 65.696 20.991 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 79.227 15.27 L 77.888 15.27 L 76.68 20.443 L 76.574 20.443 L 75.18 15.27 L 73.897 15.27 L 72.503 20.443 L 72.403 20.443 L 71.189 15.27 L 69.832 15.27 L 71.7 22.049 L 73.076 22.049 L 74.47 17.057 L 74.576 17.057 L 75.977 22.049 L 77.365 22.049 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 80.769 22.05 L 82.108 22.05 L 82.108 18.084 C 82.108 17.026 82.737 16.366 83.727 16.366 C 84.717 16.366 85.19 16.907 85.19 17.997 L 85.19 22.05 L 86.528 22.05 L 86.528 17.661 C 86.528 16.048 85.694 15.139 84.181 15.139 C 83.16 15.139 82.488 15.594 82.158 16.347 L 82.058 16.347 L 82.058 15.27 L 80.769 15.27 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 88.637 22.049 L 89.975 22.049 L 89.975 12.624 L 88.637 12.624 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 95.008 22.18 C 96.988 22.18 98.202 20.854 98.202 18.657 C 98.202 16.471 96.982 15.139 95.008 15.139 C 93.029 15.139 91.809 16.471 91.809 18.657 C 91.809 20.854 93.022 22.18 95.008 22.18 Z M 95.008 20.991 C 93.844 20.991 93.191 20.138 93.191 18.657 C 93.191 17.188 93.844 16.328 95.008 16.328 C 96.166 16.328 96.826 17.188 96.826 18.657 C 96.826 20.132 96.166 20.991 95.008 20.991 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 102.188 21.035 C 101.46 21.035 100.931 20.68 100.931 20.07 C 100.931 19.472 101.354 19.155 102.288 19.092 L 103.944 18.987 L 103.944 19.553 C 103.944 20.394 103.197 21.035 102.188 21.035 Z M 101.846 22.162 C 102.736 22.162 103.477 21.776 103.882 21.097 L 103.987 21.097 L 103.987 22.05 L 105.276 22.05 L 105.276 17.418 C 105.276 15.986 104.317 15.139 102.618 15.139 C 101.08 15.139 99.984 15.886 99.847 17.05 L 101.142 17.05 C 101.292 16.571 101.808 16.297 102.555 16.297 C 103.471 16.297 103.944 16.702 103.944 17.418 L 103.944 18.003 L 102.107 18.109 C 100.495 18.208 99.586 18.912 99.586 20.132 C 99.586 21.371 100.538 22.162 101.846 22.162 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 109.818 22.162 C 110.752 22.162 111.542 21.72 111.947 20.979 L 112.053 20.979 L 112.053 22.049 L 113.335 22.049 L 113.335 12.624 L 111.997 12.624 L 111.997 16.347 L 111.897 16.347 C 111.53 15.6 110.746 15.158 109.818 15.158 C 108.106 15.158 107.004 16.515 107.004 18.657 C 107.004 20.804 108.093 22.162 109.818 22.162 Z M 110.198 16.359 C 111.318 16.359 112.022 17.25 112.022 18.663 C 112.022 20.082 111.325 20.96 110.198 20.96 C 109.065 20.96 108.386 20.095 108.386 18.657 C 108.386 17.231 109.071 16.359 110.198 16.359 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 122.016 22.18 C 123.996 22.18 125.21 20.854 125.21 18.657 C 125.21 16.471 123.99 15.139 122.016 15.139 C 120.037 15.139 118.816 16.471 118.816 18.657 C 118.816 20.854 120.031 22.18 122.016 22.18 Z M 122.016 20.991 C 120.852 20.991 120.199 20.138 120.199 18.657 C 120.199 17.188 120.852 16.328 122.016 16.328 C 123.174 16.328 123.834 17.188 123.834 18.657 C 123.834 20.132 123.174 20.991 122.016 20.991 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 126.98 22.05 L 128.319 22.05 L 128.319 18.084 C 128.319 17.026 128.948 16.366 129.938 16.366 C 130.927 16.366 131.401 16.907 131.401 17.997 L 131.401 22.05 L 132.739 22.05 L 132.739 17.661 C 132.739 16.048 131.905 15.139 130.392 15.139 C 129.371 15.139 128.699 15.594 128.369 16.347 L 128.269 16.347 L 128.269 15.27 L 126.98 15.27 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 138.905 13.583 L 138.905 15.301 L 137.828 15.301 L 137.828 16.428 L 138.905 16.428 L 138.905 20.257 C 138.905 21.564 139.497 22.087 140.984 22.087 C 141.246 22.087 141.495 22.056 141.713 22.018 L 141.713 20.904 C 141.526 20.923 141.408 20.935 141.202 20.935 C 140.536 20.935 140.244 20.624 140.244 19.914 L 140.244 16.428 L 141.713 16.428 L 141.713 15.301 L 140.244 15.301 L 140.244 13.583 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 143.512 22.049 L 144.85 22.049 L 144.85 18.09 C 144.85 17.063 145.46 16.372 146.556 16.372 C 147.502 16.372 148.007 16.92 148.007 18.003 L 148.007 22.049 L 149.345 22.049 L 149.345 17.673 C 149.345 16.061 148.455 15.145 147.011 15.145 C 145.99 15.145 145.274 15.6 144.944 16.359 L 144.838 16.359 L 144.838 12.624 L 143.512 12.624 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 154.173 16.278 C 155.163 16.278 155.811 16.969 155.843 18.034 L 152.418 18.034 C 152.493 16.976 153.183 16.278 154.173 16.278 Z M 155.835 20.219 C 155.586 20.748 155.033 21.041 154.223 21.041 C 153.153 21.041 152.462 20.288 152.418 19.099 L 152.418 19.024 L 157.205 19.024 L 157.205 18.557 C 157.205 16.428 156.066 15.139 154.179 15.139 C 152.268 15.139 151.055 16.515 151.055 18.681 C 151.055 20.848 152.244 22.18 154.185 22.18 C 155.736 22.18 156.819 21.433 157.124 20.219 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 37.153 30.452 C 37.185 27.93 38.54 25.544 40.688 24.224 C 39.333 22.288 37.063 21.061 34.701 20.987 C 32.182 20.723 29.74 22.494 28.457 22.494 C 27.148 22.494 25.172 21.013 23.044 21.057 C 20.27 21.147 17.684 22.724 16.335 25.149 C 13.434 30.172 15.598 37.553 18.376 41.613 C 19.767 43.601 21.392 45.822 23.518 45.743 C 25.599 45.657 26.375 44.416 28.887 44.416 C 31.375 44.416 32.104 45.743 34.273 45.693 C 36.506 45.657 37.913 43.696 39.254 41.689 C 40.253 40.273 41.022 38.707 41.532 37.05 C 38.908 35.941 37.156 33.3 37.153 30.452 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 33.057 18.317 C 34.274 16.856 34.874 14.977 34.729 13.081 C 32.869 13.276 31.151 14.165 29.917 15.57 C 28.711 16.943 28.083 18.789 28.202 20.613 C 30.062 20.632 31.891 19.767 33.057 18.317 Z"
                fill="rgb(255,255,255)"
              />
            </g>
          </svg>
          <svg
            viewBox="0 0 201 58.5"
            overflow="visible"
            id="svg-412316951_7924"
          >
            <g>
              <path
                d="M 6.75 58.5 C 3.022 58.5 0 55.478 0 51.75 L 0 6.75 C 0 3.022 3.022 0 6.75 0 L 194.25 0 C 197.978 0 201 3.022 201 6.75 L 201 51.75 C 201 55.478 197.978 58.5 194.25 58.5 Z"
                fill="rgb(0,0,0)"
              />
              <path
                d="M 6.75 58.5 C 3.022 58.5 0 55.478 0 51.75 L 0 6.75 C 0 3.022 3.022 0 6.75 0 L 194.25 0 C 197.978 0 201 3.022 201 6.75 L 201 51.75 C 201 55.478 197.978 58.5 194.25 58.5 Z"
                fill="transparent"
                strokeWidth={1.5}
                stroke="rgb(166,166,166)"
                strokeMiterlimit={10}
                strokeDasharray=""
              />
              <path
                d="M 159.651 44.25 L 162.45 44.25 L 162.45 25.498 L 159.651 25.498 Z M 184.862 32.253 L 181.654 40.383 L 181.558 40.383 L 178.228 32.253 L 175.213 32.253 L 180.208 43.616 L 177.359 49.937 L 180.278 49.937 L 187.975 32.253 Z M 168.988 42.12 C 168.073 42.12 166.793 41.661 166.793 40.528 C 166.793 39.08 168.386 38.525 169.76 38.525 C 170.99 38.525 171.571 38.79 172.318 39.152 C 172.1 40.89 170.605 42.12 168.988 42.12 Z M 169.326 31.843 C 167.3 31.843 165.201 32.736 164.333 34.714 L 166.817 35.751 C 167.348 34.714 168.336 34.376 169.374 34.376 C 170.822 34.376 172.293 35.244 172.317 36.789 L 172.317 36.981 C 171.81 36.692 170.724 36.258 169.398 36.258 C 166.719 36.258 163.994 37.729 163.994 40.479 C 163.994 42.989 166.19 44.605 168.65 44.605 C 170.531 44.605 171.57 43.761 172.22 42.771 L 172.317 42.771 L 172.317 44.22 L 175.02 44.22 L 175.02 37.029 C 175.02 33.7 172.533 31.843 169.326 31.843 Z M 152.029 34.536 L 148.047 34.536 L 148.047 28.108 L 152.029 28.108 C 154.121 28.108 155.309 29.84 155.309 31.322 C 155.309 32.775 154.121 34.536 152.029 34.536 Z M 151.957 25.498 L 145.249 25.498 L 145.249 44.25 L 148.047 44.25 L 148.047 37.146 L 151.957 37.146 C 155.059 37.146 158.108 34.9 158.108 31.322 C 158.108 27.744 155.059 25.498 151.957 25.498 Z M 115.384 42.124 C 113.45 42.124 111.832 40.504 111.832 38.282 C 111.832 36.033 113.45 34.391 115.384 34.391 C 117.293 34.391 118.791 36.033 118.791 38.282 C 118.791 40.504 117.293 42.124 115.384 42.124 Z M 118.598 33.303 L 118.501 33.303 C 117.873 32.554 116.664 31.877 115.142 31.877 C 111.952 31.877 109.028 34.681 109.028 38.282 C 109.028 41.858 111.952 44.637 115.142 44.637 C 116.664 44.637 117.873 43.96 118.501 43.187 L 118.598 43.187 L 118.598 44.105 C 118.598 46.546 117.293 47.851 115.19 47.851 C 113.475 47.851 112.412 46.618 111.977 45.579 L 109.536 46.594 C 110.236 48.285 112.097 50.364 115.19 50.364 C 118.478 50.364 121.257 48.431 121.257 43.718 L 121.257 32.264 L 118.598 32.264 Z M 123.19 44.25 L 125.992 44.25 L 125.992 25.498 L 123.19 25.498 Z M 130.125 38.064 C 130.053 35.599 132.035 34.342 133.46 34.342 C 134.572 34.342 135.514 34.898 135.829 35.695 Z M 138.824 35.937 C 138.293 34.512 136.674 31.877 133.363 31.877 C 130.076 31.877 127.346 34.463 127.346 38.257 C 127.346 41.834 130.053 44.637 133.677 44.637 C 136.601 44.637 138.293 42.849 138.994 41.81 L 136.819 40.359 C 136.094 41.423 135.104 42.124 133.677 42.124 C 132.252 42.124 131.236 41.471 130.585 40.19 L 139.114 36.662 Z M 70.863 33.835 L 70.863 36.541 L 77.339 36.541 C 77.146 38.064 76.638 39.175 75.865 39.949 C 74.922 40.891 73.448 41.93 70.863 41.93 C 66.875 41.93 63.758 38.716 63.758 34.729 C 63.758 30.742 66.875 27.527 70.863 27.527 C 73.013 27.527 74.584 28.373 75.744 29.461 L 77.654 27.551 C 76.034 26.005 73.884 24.821 70.863 24.821 C 65.4 24.821 60.809 29.268 60.809 34.729 C 60.809 40.19 65.4 44.637 70.863 44.637 C 73.81 44.637 76.034 43.67 77.774 41.858 C 79.562 40.069 80.118 37.556 80.118 35.526 C 80.118 34.898 80.069 34.318 79.973 33.835 Z M 87.481 42.124 C 85.547 42.124 83.88 40.529 83.88 38.257 C 83.88 35.961 85.547 34.391 87.481 34.391 C 89.414 34.391 91.081 35.961 91.081 38.257 C 91.081 40.529 89.414 42.124 87.481 42.124 Z M 87.481 31.877 C 83.952 31.877 81.077 34.56 81.077 38.257 C 81.077 41.93 83.952 44.637 87.481 44.637 C 91.009 44.637 93.885 41.93 93.885 38.257 C 93.885 34.56 91.009 31.877 87.481 31.877 Z M 101.45 42.124 C 99.518 42.124 97.85 40.529 97.85 38.257 C 97.85 35.961 99.518 34.391 101.45 34.391 C 103.384 34.391 105.051 35.961 105.051 38.257 C 105.051 40.529 103.384 42.124 101.45 42.124 Z M 101.45 31.877 C 97.922 31.877 95.047 34.56 95.047 38.257 C 95.047 41.93 97.922 44.637 101.45 44.637 C 104.979 44.637 107.855 41.93 107.855 38.257 C 107.855 34.56 104.979 31.877 101.45 31.877 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 65.965 19.102 C 64.62 19.102 63.463 18.628 62.531 17.696 C 61.598 16.763 61.125 15.594 61.125 14.236 C 61.125 12.877 61.598 11.711 62.531 10.776 C 63.463 9.843 64.62 9.37 65.965 9.37 C 66.65 9.37 67.289 9.489 67.9 9.735 C 68.512 9.981 69.012 10.324 69.406 10.771 L 69.498 10.877 L 68.449 11.926 L 68.345 11.797 C 68.083 11.476 67.751 11.227 67.33 11.046 C 66.911 10.865 66.452 10.781 65.965 10.781 C 65.018 10.781 64.232 11.103 63.575 11.757 C 62.933 12.424 62.611 13.236 62.611 14.236 C 62.611 15.236 62.934 16.049 63.576 16.716 C 64.232 17.37 65.018 17.693 65.965 17.693 C 66.832 17.693 67.549 17.451 68.113 16.972 C 68.638 16.526 68.953 15.923 69.064 15.155 L 65.815 15.155 L 65.815 13.772 L 70.469 13.772 L 70.489 13.898 C 70.527 14.142 70.554 14.376 70.554 14.602 C 70.554 15.892 70.16 16.945 69.389 17.72 C 68.517 18.644 67.372 19.102 65.965 19.102 Z M 106.377 19.102 C 105.031 19.102 103.887 18.628 102.967 17.696 C 102.967 17.696 102.966 17.696 102.966 17.695 C 102.044 16.773 101.587 15.605 101.587 14.236 C 101.587 12.867 102.044 11.699 102.966 10.777 C 102.966 10.776 102.966 10.776 102.966 10.776 C 103.886 9.844 105.031 9.37 106.377 9.37 C 107.722 9.37 108.865 9.844 109.786 10.79 C 110.708 11.712 111.166 12.878 111.166 14.236 C 111.166 15.605 110.708 16.773 109.786 17.695 C 108.865 18.628 107.711 19.102 106.377 19.102 Z M 71.886 18.9 L 71.886 9.572 L 72.036 9.572 L 77.457 9.572 L 77.457 10.983 L 73.346 10.983 L 73.346 13.545 L 77.054 13.545 L 77.054 14.927 L 73.346 14.927 L 73.346 17.491 L 77.457 17.491 L 77.457 18.9 Z M 80.866 18.9 L 80.866 10.983 L 78.344 10.983 L 78.344 9.572 L 84.848 9.572 L 84.848 10.983 L 84.698 10.983 L 82.326 10.983 L 82.326 18.9 Z M 89.005 18.9 L 89.005 9.572 L 90.465 9.572 L 90.465 9.722 L 90.465 18.9 Z M 94.141 18.9 L 94.141 10.983 L 91.619 10.983 L 91.619 9.572 L 98.123 9.572 L 98.123 10.983 L 97.973 10.983 L 95.601 10.983 L 95.601 18.9 Z M 112.462 18.9 L 112.462 9.572 L 114.108 9.572 L 118.299 16.28 L 118.263 15.007 L 118.263 9.572 L 119.723 9.572 L 119.723 18.9 L 118.278 18.9 L 113.886 11.853 L 113.922 13.125 L 113.922 13.127 L 113.922 18.9 Z M 106.377 17.693 C 107.325 17.693 108.098 17.37 108.728 16.717 L 108.729 16.716 L 108.73 16.715 C 109.369 16.076 109.682 15.252 109.682 14.236 C 109.682 13.222 109.369 12.396 108.73 11.757 L 108.729 11.756 L 108.728 11.755 C 108.098 11.102 107.325 10.781 106.377 10.781 C 105.428 10.781 104.655 11.102 104.013 11.754 L 104.013 11.755 C 103.385 12.41 103.073 13.222 103.073 14.236 C 103.073 15.252 103.385 16.062 104.013 16.717 C 104.655 17.37 105.429 17.693 106.377 17.693 Z"
                fill="rgb(255,255,255)"
              />
              <path
                d="M 30.322 28.385 L 14.352 45.335 C 14.353 45.338 14.354 45.341 14.354 45.345 C 14.844 47.185 16.525 48.541 18.52 48.541 C 19.318 48.541 20.067 48.325 20.709 47.946 L 20.76 47.916 L 38.736 37.544 Z"
                fill="rgb(234,67,53)"
              />
              <path
                d="M 46.48 25.499 L 46.465 25.489 L 38.704 20.99 L 29.961 28.77 L 38.735 37.542 L 46.455 33.088 C 47.808 32.358 48.727 30.931 48.727 29.285 C 48.727 27.652 47.82 26.232 46.48 25.499 Z"
                fill="rgb(251,188,4)"
              />
              <path
                d="M 14.349 13.165 C 14.253 13.519 14.203 13.89 14.203 14.275 L 14.203 44.226 C 14.203 44.611 14.253 44.983 14.35 45.335 L 30.869 28.819 Z"
                fill="rgb(66,133,244)"
              />
              <path
                d="M 30.441 29.25 L 38.706 20.987 L 20.751 10.576 C 20.098 10.185 19.336 9.96 18.521 9.96 C 16.526 9.96 14.843 11.317 14.353 13.16 C 14.352 13.162 14.352 13.163 14.352 13.165 Z"
                fill="rgb(52,168,83)"
              />
            </g>
          </svg>
          <svg
            width="699"
            height="196"
            viewBox="0 0 699 196"
            fill="none"
            id="svg-1137231340_6119"
          >
            <path
              d="M668.903 75.4492C685.462 75.4492 698.806 91.3256 699 111.098C699 111.195 699 111.39 699 111.488C699 111.682 699 111.877 699 111.975C698.806 131.747 685.462 147.623 668.903 147.623C668.027 147.623 667.15 147.623 666.176 147.526L666.079 147.428C659.163 146.649 653.904 140.805 653.904 133.792V129.604H647.865V137.299V147.623V162.501L626.826 177.72V111.488V75.4492H647.865V85.7737V93.4684H653.904V89.2801C653.904 82.2673 659.163 76.3258 666.079 75.5466H666.176C667.15 75.4492 668.027 75.4492 668.903 75.4492ZM662.767 126.585C671.144 126.682 677.962 119.864 677.962 111.488C677.962 103.208 671.144 96.3904 662.767 96.4878C654.683 96.5852 647.962 103.208 647.865 111.39V111.488C647.865 111.585 647.865 111.585 647.865 111.682C647.962 119.864 654.683 126.487 662.767 126.585Z"
              fill="#030319"
            />
            <path
              d="M583.064 75.4492C602.933 75.4492 619.102 91.6177 619.102 111.488C619.102 131.455 602.933 147.623 583.064 147.623C563.096 147.623 546.928 131.455 546.928 111.488C546.928 91.6177 563.096 75.4492 583.064 75.4492ZM583.064 126.585C591.343 126.585 598.063 119.864 598.063 111.488C598.063 103.208 591.343 96.4878 583.064 96.4878C574.687 96.4878 567.966 103.208 567.966 111.488C567.966 119.864 574.687 126.585 583.064 126.585Z"
              fill="#030319"
            />
            <path
              d="M488.334 147.623V60.5712L509.373 45.3523V147.623H488.334ZM518.431 147.623V58.9032L539.47 43.6843V147.623H518.431Z"
              fill="#030319"
            />
            <path
              d="M459.569 85.7737V75.4492H480.608V111.488V147.623H459.569V137.299V129.604H453.53V133.792C453.53 140.805 448.368 146.649 441.355 147.428H441.258C440.381 147.526 439.407 147.623 438.531 147.623C422.07 147.623 408.628 131.747 408.434 111.975C408.434 111.78 408.434 111.682 408.434 111.488C408.434 111.39 408.434 111.195 408.434 111C408.628 91.3255 422.07 75.4492 438.531 75.4492C439.407 75.4492 440.381 75.4492 441.258 75.5466H441.355C448.368 76.3258 453.53 82.2673 453.53 89.2801V93.4684H459.569V85.7737ZM459.569 111.682C459.569 111.585 459.569 111.585 459.569 111.488V111.39C459.472 103.208 452.848 96.5852 444.667 96.4878C436.29 96.3904 429.472 103.208 429.472 111.488C429.472 119.864 436.29 126.585 444.667 126.585C452.848 126.487 459.472 119.767 459.569 111.682Z"
              fill="#030319"
            />
            <path
              d="M365.433 96.4878C357.056 96.4878 350.336 103.208 350.336 111.488C350.336 119.864 357.056 126.585 365.433 126.585C371.569 126.585 376.926 122.883 379.166 117.526H400.984C398.159 134.571 383.257 147.623 365.433 147.623C345.465 147.623 329.297 131.455 329.297 111.488C329.297 91.6177 345.465 75.4492 365.433 75.4492C383.257 75.4492 398.159 88.4035 400.984 105.546H379.166C376.926 100.189 371.569 96.4878 365.433 96.4878Z"
              fill="#030319"
            />
            <path
              d="M281.603 66.6326C266.839 66.6326 260.844 71.4881 260.844 77.8003C260.844 89.745 321.687 81.7819 321.687 115.479C321.687 120.335 315.245 147.623 278.739 147.623C254.492 147.623 244.023 133.833 239.37 127.715L238.744 126.938L254.724 115.283C254.724 115.283 262.365 126.647 278.739 126.647C293.592 126.647 299.587 121.792 299.587 115.479C299.587 103.243 238.744 111.692 238.744 77.8003C238.744 72.9448 245.186 45.6566 281.603 45.6566C305.94 45.6566 316.408 59.4464 321.061 65.5644L321.687 66.3412L305.707 77.6162C305.707 77.6162 298.066 66.6326 281.603 66.6326Z"
              fill="#030319"
            />
            <ellipse
              cx="97.8957"
              cy="97.8954"
              rx="97.8957"
              ry="97.8954"
              fill="url(#svg-1137231340_6119_paint0_linear_1843_2573)"
            />
            <path
              d="M103.576 14.4118C115.249 13.8539 129.142 17.6986 139.282 23.2509C158.722 33.8511 173.055 51.8528 179.03 73.1714C184.904 94.1022 182.275 116.505 171.709 135.505C161.278 154.663 143.583 168.825 122.604 174.805C121.916 175 121.535 175.131 120.923 174.79C120.848 174.232 123.053 171.981 123.588 171.354C127.648 166.588 129.697 162.178 131.673 156.382C133.304 155.423 134.869 154.356 136.358 153.19C151.792 141.054 161.837 123.339 164.329 103.867C166.932 83.664 161.768 65.3031 149.385 49.2548C145.6 44.5826 141.241 40.4056 136.412 36.8219C127.789 30.443 117.883 26.3644 107.081 25.9036C100.34 25.6159 94.1717 26.5885 89.9416 32.5503C88.1358 35.1174 87.0577 38.1249 86.8214 41.2544C85.8581 52.6598 94.7935 61.1826 102.438 68.3351C106.731 72.3277 111.304 76.1609 115.634 80.1021C126.117 89.6427 137.49 100.106 139.627 114.873C140.71 122.355 139.833 129.826 137.214 136.929C136.785 138.093 136.144 140.229 135.444 141.211L135.214 141.233C134.907 140.566 134.342 137.129 134.064 136.042C133.36 133.295 132.371 130.526 131.084 127.972C123.12 112.161 107.759 101.092 95.0915 89.0304C83.0497 77.5651 70.841 66.3252 69.8719 48.4363C69.4109 39.9256 72.4487 31.2566 78.2811 25.0667C85.079 17.8519 93.8037 14.7104 103.576 14.4118Z"
              fill="white"
            />
            <path
              d="M91.5742 180.82C79.901 181.378 66.0082 177.534 55.8688 171.981C36.4285 161.381 22.0955 143.379 16.1206 122.061C10.246 101.13 12.8756 78.7274 23.4413 59.7273C33.8727 40.5694 51.5673 26.4075 72.5462 20.4273C73.234 20.2325 73.6158 20.1012 74.2273 20.442C74.3028 20.9998 72.097 23.2514 71.5628 23.8785C67.5026 28.6444 65.4533 33.0547 63.4777 38.8504C61.8468 39.8095 60.2815 40.8763 58.7919 42.042C43.3582 54.178 33.3134 71.8929 30.8211 91.3651C28.218 111.568 33.3828 129.929 45.765 145.977C49.5501 150.65 53.9092 154.827 58.7385 158.41C67.3615 164.789 77.2674 168.868 88.0694 169.329C94.8106 169.616 100.979 168.644 105.209 162.682C107.015 160.115 108.093 157.107 108.329 153.978C109.292 142.572 100.357 134.05 92.7125 126.897C88.4197 122.904 83.8462 119.071 79.5159 115.13C69.0339 105.589 57.6601 95.1262 55.5235 80.3593C54.4404 72.877 55.3169 65.4066 57.9365 58.3035C58.3658 57.1393 59.0062 55.0028 59.7064 54.0216L59.9363 53.9994C60.2437 54.6664 60.8081 58.1028 61.0866 59.1903C61.7902 61.9377 62.7798 64.7057 64.0662 67.2598C72.0303 83.0713 87.391 94.1406 100.059 106.202C112.101 117.667 124.309 128.907 125.278 146.796C125.739 155.307 122.702 163.976 116.869 170.165C110.071 177.38 101.347 180.522 91.5742 180.82Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="svg-1137231340_6119_paint0_linear_1843_2573"
                x1="97.8957"
                y1="0"
                x2="46.0375"
                y2="179.202"
                gradientUnits="userSpaceOnUse"
              >
                <stop stopColor="#0F1AF1" />
                <stop offset="1" stopColor="#2E38F9" />
              </linearGradient>
            </defs>
          </svg>
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            id="svg-1839680863_948"
          >
            <path
              d="M9.90033 7.61699C10.967 7.66699 11.242 8.57533 11.2587 9.00033H12.7503C12.6837 7.35033 11.5087 6.34199 9.87533 6.34199C8.03366 6.34199 6.66699 7.50033 6.66699 10.117C6.66699 11.7337 7.44199 13.6503 9.86699 13.6503C11.717 13.6503 12.7087 12.2753 12.7337 11.192H11.242C11.217 11.6837 10.867 12.342 9.88366 12.392C8.79199 12.3587 8.33366 11.5087 8.33366 10.117C8.33366 7.70866 9.40033 7.63366 9.90033 7.61699ZM10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32533 16.667 3.33366 13.6753 3.33366 10.0003C3.33366 6.32533 6.32533 3.33366 10.0003 3.33366C13.6753 3.33366 16.667 6.32533 16.667 10.0003C16.667 13.6753 13.6753 16.667 10.0003 16.667Z"
              fill="#666D80"
            />
          </svg>
        </>
      </div>
      <>
        {/*$*/}
        <div
          data-framer-root=""
          className="framer-qTAO4 framer-rcOGl framer-1epkjq8 scalloppay-s1"
        >
          <div
            className="framer-hb7vxb-container hidden-xsaq5o scalloppay-s2"
            data-framer-appear-id="hb7vxb"
            id="hb7vxb"
          >
            <div className="ssr-variant hidden-c4t5yq">
              <div
                className="framer-8MFL4 framer-15zawlh framer-v-15zawlh scalloppay-s3"
                data-framer-name="Desktop [Default Boxed]"
              >
                <header
                  className="framer-ooxjtq scalloppay-s4"
                  data-border="true"
                  data-framer-name="Main Area"
                >
                  <div
                    className="framer-p578i7 scalloppay-s5"
                    data-framer-name="Background [Default]"
                  />
                  <div
                    className="framer-pc27k4 scalloppay-s6"
                    data-framer-name="Background [Boxed Mini]"
                  />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1hjthz scalloppay-s7"
                        aria-hidden="true"
                      />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav">
                      <div
                        className="framer-1hg3ikx-container"
                        data-framer-name="Menu [Desktop]"
                        name="Menu [Desktop]"
                      >
                        <div
                          name="Menu [Desktop]"
                          className="framer-n0D3w framer-1itjusz framer-v-1itjusz scalloppay-s8"
                          data-framer-name="Menu"
                        >
                          {/*$*/}
                          <div className="framer-mquu2a-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq scalloppay-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/accounts"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi scalloppay-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s11"
                                >
                                  Accounts{' '}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1yixouk-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq scalloppay-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/scallop-pay"
                              data-framer-page-link-current="true"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi scalloppay-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s11"
                                >
                                  Scallop Pay
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-wi7xty-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq scalloppay-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/cards"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi scalloppay-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s11"
                                >
                                  Cards
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1tpzm7c-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq scalloppay-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/scallop-plus"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi scalloppay-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s11"
                                >
                                  Scallop+
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-u2qi4r-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq scalloppay-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/helpcenter"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi scalloppay-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s11"
                                >
                                  FAQs
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                    </nav>
                    <div
                      className="framer-14uxsxw"
                      data-framer-name="Menu Icon"
                    >
                      <div
                        className="framer-16051d2"
                        data-framer-name="QR Overlay Trigger"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div className="framer-168591e-container">
                          <div
                            className="framer-wWHmH framer-ly6l8a framer-v-18roq29 scalloppay-s12"
                            data-border="true"
                            data-framer-name="Variant 2"
                            data-highlight="true"
                            tabIndex={0}
                          >
                            <div
                              className="framer-1ebu3nm scalloppay-s13 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text scalloppay-s14"
                              >
                                Get Started
                              </p>
                            </div>
                            <div
                              className="framer-1u4w7ze scalloppay-s15 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text scalloppay-s16">
                                Coming soon
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
            <div className="ssr-variant hidden-1epkjq8 hidden-xsaq5o">
              <div
                className="framer-8MFL4 framer-15zawlh framer-v-15viyb0 scalloppay-s3"
                data-framer-name="Desktop [Boxed Mini]"
              >
                <header
                  className="framer-ooxjtq scalloppay-s17"
                  data-border="true"
                  data-framer-name="Main Area"
                >
                  <div
                    className="framer-p578i7 scalloppay-s6"
                    data-framer-name="Background [Default]"
                  />
                  <div
                    className="framer-pc27k4 scalloppay-s5"
                    data-framer-name="Background [Boxed Mini]"
                  />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1hjthz scalloppay-s7"
                        aria-hidden="true"
                      />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav">
                      <div
                        className="framer-1hg3ikx-container"
                        data-framer-name="Menu [Desktop]"
                        name="Menu [Desktop]"
                      >
                        <div
                          name="Menu [Desktop]"
                          className="framer-n0D3w framer-1itjusz framer-v-1itjusz scalloppay-s8"
                          data-framer-name="Menu"
                        >
                          {/*$*/}
                          <div className="framer-mquu2a-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq scalloppay-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/accounts"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi scalloppay-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s11"
                                >
                                  Accounts{' '}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1yixouk-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq scalloppay-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/scallop-pay"
                              data-framer-page-link-current="true"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi scalloppay-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s11"
                                >
                                  Scallop Pay
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-wi7xty-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq scalloppay-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/cards"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi scalloppay-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s11"
                                >
                                  Cards
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1tpzm7c-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq scalloppay-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/scallop-plus"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi scalloppay-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s11"
                                >
                                  Scallop+
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-u2qi4r-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq scalloppay-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/helpcenter"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi scalloppay-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s11"
                                >
                                  FAQs
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                    </nav>
                    <div
                      className="framer-14uxsxw"
                      data-framer-name="Menu Icon"
                    >
                      <div
                        className="framer-16051d2"
                        data-framer-name="QR Overlay Trigger"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div className="framer-168591e-container">
                          <div
                            className="framer-wWHmH framer-ly6l8a framer-v-18roq29 scalloppay-s12"
                            data-border="true"
                            data-framer-name="Variant 2"
                            data-highlight="true"
                            tabIndex={0}
                          >
                            <div
                              className="framer-1ebu3nm scalloppay-s13 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text scalloppay-s14"
                              >
                                Get Started
                              </p>
                            </div>
                            <div
                              className="framer-1u4w7ze scalloppay-s15 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text scalloppay-s16">
                                Coming soon
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="ssr-variant hidden-xsaq5o">
            <div
              className="framer-19x0qu0-container hidden-1epkjq8 hidden-c4t5yq scalloppay-s2"
              data-framer-appear-id="19x0qu0"
            >
              <div
                className="framer-8MFL4 framer-15zawlh framer-v-15zawlh scalloppay-s3"
                data-framer-name="Desktop [Default Boxed]"
              >
                <header
                  className="framer-ooxjtq scalloppay-s4"
                  data-border="true"
                  data-framer-name="Main Area"
                >
                  <div
                    className="framer-p578i7 scalloppay-s5"
                    data-framer-name="Background [Default]"
                  />
                  <div
                    className="framer-pc27k4 scalloppay-s6"
                    data-framer-name="Background [Boxed Mini]"
                  />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1hjthz scalloppay-s7"
                        aria-hidden="true"
                      />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav">
                      <div
                        className="framer-1hg3ikx-container"
                        data-framer-name="Menu [Desktop]"
                        name="Menu [Desktop]"
                      >
                        <div
                          name="Menu [Desktop]"
                          className="framer-n0D3w framer-1itjusz framer-v-1itjusz scalloppay-s8"
                          data-framer-name="Menu"
                        >
                          {/*$*/}
                          <div className="framer-mquu2a-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq scalloppay-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/accounts"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi scalloppay-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s11"
                                >
                                  Accounts{' '}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1yixouk-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq scalloppay-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/scallop-pay"
                              data-framer-page-link-current="true"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi scalloppay-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s11"
                                >
                                  Scallop Pay
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-wi7xty-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq scalloppay-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/cards"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi scalloppay-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s11"
                                >
                                  Cards
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1tpzm7c-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq scalloppay-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/scallop-plus"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi scalloppay-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s11"
                                >
                                  Scallop+
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-u2qi4r-container">
                            {/*$*/}
                            <a
                              className="framer-2DxPx framer-9un4ss framer-v-9un4ss framer-1tncwgq scalloppay-s9"
                              data-framer-name="Menu Item Simple"
                              data-highlight="true"
                              href="/helpcenter"
                              tabIndex={0}
                            >
                              <div
                                className="framer-19g30xi scalloppay-s10 reveal"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s11"
                                >
                                  FAQs
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                    </nav>
                    <div
                      className="framer-14uxsxw"
                      data-framer-name="Menu Icon"
                    >
                      <div
                        className="framer-16051d2"
                        data-framer-name="QR Overlay Trigger"
                        data-highlight="true"
                        tabIndex={0}
                      >
                        <div className="framer-168591e-container">
                          <div
                            className="framer-wWHmH framer-ly6l8a framer-v-18roq29 scalloppay-s12"
                            data-border="true"
                            data-framer-name="Variant 2"
                            data-highlight="true"
                            tabIndex={0}
                          >
                            <div
                              className="framer-1ebu3nm scalloppay-s13 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text scalloppay-s14"
                              >
                                Get Started
                              </p>
                            </div>
                            <div
                              className="framer-1u4w7ze scalloppay-s15 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p className="framer-text scalloppay-s16">
                                Coming soon
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
            <div
              className="framer-19x0qu0-container hidden-1epkjq8 hidden-c4t5yq"
              data-framer-appear-id="19x0qu0"
            >
              <div
                className="framer-8MFL4 framer-15zawlh framer-v-ewbo4l scalloppay-s3"
                data-framer-name="Mobile"
              >
                <header
                  className="framer-ooxjtq scalloppay-s18"
                  data-border="true"
                  data-framer-name="Main Area"
                >
                  <div
                    className="framer-p578i7 scalloppay-s5"
                    data-framer-name="Background [Default]"
                  />
                  <div
                    className="framer-pc27k4 scalloppay-s6"
                    data-framer-name="Background [Boxed Mini]"
                  />
                  <div className="framer-cjwofg" data-framer-name="Content">
                    {/*$*/}
                    <a className="framer-1jy87r1 framer-145ct8v" href="/">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1hjthz scalloppay-s7"
                        aria-hidden="true"
                      />
                    </a>
                    {/*/$*/}
                    <nav className="framer-xe9vp0" data-framer-name="Nav" />
                    <div
                      className="framer-14uxsxw"
                      data-framer-name="Menu Icon"
                    >
                      <div className="framer-1yr51k6-container">
                        {/*$*/}
                        <div
                          className="framer-OuhX3 framer-1ib4qbi framer-v-1ib4qbi scalloppay-s19"
                          data-framer-name="Mobile Menu"
                          data-highlight="true"
                          tabIndex={0}
                        >
                          <div className="framer-1cux5of scalloppay-s20" />
                          <div className="framer-1w1bul6 scalloppay-s20" />
                          <div className="framer-1ku2ucf scalloppay-s21" />
                        </div>
                        {/*/$*/}
                      </div>
                    </div>
                  </div>
                </header>
              </div>
            </div>
          </div>
          <div className="framer-1xxuho6" data-framer-name="Main Container">
            <section
              className="framer-181l9sa"
              data-framer-name="Hero"
              id="use-cases"
            >
              <div className="framer-rwx3bq">
                <div className="framer-pr4nyd-container">
                  {/*$*/}
                  <video
                    src="/framerusercontent.com/assets/o1pGXyTiJ9NTFXBpr8PQw4N3f6k.mp4"
                    loop
                    preload="auto"
                    muted
                    playsInline
                    autoPlay
                    className="scalloppay-s22"
                  />
                  {/*/$*/}
                </div>
                <div className="framer-9jfmb2" />
              </div>
              <div className="framer-1rs4kfx" data-framer-name="Container">
                <div className="ssr-variant hidden-c4t5yq hidden-xsaq5o">
                  <div
                    className="framer-5gvkd2 scalloppay-s23 reveal"
                    data-framer-appear-id="5gvkd2"
                    data-framer-name="One account. One balance. Built for global money."
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s24">
                      Pay like a local. Anywhere.
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1epkjq8 hidden-xsaq5o">
                  <div
                    className="framer-5gvkd2 scalloppay-s23 reveal"
                    data-framer-appear-id="5gvkd2"
                    data-framer-name="One account. One balance. Built for global money."
                    data-framer-component-type="RichTextContainer"
                  >
                    <h1
                      className="framer-text framer-styles-preset-18sajzf scalloppay-s25"
                      data-styles-preset="nXmNeSqma"
                      dir="auto"
                    >
                      <span className="framer-text scalloppay-s26">
                        Pay like a local.
                      </span>{' '}
                      <span className="framer-text scalloppay-s26">
                        Anywhere.
                      </span>
                    </h1>
                  </div>
                </div>
                <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
                  <div
                    className="framer-5gvkd2 scalloppay-s23 reveal"
                    data-framer-appear-id="5gvkd2"
                    data-framer-name="One account. One balance. Built for global money."
                    data-framer-component-type="RichTextContainer"
                  >
                    <h1
                      className="framer-text framer-styles-preset-18sajzf scalloppay-s27"
                      data-styles-preset="nXmNeSqma"
                      dir="auto"
                    >
                      Pay like a local. Anywhere.
                    </h1>
                  </div>
                </div>
                <div
                  className="framer-v994r hidden-1epkjq8 hidden-c4t5yq scalloppay-s23 reveal"
                  data-framer-name="One account. One balance. Built for global money."
                  data-framer-component-type="RichTextContainer"
                >
                  <h1 dir="auto" className="framer-text scalloppay-s28">
                    No local bank account. No local wallet. No currency
                    switching.
                  </h1>
                </div>
                <div
                  className="framer-1n761hm hidden-1epkjq8 hidden-c4t5yq scalloppay-s23 reveal"
                  data-framer-name="One account. One balance. Built for global money."
                  data-framer-component-type="RichTextContainer"
                >
                  <h1 dir="auto" className="framer-text scalloppay-s28">
                    Scan QR codes and pay through local payment networks using
                    your existing balance.
                  </h1>
                </div>
                <div
                  className="framer-15k30jx hidden-1epkjq8 hidden-xsaq5o scalloppay-s23 reveal"
                  data-framer-name="One account. One balance. Built for global money."
                  data-framer-component-type="RichTextContainer"
                >
                  <h1 dir="auto" className="framer-text scalloppay-s28">
                    Scan QR codes and pay through local payment networks using
                    your existing balance.
                  </h1>
                </div>
                <div
                  className="framer-13e3gj2 hidden-1epkjq8 hidden-xsaq5o scalloppay-s23 reveal"
                  data-framer-name="One account. One balance. Built for global money."
                  data-framer-component-type="RichTextContainer"
                >
                  <h1 dir="auto" className="framer-text scalloppay-s28">
                    No local bank account. No local wallet. No currency
                    switching.
                  </h1>
                </div>
                <div className="framer-fhttpr hidden-c4t5yq hidden-xsaq5o">
                  <div
                    className="framer-1d1ream scalloppay-s23 reveal"
                    data-framer-appear-id="1d1ream"
                    data-framer-name="52+ fiat currencies and digital assets. One unifie"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s29">
                      Scan QR codes and pay through local payment networks using
                      your existing balance.
                    </p>
                  </div>
                  <div
                    className="framer-1u3zbpp scalloppay-s23 reveal"
                    data-framer-appear-id="1u3zbpp"
                    data-framer-name="52+ fiat currencies and digital assets. One unifie"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s29">
                      No local bank account. No local wallet. No currency
                      switching.
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-xsaq5o">
                  {/*$*/}
                  <a
                    className="framer-1gpy6tm framer-ma5p3b"
                    data-framer-name="ButtonForComingSoon"
                    id="1gpy6tm"
                    href="https://onelink.to/wch597"
                    target="_blank"
                    rel="noopener"
                    tabIndex={0}
                  >
                    <div className="ssr-variant hidden-c4t5yq">
                      <div
                        className="framer-1s5vh8y scalloppay-s30 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s31">
                          Download Now
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1epkjq8">
                      <div
                        className="framer-1s5vh8y scalloppay-s30 reveal"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s31">
                          Install App
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-1n6rujd scalloppay-s32 reveal"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p className="framer-text scalloppay-s33">Coming soon</p>
                    </div>
                  </a>
                  {/*/$*/}
                </div>
                <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
                  {/*$*/}
                  <a
                    className="framer-1gpy6tm framer-ma5p3b"
                    data-framer-name="ButtonForComingSoon"
                    id="1gpy6tm"
                    href="https://onelink.to/wch597"
                    target="_blank"
                    rel="noopener"
                    tabIndex={0}
                  >
                    <div
                      className="framer-1s5vh8y scalloppay-s30 reveal"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s31">
                        Install App
                      </p>
                    </div>
                    <div
                      className="framer-1n6rujd scalloppay-s32 reveal"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p className="framer-text scalloppay-s33">Coming soon</p>
                    </div>
                  </a>
                  {/*/$*/}
                </div>
              </div>
            </section>
            <div className="framer-y3enus" data-framer-name="Country">
              <div
                className="framer-176az8k"
                data-framer-name="Frame 1707480001"
              >
                <div
                  className="framer-13un7i5"
                  data-framer-appear-id="13un7i5"
                  data-framer-name="Frame 1707480002"
                >
                  <div
                    className="framer-n4rsze"
                    data-framer-name="Ellipse 742"
                  />
                  <div
                    className="framer-1himep5"
                    data-framer-name="flags/vietnam"
                  >
                    <div className="ssr-variant">
                      <div
                        className="framer-licxm6"
                        data-framer-name="flags/vietnam"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            width="512"
                            height="512"
                            src="/framerusercontent.com/images/LwSUGTXf4l91lpJ5UHKM9WRCiw.png"
                            alt=""
                            className="scalloppay-s35"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-1o68rh9"
                  data-framer-appear-id="1o68rh9"
                  data-framer-name="Frame 1707480005"
                >
                  <div
                    className="framer-11j7sok"
                    data-framer-name="Ellipse 742"
                  />
                  <div
                    className="framer-1qh57nv"
                    data-framer-name="flags/brazil"
                  >
                    <div className="ssr-variant">
                      <div
                        className="framer-yrsn8e"
                        data-framer-name="flags/brazil"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            width="512"
                            height="512"
                            src="/framerusercontent.com/images/sQ7NpnnT7SaDAD07ZZJF2EjGbA0.png"
                            alt=""
                            className="scalloppay-s35"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-y8wg6l"
                  data-framer-appear-id="y8wg6l"
                  data-framer-name="Frame 1707480004"
                >
                  <div
                    className="framer-1ch4y79"
                    data-framer-name="Ellipse 742"
                  />
                  <div
                    className="framer-b8xhg3"
                    data-framer-name="flags/argentina"
                  >
                    <div className="ssr-variant">
                      <div
                        className="framer-1ougw8j"
                        data-framer-name="flags/argentina"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            width="512"
                            height="512"
                            src="/framerusercontent.com/images/ZbQp8u3oR6pZUn5YlxpNQmAWgg.png"
                            alt=""
                            className="scalloppay-s35"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-1w98j3o"
                  data-framer-appear-id="1w98j3o"
                  data-framer-name="Frame 1707480003"
                >
                  <div
                    className="framer-i0t8e7"
                    data-framer-name="Ellipse 742"
                  />
                  <div className="framer-fdykr4" data-framer-name="flags/peru">
                    <div className="ssr-variant">
                      <div
                        className="framer-7paa9i"
                        data-framer-name="flags/peru"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            width="512"
                            height="512"
                            src="/framerusercontent.com/images/udjtzxNieluWi38AMBWlcLFlFPQ.png"
                            alt=""
                            className="scalloppay-s35"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-1uveoe0"
                  data-framer-appear-id="1uveoe0"
                  data-framer-name="Frame 1707480006"
                >
                  <div
                    className="framer-kugp5d"
                    data-framer-name="Ellipse 742"
                  />
                  <div
                    className="framer-1d9eszd"
                    data-framer-name="flags/philippines"
                  >
                    <div className="ssr-variant">
                      <div
                        className="framer-1hlwo8d"
                        data-framer-name="flags/philippines"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            width="512"
                            height="512"
                            src="/framerusercontent.com/images/kx8QshKQNGhlmJExsdQQasW4us.png"
                            alt=""
                            className="scalloppay-s35"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-5yun41" data-framer-name="Partners">
              <div className="ssr-variant hidden-xsaq5o">
                <div
                  className="framer-134xhg5 reveal"
                  data-framer-name="Title"
                  data-framer-component-type="RichTextContainer"
                >
                  <p dir="auto" className="framer-text scalloppay-s36">
                    A world of QR codes at your fingertips
                  </p>
                </div>
              </div>
              <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
                <div
                  className="framer-134xhg5 reveal"
                  data-framer-name="Title"
                  data-framer-component-type="RichTextContainer"
                >
                  <p dir="auto" className="framer-text scalloppay-s37">
                    A world of QR codes at your
                  </p>
                  <p dir="auto" className="framer-text scalloppay-s37">
                    fingertips
                  </p>
                </div>
              </div>
              <div className="framer-up2zfz-container">
                {/*$*/}
                <div className="ssr-variant hidden-xsaq5o">
                  <section className="scalloppay-s38">
                    <div className="scalloppay-marquee-track">
                    <ul className="scalloppay-s39">
                      <li>
                        <div
                          className="framer-ob6frn scalloppay-s40"
                          data-framer-name="image 1624"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="1280"
                              height="454"
                              sizes="(min-width: 1440px) 90px, (min-width: 810px) and (max-width: 1439.98px) 90px, (max-width: 809.98px) 90px"
                              srcSet="/framerusercontent.com/images/BP5VRH2UB8hdQAHStd95eTVEEcg.png 512w,/framerusercontent.com/images/BP5VRH2UB8hdQAHStd95eTVEEcg.png 1024w,/framerusercontent.com/images/BP5VRH2UB8hdQAHStd95eTVEEcg.png 1280w"
                              src="/framerusercontent.com/images/BP5VRH2UB8hdQAHStd95eTVEEcg.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-13rokkk scalloppay-s40"
                          data-framer-name="image 1625"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="960"
                              height="228"
                              sizes="(min-width: 1440px) 135px, (min-width: 810px) and (max-width: 1439.98px) 135px, (max-width: 809.98px) 135px"
                              srcSet="/framerusercontent.com/images/ULfwyKtyyvxYsdJgXQ07oZqtt7g.png 512w,/framerusercontent.com/images/ULfwyKtyyvxYsdJgXQ07oZqtt7g.png 960w"
                              src="/framerusercontent.com/images/ULfwyKtyyvxYsdJgXQ07oZqtt7g.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-wx8urd scalloppay-s40"
                          data-framer-name="image 1558"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="152"
                              height="152"
                              src="/framerusercontent.com/images/M8YebjT0u5beWKCLM528hAf5w.png"
                              alt=""
                              className="scalloppay-s41"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-65zjmq scalloppay-s40"
                          data-framer-name="image 1651"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="3840"
                              height="913"
                              sizes="(min-width: 1440px) 138px, (min-width: 810px) and (max-width: 1439.98px) 138px, (max-width: 809.98px) 138px"
                              srcSet="/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png 512w,/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png 1024w,/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png 2048w,/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png 3840w"
                              src="/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-1ge2gy scalloppay-s40"
                          data-framer-name="png-transparent-viator-logo-review-platforms-logos 1"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="920"
                              height="232"
                              sizes="(min-width: 1440px) 127px, (min-width: 810px) and (max-width: 1439.98px) 127px, (max-width: 809.98px) 127px"
                              srcSet="/framerusercontent.com/images/zj6ffjlj21WDYnAcCvWVKSrbQEU.png 512w,/framerusercontent.com/images/zj6ffjlj21WDYnAcCvWVKSrbQEU.png 920w"
                              src="/framerusercontent.com/images/zj6ffjlj21WDYnAcCvWVKSrbQEU.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-fvxcfs scalloppay-s40"
                          data-framer-name="image 1650"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="268"
                              height="140"
                              src="/framerusercontent.com/images/xNvHINYN3b9PXJeMGbeSXzj1qPU.png"
                              alt=""
                              className="scalloppay-s41"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-18cgp21 scalloppay-s40"
                          data-framer-name="image 1652"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="426"
                              height="131"
                              src="/framerusercontent.com/images/WmuyawsW6HfOf9s9c419PMM1v6c.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                    <ul className="scalloppay-s39" aria-hidden="true">
                      <li>
                        <div
                          className="framer-ob6frn scalloppay-s40"
                          data-framer-name="image 1624"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="1280"
                              height="454"
                              sizes="(min-width: 1440px) 90px, (min-width: 810px) and (max-width: 1439.98px) 90px, (max-width: 809.98px) 90px"
                              srcSet="/framerusercontent.com/images/BP5VRH2UB8hdQAHStd95eTVEEcg.png 512w,/framerusercontent.com/images/BP5VRH2UB8hdQAHStd95eTVEEcg.png 1024w,/framerusercontent.com/images/BP5VRH2UB8hdQAHStd95eTVEEcg.png 1280w"
                              src="/framerusercontent.com/images/BP5VRH2UB8hdQAHStd95eTVEEcg.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-13rokkk scalloppay-s40"
                          data-framer-name="image 1625"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="960"
                              height="228"
                              sizes="(min-width: 1440px) 135px, (min-width: 810px) and (max-width: 1439.98px) 135px, (max-width: 809.98px) 135px"
                              srcSet="/framerusercontent.com/images/ULfwyKtyyvxYsdJgXQ07oZqtt7g.png 512w,/framerusercontent.com/images/ULfwyKtyyvxYsdJgXQ07oZqtt7g.png 960w"
                              src="/framerusercontent.com/images/ULfwyKtyyvxYsdJgXQ07oZqtt7g.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-wx8urd scalloppay-s40"
                          data-framer-name="image 1558"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="152"
                              height="152"
                              src="/framerusercontent.com/images/M8YebjT0u5beWKCLM528hAf5w.png"
                              alt=""
                              className="scalloppay-s41"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-65zjmq scalloppay-s40"
                          data-framer-name="image 1651"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="3840"
                              height="913"
                              sizes="(min-width: 1440px) 138px, (min-width: 810px) and (max-width: 1439.98px) 138px, (max-width: 809.98px) 138px"
                              srcSet="/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png 512w,/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png 1024w,/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png 2048w,/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png 3840w"
                              src="/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-1ge2gy scalloppay-s40"
                          data-framer-name="png-transparent-viator-logo-review-platforms-logos 1"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="920"
                              height="232"
                              sizes="(min-width: 1440px) 127px, (min-width: 810px) and (max-width: 1439.98px) 127px, (max-width: 809.98px) 127px"
                              srcSet="/framerusercontent.com/images/zj6ffjlj21WDYnAcCvWVKSrbQEU.png 512w,/framerusercontent.com/images/zj6ffjlj21WDYnAcCvWVKSrbQEU.png 920w"
                              src="/framerusercontent.com/images/zj6ffjlj21WDYnAcCvWVKSrbQEU.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-fvxcfs scalloppay-s40"
                          data-framer-name="image 1650"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="268"
                              height="140"
                              src="/framerusercontent.com/images/xNvHINYN3b9PXJeMGbeSXzj1qPU.png"
                              alt=""
                              className="scalloppay-s41"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-18cgp21 scalloppay-s40"
                          data-framer-name="image 1652"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="426"
                              height="131"
                              src="/framerusercontent.com/images/WmuyawsW6HfOf9s9c419PMM1v6c.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                    </div>
                  </section>
                </div>
                <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
                  <section className="scalloppay-s38">
                    <div className="scalloppay-marquee-track">
                    <ul className="scalloppay-s42">
                      <li>
                        <div
                          className="framer-ob6frn scalloppay-s40"
                          data-framer-name="image 1624"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="1280"
                              height="454"
                              sizes="(min-width: 1440px) 90px, (min-width: 810px) and (max-width: 1439.98px) 90px, (max-width: 809.98px) 90px"
                              srcSet="/framerusercontent.com/images/BP5VRH2UB8hdQAHStd95eTVEEcg.png 512w,/framerusercontent.com/images/BP5VRH2UB8hdQAHStd95eTVEEcg.png 1024w,/framerusercontent.com/images/BP5VRH2UB8hdQAHStd95eTVEEcg.png 1280w"
                              src="/framerusercontent.com/images/BP5VRH2UB8hdQAHStd95eTVEEcg.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-13rokkk scalloppay-s40"
                          data-framer-name="image 1625"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="960"
                              height="228"
                              sizes="(min-width: 1440px) 135px, (min-width: 810px) and (max-width: 1439.98px) 135px, (max-width: 809.98px) 135px"
                              srcSet="/framerusercontent.com/images/ULfwyKtyyvxYsdJgXQ07oZqtt7g.png 512w,/framerusercontent.com/images/ULfwyKtyyvxYsdJgXQ07oZqtt7g.png 960w"
                              src="/framerusercontent.com/images/ULfwyKtyyvxYsdJgXQ07oZqtt7g.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-wx8urd scalloppay-s40"
                          data-framer-name="image 1558"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="152"
                              height="152"
                              src="/framerusercontent.com/images/M8YebjT0u5beWKCLM528hAf5w.png"
                              alt=""
                              className="scalloppay-s41"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-65zjmq scalloppay-s40"
                          data-framer-name="image 1651"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="3840"
                              height="913"
                              sizes="(min-width: 1440px) 138px, (min-width: 810px) and (max-width: 1439.98px) 138px, (max-width: 809.98px) 138px"
                              srcSet="/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png 512w,/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png 1024w,/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png 2048w,/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png 3840w"
                              src="/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-1ge2gy scalloppay-s40"
                          data-framer-name="png-transparent-viator-logo-review-platforms-logos 1"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="920"
                              height="232"
                              sizes="(min-width: 1440px) 127px, (min-width: 810px) and (max-width: 1439.98px) 127px, (max-width: 809.98px) 127px"
                              srcSet="/framerusercontent.com/images/zj6ffjlj21WDYnAcCvWVKSrbQEU.png 512w,/framerusercontent.com/images/zj6ffjlj21WDYnAcCvWVKSrbQEU.png 920w"
                              src="/framerusercontent.com/images/zj6ffjlj21WDYnAcCvWVKSrbQEU.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-fvxcfs scalloppay-s40"
                          data-framer-name="image 1650"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="268"
                              height="140"
                              src="/framerusercontent.com/images/xNvHINYN3b9PXJeMGbeSXzj1qPU.png"
                              alt=""
                              className="scalloppay-s41"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-18cgp21 scalloppay-s40"
                          data-framer-name="image 1652"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="426"
                              height="131"
                              src="/framerusercontent.com/images/WmuyawsW6HfOf9s9c419PMM1v6c.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                    <ul className="scalloppay-s42" aria-hidden="true">
                      <li>
                        <div
                          className="framer-ob6frn scalloppay-s40"
                          data-framer-name="image 1624"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="1280"
                              height="454"
                              sizes="(min-width: 1440px) 90px, (min-width: 810px) and (max-width: 1439.98px) 90px, (max-width: 809.98px) 90px"
                              srcSet="/framerusercontent.com/images/BP5VRH2UB8hdQAHStd95eTVEEcg.png 512w,/framerusercontent.com/images/BP5VRH2UB8hdQAHStd95eTVEEcg.png 1024w,/framerusercontent.com/images/BP5VRH2UB8hdQAHStd95eTVEEcg.png 1280w"
                              src="/framerusercontent.com/images/BP5VRH2UB8hdQAHStd95eTVEEcg.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-13rokkk scalloppay-s40"
                          data-framer-name="image 1625"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="960"
                              height="228"
                              sizes="(min-width: 1440px) 135px, (min-width: 810px) and (max-width: 1439.98px) 135px, (max-width: 809.98px) 135px"
                              srcSet="/framerusercontent.com/images/ULfwyKtyyvxYsdJgXQ07oZqtt7g.png 512w,/framerusercontent.com/images/ULfwyKtyyvxYsdJgXQ07oZqtt7g.png 960w"
                              src="/framerusercontent.com/images/ULfwyKtyyvxYsdJgXQ07oZqtt7g.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-wx8urd scalloppay-s40"
                          data-framer-name="image 1558"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="152"
                              height="152"
                              src="/framerusercontent.com/images/M8YebjT0u5beWKCLM528hAf5w.png"
                              alt=""
                              className="scalloppay-s41"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-65zjmq scalloppay-s40"
                          data-framer-name="image 1651"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="3840"
                              height="913"
                              sizes="(min-width: 1440px) 138px, (min-width: 810px) and (max-width: 1439.98px) 138px, (max-width: 809.98px) 138px"
                              srcSet="/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png 512w,/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png 1024w,/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png 2048w,/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png 3840w"
                              src="/framerusercontent.com/images/ktw1fWIgekcSlZ5dyh2chbTfB0.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-1ge2gy scalloppay-s40"
                          data-framer-name="png-transparent-viator-logo-review-platforms-logos 1"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="920"
                              height="232"
                              sizes="(min-width: 1440px) 127px, (min-width: 810px) and (max-width: 1439.98px) 127px, (max-width: 809.98px) 127px"
                              srcSet="/framerusercontent.com/images/zj6ffjlj21WDYnAcCvWVKSrbQEU.png 512w,/framerusercontent.com/images/zj6ffjlj21WDYnAcCvWVKSrbQEU.png 920w"
                              src="/framerusercontent.com/images/zj6ffjlj21WDYnAcCvWVKSrbQEU.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-fvxcfs scalloppay-s40"
                          data-framer-name="image 1650"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="268"
                              height="140"
                              src="/framerusercontent.com/images/xNvHINYN3b9PXJeMGbeSXzj1qPU.png"
                              alt=""
                              className="scalloppay-s41"
                            />
                          </div>
                        </div>
                      </li>
                      <li>
                        <div
                          className="framer-18cgp21 scalloppay-s40"
                          data-framer-name="image 1652"
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="426"
                              height="131"
                              src="/framerusercontent.com/images/WmuyawsW6HfOf9s9c419PMM1v6c.png"
                              alt=""
                              className="scalloppay-s35"
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                    </div>
                  </section>
                </div>
                {/*/$*/}
              </div>
            </div>
            <section
              className="framer-gj2vl0"
              data-framer-name="how works"
              id="benefits"
            >
              <div className="framer-3zkc9n" data-framer-name="Content">
                <div className="framer-3yw6g3" data-framer-name="Heaader">
                  <div className="ssr-variant hidden-c4t5yq hidden-xsaq5o">
                    <div
                      className="framer-795cby scalloppay-s23 reveal"
                      data-framer-appear-id="795cby"
                      data-framer-name="One account. One balance. Built for global money."
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s43">
                        How Scallop Pay works
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1epkjq8">
                    <div
                      className="framer-795cby scalloppay-s23 reveal"
                      data-framer-appear-id="795cby"
                      data-framer-name="One account. One balance. Built for global money."
                      data-framer-component-type="RichTextContainer"
                    >
                      <h1
                        className="framer-text framer-styles-preset-18sajzf scalloppay-s44"
                        data-styles-preset="nXmNeSqma"
                        dir="auto"
                      >
                        How Scallop Pay works
                      </h1>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-c4t5yq hidden-xsaq5o">
                    <div
                      className="framer-1g08eg9 scalloppay-s23 reveal"
                      data-framer-appear-id="1g08eg9"
                      data-framer-name="52+ fiat currencies and digital assets. One unifie"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s45">
                        Simple, fast, and built for global use
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1epkjq8">
                    <div
                      className="framer-1g08eg9 scalloppay-s23 reveal"
                      data-framer-appear-id="1g08eg9"
                      data-framer-name="52+ fiat currencies and digital assets. One unifie"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s45">
                        Simple, fast, and built for global use
                      </p>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-xsaq5o">
                  <div
                    className="framer-1gab0s9"
                    data-border="true"
                    data-framer-name="Benefit Card"
                  >
                    <div
                      className="framer-1f7whhg"
                      data-border="true"
                      data-framer-name="Image"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Frame"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-qvjeou scalloppay-s46"
                        aria-hidden="true"
                      >
                        <div className="svgContainer scalloppay-s47">
                          <svg viewBox="0 0 32 32" className="scalloppay-s48">
                            <use href="#svg482887068_1078" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1f4h32b" data-framer-name="Content">
                      <div
                        className="framer-x9sdne scalloppay-s49 reveal"
                        data-framer-name="Title"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s36">
                          Payment completed
                        </p>
                      </div>
                      <div className="ssr-variant hidden-c4t5yq">
                        <div
                          className="framer-5k6v6c scalloppay-s49 reveal"
                          data-framer-name="Details"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s50">
                            Merchant receives local currency
                          </p>
                          <p dir="auto" className="framer-text scalloppay-s50">
                            via local rails
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-1epkjq8">
                        <div
                          className="framer-5k6v6c scalloppay-s49 reveal"
                          data-framer-name="Details"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s50">
                            Merchant receives local
                          </p>
                          <p dir="auto" className="framer-text scalloppay-s50">
                            currency via local rails
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
                  <div
                    className="framer-1gab0s9 scalloppay-s2"
                    data-border="true"
                    data-framer-name="Benefit Card"
                  >
                    <div
                      className="framer-1f7whhg"
                      data-border="true"
                      data-framer-name="Image"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Frame"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-qvjeou scalloppay-s46"
                        aria-hidden="true"
                      >
                        <div className="svgContainer scalloppay-s47">
                          <svg viewBox="0 0 32 32" className="scalloppay-s48">
                            <use href="#svg482887068_1078" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1f4h32b" data-framer-name="Content">
                      <div
                        className="framer-x9sdne scalloppay-s49 reveal"
                        data-framer-name="Title"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s36">
                          Payment completed
                        </p>
                      </div>
                      <div
                        className="framer-5k6v6c scalloppay-s49 reveal"
                        data-framer-name="Details"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s50">
                          Merchant receives local
                        </p>
                        <p dir="auto" className="framer-text scalloppay-s50">
                          currency via local rails
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-xsaq5o">
                  <div
                    className="framer-1wqvk42"
                    data-border="true"
                    data-framer-name="Benefit Card"
                  >
                    <div
                      className="framer-xbizni"
                      data-border="true"
                      data-framer-name="Image"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Layer_1"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-lqp2y7 scalloppay-s46"
                        aria-hidden="true"
                      >
                        <div className="svgContainer scalloppay-s47">
                          <svg viewBox="0 0 32 32" className="scalloppay-s48">
                            <use href="#svg-1654727920_5119" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1xgq85b" data-framer-name="Content">
                      <div
                        className="framer-sla4dq scalloppay-s49 reveal"
                        data-framer-name="Title"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s36">
                          Scan the QR code
                        </p>
                      </div>
                      <div className="ssr-variant hidden-c4t5yq">
                        <div
                          className="framer-t210ow scalloppay-s49 reveal"
                          data-framer-name="Details"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s50">
                            Use Scallop Pay to scan any supported
                          </p>
                          <p dir="auto" className="framer-text scalloppay-s50">
                            merchant QR
                          </p>
                        </div>
                      </div>
                      <div className="ssr-variant hidden-1epkjq8">
                        <div
                          className="framer-t210ow scalloppay-s49 reveal"
                          data-framer-name="Details"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s50">
                            Use Scallop Pay to scan any
                          </p>
                          <p dir="auto" className="framer-text scalloppay-s50">
                            supported merchant QR
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
                  <div
                    className="framer-1wqvk42 scalloppay-s2"
                    data-border="true"
                    data-framer-name="Benefit Card"
                  >
                    <div
                      className="framer-xbizni"
                      data-border="true"
                      data-framer-name="Image"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Layer_1"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-lqp2y7 scalloppay-s46"
                        aria-hidden="true"
                      >
                        <div className="svgContainer scalloppay-s47">
                          <svg viewBox="0 0 32 32" className="scalloppay-s48">
                            <use href="#svg-1654727920_5119" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1xgq85b" data-framer-name="Content">
                      <div
                        className="framer-sla4dq scalloppay-s49 reveal"
                        data-framer-name="Title"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s36">
                          Scan the QR code
                        </p>
                      </div>
                      <div
                        className="framer-t210ow scalloppay-s49 reveal"
                        data-framer-name="Details"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s50">
                          Use Scallop Pay to scan
                        </p>
                        <p dir="auto" className="framer-text scalloppay-s50">
                          any supported merchant QR
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-c4t5yq hidden-xsaq5o">
                  <div
                    className="framer-12j83pf"
                    data-border="true"
                    data-framer-name="Benefit Card"
                  >
                    <div
                      className="framer-o2kycw"
                      data-border="true"
                      data-framer-name="Image"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Frame"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-qzb3hm scalloppay-s46"
                        aria-hidden="true"
                      >
                        <div className="svgContainer scalloppay-s47">
                          <svg viewBox="0 0 32 32" className="scalloppay-s48">
                            <use href="#svg2126699191_710" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="framer-7fl7qx" data-framer-name="Content">
                      <div
                        className="framer-1f055b2 scalloppay-s49 reveal"
                        data-framer-name="Title"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s36">
                          Review details
                        </p>
                      </div>
                      <div
                        className="framer-qzec9m scalloppay-s49 reveal"
                        data-framer-name="Details"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s50">
                          Check amount, exchange rate, and
                        </p>
                        <p dir="auto" className="framer-text scalloppay-s50">
                          fees
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-1epkjq8 hidden-xsaq5o">
                  <div
                    className="framer-12j83pf scalloppay-s51"
                    data-border="true"
                    data-framer-name="Benefit Card"
                  >
                    <div
                      className="framer-o2kycw"
                      data-border="true"
                      data-framer-name="Image"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Frame"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-qzb3hm scalloppay-s46"
                        aria-hidden="true"
                      >
                        <div className="svgContainer scalloppay-s47">
                          <svg viewBox="0 0 32 32" className="scalloppay-s48">
                            <use href="#svg2126699191_710" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="framer-7fl7qx" data-framer-name="Content">
                      <div
                        className="framer-1f055b2 scalloppay-s49 reveal"
                        data-framer-name="Title"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s36">
                          Review details
                        </p>
                      </div>
                      <div
                        className="framer-qzec9m scalloppay-s49 reveal"
                        data-framer-name="Details"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s50">
                          Check amount, exchange
                        </p>
                        <p dir="auto" className="framer-text scalloppay-s50">
                          rate, and fees
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
                  <div
                    className="framer-12j83pf scalloppay-s2"
                    data-border="true"
                    data-framer-name="Benefit Card"
                  >
                    <div
                      className="framer-o2kycw"
                      data-border="true"
                      data-framer-name="Image"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Frame"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-qzb3hm scalloppay-s46"
                        aria-hidden="true"
                      >
                        <div className="svgContainer scalloppay-s47">
                          <svg viewBox="0 0 32 32" className="scalloppay-s48">
                            <use href="#svg2126699191_710" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="framer-7fl7qx" data-framer-name="Content">
                      <div
                        className="framer-1f055b2 scalloppay-s49 reveal"
                        data-framer-name="Title"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s36">
                          Review details
                        </p>
                      </div>
                      <div
                        className="framer-qzec9m scalloppay-s49 reveal"
                        data-framer-name="Details"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s50">
                          Check amount, exchange
                        </p>
                        <p dir="auto" className="framer-text scalloppay-s50">
                          rate, and fees
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-raff2r scalloppay-s2"
                  data-border="true"
                  data-framer-name="Benefit Card"
                >
                  <div
                    className="framer-1nfalzd"
                    data-border="true"
                    data-framer-name="Image"
                  >
                    <div
                      data-framer-component-type="SVG"
                      data-framer-name="Frame"
                      parentsize="0"
                      _constraints="[object Object]"
                      rotation="0"
                      shadows=""
                      className="framer-snfbqx scalloppay-s46"
                      aria-hidden="true"
                    >
                      <div className="svgContainer scalloppay-s47">
                        <svg viewBox="0 0 32 32" className="scalloppay-s48">
                          <use href="#svg-1051763948_641" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="framer-5jr8dc" data-framer-name="Content">
                    <div
                      className="framer-xuw3np scalloppay-s49 reveal"
                      data-framer-name="Title"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s36">
                        Confirm payment
                      </p>
                    </div>
                    <div className="ssr-variant hidden-c4t5yq hidden-xsaq5o">
                      <div
                        className="framer-1w44452 scalloppay-s49 reveal"
                        data-framer-name="Details"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s50">
                          Choose your balance and approve
                        </p>
                      </div>
                    </div>
                    <div className="ssr-variant hidden-1epkjq8">
                      <div
                        className="framer-1w44452 scalloppay-s49 reveal"
                        data-framer-name="Details"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s50">
                          Choose your balance and
                        </p>
                        <p dir="auto" className="framer-text scalloppay-s50">
                          approve
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-c4t5yq hidden-xsaq5o">
                  <div
                    className="framer-4j5hdk"
                    data-border="true"
                    data-framer-name="Benefit Card"
                  >
                    <div
                      className="framer-dxqs8p"
                      data-border="true"
                      data-framer-name="Image"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Frame"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-vzm8sn scalloppay-s46"
                        aria-hidden="true"
                      >
                        <div className="svgContainer scalloppay-s47">
                          <svg viewBox="0 0 32 32" className="scalloppay-s48">
                            <use href="#svg-213069468_783" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1c4y5hx" data-framer-name="Content">
                      <div
                        className="framer-8t93 scalloppay-s49 reveal"
                        data-framer-name="Title"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s36">
                          Automatic conversion
                        </p>
                      </div>
                      <div
                        className="framer-t39hl3 scalloppay-s49 reveal"
                        data-framer-name="Details"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s50">
                          Funds convert instantly if needed
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-1epkjq8 hidden-xsaq5o">
                  <div
                    className="framer-4j5hdk scalloppay-s51"
                    data-border="true"
                    data-framer-name="Benefit Card"
                  >
                    <div
                      className="framer-dxqs8p"
                      data-border="true"
                      data-framer-name="Image"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Frame"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-vzm8sn scalloppay-s46"
                        aria-hidden="true"
                      >
                        <div className="svgContainer scalloppay-s47">
                          <svg viewBox="0 0 32 32" className="scalloppay-s48">
                            <use href="#svg-213069468_783" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1c4y5hx" data-framer-name="Content">
                      <div
                        className="framer-8t93 scalloppay-s49 reveal"
                        data-framer-name="Title"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s36">
                          Automatic conversion
                        </p>
                      </div>
                      <div
                        className="framer-t39hl3 scalloppay-s49 reveal"
                        data-framer-name="Details"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s50">
                          Funds convert instantly if
                          <br className="framer-text" />
                          needed
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
                  <div
                    className="framer-4j5hdk scalloppay-s52"
                    data-border="true"
                    data-framer-name="Benefit Card"
                  >
                    <div
                      className="framer-dxqs8p"
                      data-border="true"
                      data-framer-name="Image"
                    >
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Frame"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-vzm8sn scalloppay-s46"
                        aria-hidden="true"
                      >
                        <div className="svgContainer scalloppay-s47">
                          <svg viewBox="0 0 32 32" className="scalloppay-s48">
                            <use href="#svg-213069468_783" />
                          </svg>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1c4y5hx" data-framer-name="Content">
                      <div
                        className="framer-8t93 scalloppay-s49 reveal"
                        data-framer-name="Title"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s36">
                          Automatic conversion
                        </p>
                      </div>
                      <div
                        className="framer-t39hl3 scalloppay-s49 reveal"
                        data-framer-name="Details"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s50">
                          Funds convert instantly if
                        </p>
                        <p dir="auto" className="framer-text scalloppay-s50">
                          needed
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="framer-1qsob5p" data-framer-name="BG">
                  <div className="framer-ir441x" data-framer-name="Ellipse 5">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="scalloppay-s34"
                    >
                      <img
                        decoding="async"
                        loading="lazy"
                        width="2480"
                        height="1988"
                        sizes="(min-width: 1440px) 620px, (min-width: 810px) and (max-width: 1439.98px) 620px, (max-width: 809.98px) 620px"
                        srcSet="/framerusercontent.com/images/PBSPU3h1CbefQg2QfOfTmQISXsw.png 512w,/framerusercontent.com/images/PBSPU3h1CbefQg2QfOfTmQISXsw.png 1024w,/framerusercontent.com/images/PBSPU3h1CbefQg2QfOfTmQISXsw.png 2048w,/framerusercontent.com/images/PBSPU3h1CbefQg2QfOfTmQISXsw.png 2480w"
                        src="/framerusercontent.com/images/PBSPU3h1CbefQg2QfOfTmQISXsw.png"
                        alt=""
                        className="scalloppay-s41"
                      />
                    </div>
                  </div>
                  <div className="framer-1vu76k3" data-framer-name="Ellipse 4">
                    <div
                      data-framer-background-image-wrapper="true"
                      className="scalloppay-s34"
                    >
                      <img
                        decoding="async"
                        loading="lazy"
                        width="2480"
                        height="1988"
                        sizes="(min-width: 1440px) 620px, (min-width: 810px) and (max-width: 1439.98px) 620px, (max-width: 809.98px) 620px"
                        srcSet="/framerusercontent.com/images/FMQlJkFepnh8gQmFLfAeoZqHLg.png 512w,/framerusercontent.com/images/FMQlJkFepnh8gQmFLfAeoZqHLg.png 1024w,/framerusercontent.com/images/FMQlJkFepnh8gQmFLfAeoZqHLg.png 2048w,/framerusercontent.com/images/FMQlJkFepnh8gQmFLfAeoZqHLg.png 2480w"
                        src="/framerusercontent.com/images/FMQlJkFepnh8gQmFLfAeoZqHLg.png"
                        alt=""
                        className="scalloppay-s41"
                      />
                    </div>
                  </div>
                  <figure className="framer-1tyr9ny" data-framer-name="mobile">
                    <div className="ssr-variant">
                      <div
                        className="framer-b7dof0 scalloppay-s32"
                        data-framer-name="image 1646"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="1002"
                            height="2040"
                            sizes="(min-width: 1440px) 366px, (min-width: 810px) and (max-width: 1439.98px) 296px, (max-width: 809.98px) 255px"
                            srcSet="/framerusercontent.com/images/rX4ZhUrOTFOlRS83tzBMv2Ohgg.png 1002w"
                            src="/framerusercontent.com/images/rX4ZhUrOTFOlRS83tzBMv2Ohgg.png"
                            alt=""
                            className="scalloppay-s35"
                          />
                        </div>
                      </div>
                    </div>
                  </figure>
                </div>
              </div>
            </section>
            <div
              className="framer-14pa2jy"
              data-framer-name="Realworld payment"
            >
              <div className="framer-xs1ud8" data-framer-name="Container">
                <div className="ssr-variant hidden-c4t5yq hidden-xsaq5o">
                  <div
                    className="framer-1eq8mz0 scalloppay-s23 reveal"
                    data-framer-name="One account. One balance. Built for global money."
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s43">
                      Built for real-world payments
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1epkjq8">
                  <div
                    className="framer-1eq8mz0 scalloppay-s23 reveal"
                    data-framer-name="One account. One balance. Built for global money."
                    data-framer-component-type="RichTextContainer"
                  >
                    <h1
                      className="framer-text framer-styles-preset-18sajzf scalloppay-s44"
                      data-styles-preset="nXmNeSqma"
                      dir="auto"
                    >
                      Built for real-world payments
                    </h1>
                  </div>
                </div>
                <div className="ssr-variant hidden-c4t5yq hidden-xsaq5o">
                  <div
                    className="framer-tbw4ux scalloppay-s23 reveal"
                    data-framer-appear-id="tbw4ux"
                    data-framer-name="52+ fiat currencies and digital assets. One unifie"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s45">
                      Use Scallop Pay where cards don&rsquo;t work
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1epkjq8">
                  <div
                    className="framer-tbw4ux scalloppay-s23 reveal"
                    data-framer-appear-id="tbw4ux"
                    data-framer-name="52+ fiat currencies and digital assets. One unifie"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s45">
                      Use Scallop Pay where cards don&rsquo;t work
                    </p>
                  </div>
                </div>
              </div>
              <div className="framer-1kb0bmk hidden-1epkjq8 hidden-c4t5yq">
                <div className="ssr-variant">
                  <div className="framer-s8i8p3-container hidden-1epkjq8">
                    <div
                      className="framer-LCzCO framer-fmgzn5 framer-v-1cw9kgn scalloppay-s3"
                      data-framer-name="Open"
                      data-highlight="true"
                    >
                      <div
                        className="framer-bpmdt9 scalloppay-s53"
                        data-framer-name="Content"
                      >
                        <div
                          className="framer-1w6qppx scalloppay-s54"
                          draggable={false}
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="570"
                              height="432"
                              sizes="(min-width: 1440px) 526px, (min-width: 810px) and (max-width: 1439.98px) 526px, (max-width: 809.98px) 526px"
                              srcSet="/framerusercontent.com/images/wxs8oV9FEE9m6St9gbx87Pe8.png 512w,/framerusercontent.com/images/wxs8oV9FEE9m6St9gbx87Pe8.png 570w"
                              src="/framerusercontent.com/images/wxs8oV9FEE9m6St9gbx87Pe8.png"
                              alt=""
                              draggable={false}
                              className="scalloppay-s35"
                            />
                          </div>
                          <div className="framer-1ml7kyc-container">
                            {/*$*/}
                            <div />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-14k880b scalloppay-s55"
                          data-framer-name="Description"
                        >
                          <div
                            className="framer-xt211i scalloppay-s56 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s57"
                            >
                              Street Vendors
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div className="framer-tsq95d-container hidden-1epkjq8">
                    <div
                      className="framer-LCzCO framer-fmgzn5 framer-v-1cw9kgn scalloppay-s3"
                      data-framer-name="Open"
                      data-highlight="true"
                    >
                      <div
                        className="framer-bpmdt9 scalloppay-s53"
                        data-framer-name="Content"
                      >
                        <div
                          className="framer-1w6qppx scalloppay-s54"
                          draggable={false}
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="570"
                              height="432"
                              sizes="(min-width: 1440px) 526px, (min-width: 810px) and (max-width: 1439.98px) 526px, (max-width: 809.98px) 526px"
                              srcSet="/framerusercontent.com/images/sO47sJIxpNWeUcOOzcOoMfMp3iQ.png 512w,/framerusercontent.com/images/sO47sJIxpNWeUcOOzcOoMfMp3iQ.png 570w"
                              src="/framerusercontent.com/images/sO47sJIxpNWeUcOOzcOoMfMp3iQ.png"
                              alt=""
                              draggable={false}
                              className="scalloppay-s35"
                            />
                          </div>
                          <div className="framer-1ml7kyc-container">
                            {/*$*/}
                            <div />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-14k880b scalloppay-s55"
                          data-framer-name="Description"
                        >
                          <div
                            className="framer-xt211i scalloppay-s56 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s57"
                            >
                              Local Shops
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div className="framer-11d6he7-container hidden-1epkjq8">
                    <div
                      className="framer-LCzCO framer-fmgzn5 framer-v-1cw9kgn scalloppay-s19"
                      data-framer-name="Open"
                      data-highlight="true"
                    >
                      <div
                        className="framer-bpmdt9 scalloppay-s53"
                        data-framer-name="Content"
                      >
                        <div
                          className="framer-1w6qppx scalloppay-s54"
                          draggable={false}
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="570"
                              height="432"
                              sizes="(min-width: 1440px) 526px, (min-width: 810px) and (max-width: 1439.98px) 526px, (max-width: 809.98px) 526px"
                              srcSet="/framerusercontent.com/images/wHAh4kG4Eca5QDUEN3pVXVrBU.png 512w,/framerusercontent.com/images/wHAh4kG4Eca5QDUEN3pVXVrBU.png 570w"
                              src="/framerusercontent.com/images/wHAh4kG4Eca5QDUEN3pVXVrBU.png"
                              alt=""
                              draggable={false}
                              className="scalloppay-s35"
                            />
                          </div>
                          <div className="framer-1ml7kyc-container">
                            {/*$*/}
                            <div />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-14k880b scalloppay-s55"
                          data-framer-name="Description"
                        >
                          <div
                            className="framer-xt211i scalloppay-s56 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s57"
                            >
                              Transport
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div className="framer-v815gd-container hidden-1epkjq8">
                    <div
                      className="framer-LCzCO framer-fmgzn5 framer-v-1cw9kgn scalloppay-s3"
                      data-framer-name="Open"
                      data-highlight="true"
                    >
                      <div
                        className="framer-bpmdt9 scalloppay-s53"
                        data-framer-name="Content"
                      >
                        <div
                          className="framer-1w6qppx scalloppay-s54"
                          draggable={false}
                        >
                          <div
                            data-framer-background-image-wrapper="true"
                            className="scalloppay-s34"
                          >
                            <img
                              decoding="async"
                              width="570"
                              height="432"
                              sizes="(min-width: 1440px) 526px, (min-width: 810px) and (max-width: 1439.98px) 526px, (max-width: 809.98px) 526px"
                              srcSet="/framerusercontent.com/images/rXtLbRyupBaDsjTqmrQgIkApxM.png 512w,/framerusercontent.com/images/rXtLbRyupBaDsjTqmrQgIkApxM.png 570w"
                              src="/framerusercontent.com/images/rXtLbRyupBaDsjTqmrQgIkApxM.png"
                              alt=""
                              draggable={false}
                              className="scalloppay-s35"
                            />
                          </div>
                          <div className="framer-1ml7kyc-container">
                            {/*$*/}
                            <div />
                            {/*/$*/}
                          </div>
                        </div>
                        <div
                          className="framer-14k880b scalloppay-s55"
                          data-framer-name="Description"
                        >
                          <div
                            className="framer-xt211i scalloppay-s56 reveal"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s57"
                            >
                              Abroad Purchases
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-c4t5yq">
                <div className="framer-12bs1my-container hidden-xsaq5o">
                  <div
                    className="framer-wi2H6 framer-qkhuhr framer-v-qkhuhr"
                    data-framer-name="1"
                  >
                    <div className="framer-1fad0-container">
                      <div
                        className={`framer-LCzCO framer-fmgzn5 ${hoveredPaymentCard === 0 ? 'framer-v-1cw9kgn' : 'framer-v-fmgzn5'}`}
                        data-framer-name={
                          hoveredPaymentCard === 0 ? 'Open' : 'Closed'
                        }
                        data-highlight="true"
                        onMouseEnter={() => setHoveredPaymentCard(0)}
                        onClick={() => setHoveredPaymentCard(0)}
                        onFocus={() => setHoveredPaymentCard(0)}
                        tabIndex={0}
                        role="button"
                      >
                        <div
                          className={`framer-bpmdt9 ${hoveredPaymentCard === 0 ? 'scalloppay-s53' : 'scalloppay-s58'}`}
                          data-framer-name="Content"
                        >
                          <div
                            className={`framer-1w6qppx ${hoveredPaymentCard === 0 ? 'scalloppay-s54' : 'scalloppay-s59'}`}
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="scalloppay-s34"
                            >
                              <img
                                decoding="async"
                                width="570"
                                height="432"
                                sizes="(min-width: 1440px) 526px, (min-width: 810px) and (max-width: 1439.98px) 526px, (max-width: 809.98px) 526px"
                                srcSet="/framerusercontent.com/images/wxs8oV9FEE9m6St9gbx87Pe8.png 512w,/framerusercontent.com/images/wxs8oV9FEE9m6St9gbx87Pe8.png 570w"
                                src="/framerusercontent.com/images/wxs8oV9FEE9m6St9gbx87Pe8.png"
                                alt=""
                                draggable={false}
                                className="scalloppay-s35"
                              />
                            </div>
                            <div className="framer-1ml7kyc-container">
                              {/*$*/}
                              <div />
                              {/*/$*/}
                            </div>
                          </div>
                          <div
                            className={`framer-14k880b ${hoveredPaymentCard === 0 ? 'scalloppay-s55' : 'scalloppay-s60'}`}
                            data-framer-name="Description"
                          >
                            <div
                              className="framer-xt211i scalloppay-s56 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text scalloppay-s57"
                              >
                                {hoveredPaymentCard === 0
                                  ? 'Street Vendors'
                                  : ''}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-17kp3gk-container">
                      <div
                        className={`framer-LCzCO framer-fmgzn5 ${hoveredPaymentCard === 1 ? 'framer-v-1cw9kgn' : 'framer-v-fmgzn5'}`}
                        data-framer-name={
                          hoveredPaymentCard === 1 ? 'Open' : 'Closed'
                        }
                        data-highlight="true"
                        onMouseEnter={() => setHoveredPaymentCard(1)}
                        onClick={() => setHoveredPaymentCard(1)}
                        onFocus={() => setHoveredPaymentCard(1)}
                        tabIndex={0}
                        role="button"
                      >
                        <div
                          className={`framer-bpmdt9 ${hoveredPaymentCard === 1 ? 'scalloppay-s53' : 'scalloppay-s58'}`}
                          data-framer-name="Content"
                        >
                          <div
                            className={`framer-1w6qppx ${hoveredPaymentCard === 1 ? 'scalloppay-s54' : 'scalloppay-s59'}`}
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="scalloppay-s34"
                            >
                              <img
                                decoding="async"
                                width="570"
                                height="432"
                                sizes="(min-width: 1440px) 526px, (min-width: 810px) and (max-width: 1439.98px) 526px, (max-width: 809.98px) 526px"
                                srcSet="/framerusercontent.com/images/sO47sJIxpNWeUcOOzcOoMfMp3iQ.png 512w,/framerusercontent.com/images/sO47sJIxpNWeUcOOzcOoMfMp3iQ.png 570w"
                                src="/framerusercontent.com/images/sO47sJIxpNWeUcOOzcOoMfMp3iQ.png"
                                alt=""
                                draggable={false}
                                className="scalloppay-s35"
                              />
                            </div>
                            <div className="framer-1ml7kyc-container">
                              {/*$*/}
                              <div />
                              {/*/$*/}
                            </div>
                          </div>
                          <div
                            className={`framer-14k880b ${hoveredPaymentCard === 1 ? 'scalloppay-s55' : 'scalloppay-s60'}`}
                            data-framer-name="Description"
                          >
                            <div
                              className="framer-xt211i scalloppay-s56 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text scalloppay-s57"
                              >
                                {hoveredPaymentCard === 1 ? 'Local Shops' : ''}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-7ur1b1-container">
                      <div
                        className={`framer-LCzCO framer-fmgzn5 ${hoveredPaymentCard === 2 ? 'framer-v-1cw9kgn' : 'framer-v-fmgzn5'}`}
                        data-framer-name={
                          hoveredPaymentCard === 2 ? 'Open' : 'Closed'
                        }
                        data-highlight="true"
                        onMouseEnter={() => setHoveredPaymentCard(2)}
                        onClick={() => setHoveredPaymentCard(2)}
                        onFocus={() => setHoveredPaymentCard(2)}
                        tabIndex={0}
                        role="button"
                      >
                        <div
                          className={`framer-bpmdt9 ${hoveredPaymentCard === 2 ? 'scalloppay-s53' : 'scalloppay-s58'}`}
                          data-framer-name="Content"
                        >
                          <div
                            className={`framer-1w6qppx ${hoveredPaymentCard === 2 ? 'scalloppay-s54' : 'scalloppay-s59'}`}
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="scalloppay-s34"
                            >
                              <img
                                decoding="async"
                                width="570"
                                height="432"
                                sizes="(min-width: 1440px) 526px, (min-width: 810px) and (max-width: 1439.98px) 526px, (max-width: 809.98px) 526px"
                                srcSet="/framerusercontent.com/images/wHAh4kG4Eca5QDUEN3pVXVrBU.png 512w,/framerusercontent.com/images/wHAh4kG4Eca5QDUEN3pVXVrBU.png 570w"
                                src="/framerusercontent.com/images/wHAh4kG4Eca5QDUEN3pVXVrBU.png"
                                alt=""
                                draggable={false}
                                className="scalloppay-s35"
                              />
                            </div>
                            <div className="framer-1ml7kyc-container">
                              {/*$*/}
                              <div />
                              {/*/$*/}
                            </div>
                          </div>
                          <div
                            className={`framer-14k880b ${hoveredPaymentCard === 2 ? 'scalloppay-s55' : 'scalloppay-s60'}`}
                            data-framer-name="Description"
                          >
                            <div
                              className="framer-xt211i scalloppay-s56 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text scalloppay-s57"
                              >
                                {hoveredPaymentCard === 2 ? 'Transport' : ''}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1vr91v1-container">
                      <div
                        className={`framer-LCzCO framer-fmgzn5 ${hoveredPaymentCard === 3 ? 'framer-v-1cw9kgn' : 'framer-v-fmgzn5'}`}
                        data-framer-name={
                          hoveredPaymentCard === 3 ? 'Open' : 'Closed'
                        }
                        data-highlight="true"
                        onMouseEnter={() => setHoveredPaymentCard(3)}
                        onClick={() => setHoveredPaymentCard(3)}
                        onFocus={() => setHoveredPaymentCard(3)}
                        tabIndex={0}
                        role="button"
                      >
                        <div
                          className={`framer-bpmdt9 ${hoveredPaymentCard === 3 ? 'scalloppay-s53' : 'scalloppay-s58'}`}
                          data-framer-name="Content"
                        >
                          <div
                            className={`framer-1w6qppx ${hoveredPaymentCard === 3 ? 'scalloppay-s54' : 'scalloppay-s59'}`}
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="scalloppay-s34"
                            >
                              <img
                                decoding="async"
                                width="570"
                                height="432"
                                sizes="(min-width: 1440px) 526px, (min-width: 810px) and (max-width: 1439.98px) 526px, (max-width: 809.98px) 526px"
                                srcSet="/framerusercontent.com/images/rXtLbRyupBaDsjTqmrQgIkApxM.png 512w,/framerusercontent.com/images/rXtLbRyupBaDsjTqmrQgIkApxM.png 570w"
                                src="/framerusercontent.com/images/rXtLbRyupBaDsjTqmrQgIkApxM.png"
                                alt=""
                                draggable={false}
                                className="scalloppay-s35"
                              />
                            </div>
                            <div className="framer-1ml7kyc-container">
                              {/*$*/}
                              <div />
                              {/*/$*/}
                            </div>
                          </div>
                          <div
                            className={`framer-14k880b ${hoveredPaymentCard === 3 ? 'scalloppay-s55' : 'scalloppay-s60'}`}
                            data-framer-name="Description"
                          >
                            <div
                              className="framer-xt211i scalloppay-s56 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text scalloppay-s57"
                              >
                                {hoveredPaymentCard === 3
                                  ? 'Abroad Purchases'
                                  : ''}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-1epkjq8 hidden-xsaq5o">
                <div className="framer-12bs1my-container hidden-xsaq5o">
                  <div
                    className="framer-wi2H6 framer-qkhuhr framer-v-qkhuhr scalloppay-s3"
                    data-framer-name="1"
                  >
                    <div className="framer-1fad0-container">
                      <div
                        className={`framer-LCzCO framer-fmgzn5 ${hoveredPaymentCard === 0 ? 'framer-v-1cw9kgn' : 'framer-v-fmgzn5'}`}
                        data-framer-name={
                          hoveredPaymentCard === 0 ? 'Open' : 'Closed'
                        }
                        data-highlight="true"
                        onMouseEnter={() => setHoveredPaymentCard(0)}
                        onClick={() => setHoveredPaymentCard(0)}
                        onFocus={() => setHoveredPaymentCard(0)}
                        tabIndex={0}
                        role="button"
                      >
                        <div
                          className={`framer-bpmdt9 ${hoveredPaymentCard === 0 ? 'scalloppay-s53' : 'scalloppay-s58'}`}
                          data-framer-name="Content"
                        >
                          <div
                            className={`framer-1w6qppx ${hoveredPaymentCard === 0 ? 'scalloppay-s54' : 'scalloppay-s59'}`}
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="scalloppay-s34"
                            >
                              <img
                                decoding="async"
                                width="570"
                                height="432"
                                sizes="(min-width: 1440px) 526px, (min-width: 810px) and (max-width: 1439.98px) 526px, (max-width: 809.98px) 526px"
                                srcSet="/framerusercontent.com/images/wxs8oV9FEE9m6St9gbx87Pe8.png 512w,/framerusercontent.com/images/wxs8oV9FEE9m6St9gbx87Pe8.png 570w"
                                src="/framerusercontent.com/images/wxs8oV9FEE9m6St9gbx87Pe8.png"
                                alt=""
                                draggable={false}
                                className="scalloppay-s35"
                              />
                            </div>
                            <div className="framer-1ml7kyc-container">
                              {/*$*/}
                              <div />
                              {/*/$*/}
                            </div>
                          </div>
                          <div
                            className={`framer-14k880b ${hoveredPaymentCard === 0 ? 'scalloppay-s55' : 'scalloppay-s60'}`}
                            data-framer-name="Description"
                          >
                            <div
                              className="framer-xt211i scalloppay-s56 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text scalloppay-s57"
                              >
                                {hoveredPaymentCard === 0
                                  ? 'Street Vendors'
                                  : ''}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-17kp3gk-container">
                      <div
                        className={`framer-LCzCO framer-fmgzn5 ${hoveredPaymentCard === 1 ? 'framer-v-1cw9kgn' : 'framer-v-fmgzn5'}`}
                        data-framer-name={
                          hoveredPaymentCard === 1 ? 'Open' : 'Closed'
                        }
                        data-highlight="true"
                        onMouseEnter={() => setHoveredPaymentCard(1)}
                        onClick={() => setHoveredPaymentCard(1)}
                        onFocus={() => setHoveredPaymentCard(1)}
                        tabIndex={0}
                        role="button"
                      >
                        <div
                          className={`framer-bpmdt9 ${hoveredPaymentCard === 1 ? 'scalloppay-s53' : 'scalloppay-s58'}`}
                          data-framer-name="Content"
                        >
                          <div
                            className={`framer-1w6qppx ${hoveredPaymentCard === 1 ? 'scalloppay-s54' : 'scalloppay-s59'}`}
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="scalloppay-s34"
                            >
                              <img
                                decoding="async"
                                width="570"
                                height="432"
                                sizes="(min-width: 1440px) 526px, (min-width: 810px) and (max-width: 1439.98px) 526px, (max-width: 809.98px) 526px"
                                srcSet="/framerusercontent.com/images/sO47sJIxpNWeUcOOzcOoMfMp3iQ.png 512w,/framerusercontent.com/images/sO47sJIxpNWeUcOOzcOoMfMp3iQ.png 570w"
                                src="/framerusercontent.com/images/sO47sJIxpNWeUcOOzcOoMfMp3iQ.png"
                                alt=""
                                draggable={false}
                                className="scalloppay-s35"
                              />
                            </div>
                            <div className="framer-1ml7kyc-container">
                              {/*$*/}
                              <div />
                              {/*/$*/}
                            </div>
                          </div>
                          <div
                            className={`framer-14k880b ${hoveredPaymentCard === 1 ? 'scalloppay-s55' : 'scalloppay-s60'}`}
                            data-framer-name="Description"
                          >
                            <div
                              className="framer-xt211i scalloppay-s56 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text scalloppay-s57"
                              >
                                {hoveredPaymentCard === 1 ? 'Local Shops' : ''}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-7ur1b1-container">
                      <div
                        className={`framer-LCzCO framer-fmgzn5 ${hoveredPaymentCard === 2 ? 'framer-v-1cw9kgn' : 'framer-v-fmgzn5'}`}
                        data-framer-name={
                          hoveredPaymentCard === 2 ? 'Open' : 'Closed'
                        }
                        data-highlight="true"
                        onMouseEnter={() => setHoveredPaymentCard(2)}
                        onClick={() => setHoveredPaymentCard(2)}
                        onFocus={() => setHoveredPaymentCard(2)}
                        tabIndex={0}
                        role="button"
                      >
                        <div
                          className={`framer-bpmdt9 ${hoveredPaymentCard === 2 ? 'scalloppay-s53' : 'scalloppay-s58'}`}
                          data-framer-name="Content"
                        >
                          <div
                            className={`framer-1w6qppx ${hoveredPaymentCard === 2 ? 'scalloppay-s54' : 'scalloppay-s59'}`}
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="scalloppay-s34"
                            >
                              <img
                                decoding="async"
                                width="570"
                                height="432"
                                sizes="(min-width: 1440px) 526px, (min-width: 810px) and (max-width: 1439.98px) 526px, (max-width: 809.98px) 526px"
                                srcSet="/framerusercontent.com/images/wHAh4kG4Eca5QDUEN3pVXVrBU.png 512w,/framerusercontent.com/images/wHAh4kG4Eca5QDUEN3pVXVrBU.png 570w"
                                src="/framerusercontent.com/images/wHAh4kG4Eca5QDUEN3pVXVrBU.png"
                                alt=""
                                draggable={false}
                                className="scalloppay-s35"
                              />
                            </div>
                            <div className="framer-1ml7kyc-container">
                              {/*$*/}
                              <div />
                              {/*/$*/}
                            </div>
                          </div>
                          <div
                            className={`framer-14k880b ${hoveredPaymentCard === 2 ? 'scalloppay-s55' : 'scalloppay-s60'}`}
                            data-framer-name="Description"
                          >
                            <div
                              className="framer-xt211i scalloppay-s56 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text scalloppay-s57"
                              >
                                {hoveredPaymentCard === 2 ? 'Transport' : ''}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1vr91v1-container">
                      <div
                        className={`framer-LCzCO framer-fmgzn5 ${hoveredPaymentCard === 3 ? 'framer-v-1cw9kgn' : 'framer-v-fmgzn5'}`}
                        data-framer-name={
                          hoveredPaymentCard === 3 ? 'Open' : 'Closed'
                        }
                        data-highlight="true"
                        onMouseEnter={() => setHoveredPaymentCard(3)}
                        onClick={() => setHoveredPaymentCard(3)}
                        onFocus={() => setHoveredPaymentCard(3)}
                        tabIndex={0}
                        role="button"
                      >
                        <div
                          className={`framer-bpmdt9 ${hoveredPaymentCard === 3 ? 'scalloppay-s53' : 'scalloppay-s58'}`}
                          data-framer-name="Content"
                        >
                          <div
                            className={`framer-1w6qppx ${hoveredPaymentCard === 3 ? 'scalloppay-s54' : 'scalloppay-s59'}`}
                            draggable={false}
                          >
                            <div
                              data-framer-background-image-wrapper="true"
                              className="scalloppay-s34"
                            >
                              <img
                                decoding="async"
                                width="570"
                                height="432"
                                sizes="(min-width: 1440px) 526px, (min-width: 810px) and (max-width: 1439.98px) 526px, (max-width: 809.98px) 526px"
                                srcSet="/framerusercontent.com/images/rXtLbRyupBaDsjTqmrQgIkApxM.png 512w,/framerusercontent.com/images/rXtLbRyupBaDsjTqmrQgIkApxM.png 570w"
                                src="/framerusercontent.com/images/rXtLbRyupBaDsjTqmrQgIkApxM.png"
                                alt=""
                                draggable={false}
                                className="scalloppay-s35"
                              />
                            </div>
                            <div className="framer-1ml7kyc-container">
                              {/*$*/}
                              <div />
                              {/*/$*/}
                            </div>
                          </div>
                          <div
                            className={`framer-14k880b ${hoveredPaymentCard === 3 ? 'scalloppay-s55' : 'scalloppay-s60'}`}
                            data-framer-name="Description"
                          >
                            <div
                              className="framer-xt211i scalloppay-s56 reveal"
                              data-framer-component-type="RichTextContainer"
                            >
                              <p
                                dir="auto"
                                className="framer-text scalloppay-s57"
                              >
                                {hoveredPaymentCard === 3
                                  ? 'Abroad Purchases'
                                  : ''}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-1fqwsnz" data-framer-name="Payment app">
              <div className="framer-18ep7u9" data-framer-name="Container" />
              <div className="framer-h7dh1t" data-framer-name="Container">
                <div className="ssr-variant hidden-c4t5yq hidden-xsaq5o">
                  <div
                    className="framer-1m20llt scalloppay-s23 reveal"
                    data-framer-name="One account. One balance. Built for global money."
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s61">
                      More than just a Payment App
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1epkjq8">
                  <div
                    className="framer-1m20llt scalloppay-s23 reveal"
                    data-framer-name="One account. One balance. Built for global money."
                    data-framer-component-type="RichTextContainer"
                  >
                    <h1
                      className="framer-text framer-styles-preset-18sajzf scalloppay-s27"
                      data-styles-preset="nXmNeSqma"
                      dir="auto"
                    >
                      More than just a Payment App
                    </h1>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div
                    className="framer-1c879hq scalloppay-s23 reveal"
                    data-framer-name="52+ fiat currencies and digital assets. One unifie"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s45">
                      Access local payment systems without local setup
                    </p>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-c4t5yq hidden-xsaq5o">
                <div
                  className="framer-11aaodm scalloppay-s32"
                  data-framer-name="Section/Comparison"
                  id="11aaodm"
                >
                  <div className="framer-4yzdag" data-framer-name="Container">
                    <div
                      className="framer-194jqig"
                      data-framer-name="Plan Header"
                    >
                      <div
                        className="framer-vcqj1k hidden-xsaq5o scalloppay-s49 reveal"
                        data-framer-name="Title"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s62">
                          <span className="scalloppay-s63">
                            <span className="scalloppay-s64">F</span>
                            <span className="scalloppay-s64">e</span>
                            <span className="scalloppay-s64">a</span>
                            <span className="scalloppay-s64">t</span>
                            <span className="scalloppay-s64">u</span>
                            <span className="scalloppay-s64">r</span>
                            <span className="scalloppay-s64">e</span>
                            <span className="scalloppay-s64">s</span>
                          </span>{' '}
                          <span className="scalloppay-s63">
                            <span className="scalloppay-s64">i</span>
                            <span className="scalloppay-s64">n</span>
                            <span className="scalloppay-s64">c</span>
                            <span className="scalloppay-s64">l</span>
                            <span className="scalloppay-s64">u</span>
                            <span className="scalloppay-s64">d</span>
                            <span className="scalloppay-s64">e</span>
                            <span className="scalloppay-s64">d</span>
                          </span>{' '}
                          <span className="scalloppay-s63">
                            <span className="scalloppay-s64">i</span>
                            <span className="scalloppay-s64">n</span>
                          </span>{' '}
                          <span className="scalloppay-s63">
                            <span className="scalloppay-s64">e</span>
                            <span className="scalloppay-s64">v</span>
                            <span className="scalloppay-s64">e</span>
                            <span className="scalloppay-s64">r</span>
                            <span className="scalloppay-s64">y</span>
                          </span>{' '}
                          <span className="scalloppay-s63">
                            <span className="scalloppay-s64">p</span>
                            <span className="scalloppay-s64">l</span>
                            <span className="scalloppay-s64">a</span>
                            <span className="scalloppay-s64">n</span>
                          </span>
                        </p>
                      </div>
                      <div
                        className="framer-1q7a1e"
                        data-framer-name="Plan Buttons"
                      >
                        <div className="framer-rk9jht-container">
                          <div
                            className="framer-uIx4h framer-ykqhhg framer-v-ykqhhg scalloppay-s65"
                            data-framer-name="Variant 1"
                          >
                            <div className="framer-1wuw3je">
                              <div
                                className="framer-1uvb7g8 scalloppay-s66 reveal"
                                data-framer-name="Plan Name"
                                data-framer-component-type="RichTextContainer"
                              >
                                <h5
                                  dir="auto"
                                  className="framer-text scalloppay-s67"
                                >
                                  Scallop Pay
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="framer-14zvt7h-container">
                          <div
                            className="framer-uIx4h framer-ykqhhg framer-v-ykqhhg scalloppay-s65"
                            data-framer-name="Variant 1"
                          >
                            <div className="framer-1wuw3je">
                              <div
                                className="framer-1uvb7g8 scalloppay-s66 reveal"
                                data-framer-name="Plan Name"
                                data-framer-component-type="RichTextContainer"
                              >
                                <h5
                                  dir="auto"
                                  className="framer-text scalloppay-s67"
                                >
                                  Traditional Cards
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-vsjbyh-container hidden-xsaq5o">
                      <ul
                        className="framer-D6rRd framer-hn7heh framer-v-hn7heh scalloppay-s3"
                        data-framer-name="Desktop"
                      >
                        <li className="framer-16h3wtx" data-framer-name="Table">
                          <div className="framer-1qgl83x-container">
                            <div
                              className="framer-onkl2 framer-17syfd5 framer-v-17syfd5 scalloppay-s68"
                              data-framer-name="Desktop - Variant 1"
                            >
                              <div
                                className="framer-d4km2x scalloppay-s69 reveal"
                                data-framer-name="Feature Name"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s70"
                                >
                                  Pay where cards are not accepted
                                </p>
                              </div>
                              <div
                                className="framer-1txa564"
                                data-framer-name="3"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Frame"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-12c4ez4 scalloppay-s46"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer scalloppay-s47">
                                    <svg
                                      viewBox="0 0 32 32"
                                      className="scalloppay-s48"
                                    >
                                      <use href="#svg-892036779_709" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-12rfxzq"
                                data-framer-name="4"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Frame"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1t2t180 scalloppay-s46"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer scalloppay-s47">
                                    <svg
                                      viewBox="0 0 32 32"
                                      className="scalloppay-s48"
                                    >
                                      <use href="#svg-1469766317_873" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="framer-1ff14az-container">
                            <div
                              className="framer-onkl2 framer-17syfd5 framer-v-1e308x7 scalloppay-s71"
                              data-framer-name="Desktop - Variant 2"
                            >
                              <div
                                className="framer-d4km2x scalloppay-s69 reveal"
                                data-framer-name="Feature Name"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s70"
                                >
                                  No need for local currency balances
                                </p>
                              </div>
                              <div
                                className="framer-1txa564"
                                data-framer-name="3"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Frame"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-12c4ez4 scalloppay-s46"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer scalloppay-s47">
                                    <svg
                                      viewBox="0 0 32 32"
                                      className="scalloppay-s48"
                                    >
                                      <use href="#svg-892036779_709" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-12rfxzq"
                                data-framer-name="4"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Frame"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1t2t180 scalloppay-s46"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer scalloppay-s47">
                                    <svg
                                      viewBox="0 0 32 32"
                                      className="scalloppay-s48"
                                    >
                                      <use href="#svg-1469766317_873" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="framer-1kjsl3e-container">
                            <div
                              className="framer-onkl2 framer-17syfd5 framer-v-17syfd5 scalloppay-s68"
                              data-framer-name="Desktop - Variant 1"
                            >
                              <div
                                className="framer-d4km2x scalloppay-s69 reveal"
                                data-framer-name="Feature Name"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s70"
                                >
                                  No switching between apps
                                </p>
                              </div>
                              <div
                                className="framer-1txa564"
                                data-framer-name="3"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Frame"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-12c4ez4 scalloppay-s46"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer scalloppay-s47">
                                    <svg
                                      viewBox="0 0 32 32"
                                      className="scalloppay-s48"
                                    >
                                      <use href="#svg-892036779_709" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-12rfxzq"
                                data-framer-name="4"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Frame"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1t2t180 scalloppay-s46"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer scalloppay-s47">
                                    <svg
                                      viewBox="0 0 32 32"
                                      className="scalloppay-s48"
                                    >
                                      <use href="#svg-1469766317_873" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="framer-1en9xn-container">
                            <div
                              className="framer-onkl2 framer-17syfd5 framer-v-1e308x7 scalloppay-s71"
                              data-framer-name="Desktop - Variant 2"
                            >
                              <div
                                className="framer-d4km2x scalloppay-s69 reveal"
                                data-framer-name="Feature Name"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s70"
                                >
                                  Use one unified balance globally
                                </p>
                              </div>
                              <div
                                className="framer-1txa564"
                                data-framer-name="3"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Frame"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-12c4ez4 scalloppay-s46"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer scalloppay-s47">
                                    <svg
                                      viewBox="0 0 32 32"
                                      className="scalloppay-s48"
                                    >
                                      <use href="#svg-892036779_709" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-12rfxzq"
                                data-framer-name="4"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Frame"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1t2t180 scalloppay-s46"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer scalloppay-s47">
                                    <svg
                                      viewBox="0 0 32 32"
                                      className="scalloppay-s48"
                                    >
                                      <use href="#svg-1469766317_873" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div
                      className="framer-7kl7d6 hidden-1epkjq8 hidden-c4t5yq scalloppay-s72"
                      data-framer-name="Mobile"
                    >
                      <div
                        className="framer-1l33nn3 scalloppay-s49 reveal"
                        data-framer-name="Feature Name"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s73">
                          Zero-Knowledge
                        </p>
                        <p dir="auto" className="framer-text scalloppay-s73">
                          Encryption
                        </p>
                      </div>
                      <div className="framer-zt0oe8" data-framer-name="3">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-igtcm3 scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 32 32" className="scalloppay-s48">
                              <use href="#svg-892036779_709" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="framer-b4zcvw" data-framer-name="4">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-4xrn7a scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 32 32" className="scalloppay-s48">
                              <use href="#svg-1469766317_873" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-vqvd57 hidden-1epkjq8 hidden-c4t5yq scalloppay-s72"
                      data-framer-name="Mobile"
                    >
                      <div
                        className="framer-poz6i1 scalloppay-s49 reveal"
                        data-framer-name="Feature Name"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s73">
                          No need for local
                        </p>
                        <p dir="auto" className="framer-text scalloppay-s73">
                          currency balances
                        </p>
                      </div>
                      <div className="framer-1n3vprm" data-framer-name="3">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-dbhfmu scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 32 32" className="scalloppay-s48">
                              <use href="#svg-892036779_709" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="framer-ei2n7d" data-framer-name="4">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-18xwut2 scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 32 32" className="scalloppay-s48">
                              <use href="#svg-1469766317_873" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1nxcczu hidden-1epkjq8 hidden-c4t5yq scalloppay-s72"
                      data-framer-name="Mobile"
                    >
                      <div
                        className="framer-15ua86u scalloppay-s49 reveal"
                        data-framer-name="Feature Name"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s73">
                          No switching between apps
                        </p>
                      </div>
                      <div className="framer-154av6w" data-framer-name="3">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-vzj6xf scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 32 32" className="scalloppay-s48">
                              <use href="#svg-892036779_709" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="framer-1fyr3y8" data-framer-name="4">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ari5ar scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 32 32" className="scalloppay-s48">
                              <use href="#svg-1469766317_873" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-707f4j hidden-1epkjq8 hidden-c4t5yq scalloppay-s72"
                      data-framer-name="Mobile"
                    >
                      <div
                        className="framer-1gjpszk scalloppay-s49 reveal"
                        data-framer-name="Feature Name"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s73">
                          Use one unified balance globally
                        </p>
                      </div>
                      <div className="framer-15axyup" data-framer-name="3">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1slagqb scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 32 32" className="scalloppay-s48">
                              <use href="#svg-892036779_709" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="framer-b2lhka" data-framer-name="4">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1jurkqi scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 32 32" className="scalloppay-s48">
                              <use href="#svg-1469766317_873" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-1epkjq8 hidden-xsaq5o">
                <div
                  className="framer-11aaodm"
                  data-framer-name="Section/Comparison"
                  id="11aaodm"
                >
                  <div className="framer-4yzdag" data-framer-name="Container">
                    <div
                      className="framer-194jqig"
                      data-framer-name="Plan Header"
                    >
                      <div
                        className="framer-vcqj1k hidden-xsaq5o scalloppay-s49 reveal"
                        data-framer-name="Title"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p
                          className="framer-text framer-styles-preset-j2aj5g scalloppay-s25"
                          data-styles-preset="y0n9yO7RI"
                        >
                          <span className="scalloppay-s63">
                            <span className="scalloppay-s64">F</span>
                            <span className="scalloppay-s64">e</span>
                            <span className="scalloppay-s64">a</span>
                            <span className="scalloppay-s64">t</span>
                            <span className="scalloppay-s64">u</span>
                            <span className="scalloppay-s64">r</span>
                            <span className="scalloppay-s64">e</span>
                            <span className="scalloppay-s64">s</span>
                          </span>{' '}
                          <span className="scalloppay-s63">
                            <span className="scalloppay-s64">i</span>
                            <span className="scalloppay-s64">n</span>
                            <span className="scalloppay-s64">c</span>
                            <span className="scalloppay-s64">l</span>
                            <span className="scalloppay-s64">u</span>
                            <span className="scalloppay-s64">d</span>
                            <span className="scalloppay-s64">e</span>
                            <span className="scalloppay-s64">d</span>
                          </span>{' '}
                          <span className="scalloppay-s63">
                            <span className="scalloppay-s64">i</span>
                            <span className="scalloppay-s64">n</span>
                          </span>{' '}
                          <span className="scalloppay-s63">
                            <span className="scalloppay-s64">e</span>
                            <span className="scalloppay-s64">v</span>
                            <span className="scalloppay-s64">e</span>
                            <span className="scalloppay-s64">r</span>
                            <span className="scalloppay-s64">y</span>
                          </span>{' '}
                          <span className="scalloppay-s63">
                            <span className="scalloppay-s64">p</span>
                            <span className="scalloppay-s64">l</span>
                            <span className="scalloppay-s64">a</span>
                            <span className="scalloppay-s64">n</span>
                          </span>
                        </p>
                      </div>
                      <div
                        className="framer-1q7a1e"
                        data-framer-name="Plan Buttons"
                      >
                        <div className="framer-rk9jht-container">
                          <div
                            className="framer-uIx4h framer-ykqhhg framer-v-ykqhhg scalloppay-s65"
                            data-framer-name="Variant 1"
                          >
                            <div className="framer-1wuw3je">
                              <div
                                className="framer-1uvb7g8 scalloppay-s66 reveal"
                                data-framer-name="Plan Name"
                                data-framer-component-type="RichTextContainer"
                              >
                                <h5
                                  dir="auto"
                                  className="framer-text scalloppay-s67"
                                >
                                  Scallop Pay
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="framer-14zvt7h-container">
                          <div
                            className="framer-uIx4h framer-ykqhhg framer-v-ykqhhg scalloppay-s65"
                            data-framer-name="Variant 1"
                          >
                            <div className="framer-1wuw3je">
                              <div
                                className="framer-1uvb7g8 scalloppay-s66 reveal"
                                data-framer-name="Plan Name"
                                data-framer-component-type="RichTextContainer"
                              >
                                <h5
                                  dir="auto"
                                  className="framer-text scalloppay-s67"
                                >
                                  Traditional Cards
                                </h5>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-vsjbyh-container hidden-xsaq5o">
                      <ul
                        className="framer-D6rRd framer-hn7heh framer-v-hn7heh scalloppay-s3"
                        data-framer-name="Desktop"
                      >
                        <li className="framer-16h3wtx" data-framer-name="Table">
                          <div className="framer-1qgl83x-container">
                            <div
                              className="framer-onkl2 framer-17syfd5 framer-v-17syfd5 scalloppay-s68"
                              data-framer-name="Desktop - Variant 1"
                            >
                              <div
                                className="framer-d4km2x scalloppay-s69 reveal"
                                data-framer-name="Feature Name"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s70"
                                >
                                  Pay where cards are not accepted
                                </p>
                              </div>
                              <div
                                className="framer-1txa564"
                                data-framer-name="3"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Frame"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-12c4ez4 scalloppay-s46"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer scalloppay-s47">
                                    <svg
                                      viewBox="0 0 32 32"
                                      className="scalloppay-s48"
                                    >
                                      <use href="#svg-892036779_709" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-12rfxzq"
                                data-framer-name="4"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Frame"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1t2t180 scalloppay-s46"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer scalloppay-s47">
                                    <svg
                                      viewBox="0 0 32 32"
                                      className="scalloppay-s48"
                                    >
                                      <use href="#svg-1469766317_873" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="framer-1ff14az-container">
                            <div
                              className="framer-onkl2 framer-17syfd5 framer-v-1e308x7 scalloppay-s71"
                              data-framer-name="Desktop - Variant 2"
                            >
                              <div
                                className="framer-d4km2x scalloppay-s69 reveal"
                                data-framer-name="Feature Name"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s70"
                                >
                                  No need for local currency balances
                                </p>
                              </div>
                              <div
                                className="framer-1txa564"
                                data-framer-name="3"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Frame"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-12c4ez4 scalloppay-s46"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer scalloppay-s47">
                                    <svg
                                      viewBox="0 0 32 32"
                                      className="scalloppay-s48"
                                    >
                                      <use href="#svg-892036779_709" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-12rfxzq"
                                data-framer-name="4"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Frame"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1t2t180 scalloppay-s46"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer scalloppay-s47">
                                    <svg
                                      viewBox="0 0 32 32"
                                      className="scalloppay-s48"
                                    >
                                      <use href="#svg-1469766317_873" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="framer-1kjsl3e-container">
                            <div
                              className="framer-onkl2 framer-17syfd5 framer-v-17syfd5 scalloppay-s68"
                              data-framer-name="Desktop - Variant 1"
                            >
                              <div
                                className="framer-d4km2x scalloppay-s69 reveal"
                                data-framer-name="Feature Name"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s70"
                                >
                                  No switching between apps
                                </p>
                              </div>
                              <div
                                className="framer-1txa564"
                                data-framer-name="3"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Frame"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-12c4ez4 scalloppay-s46"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer scalloppay-s47">
                                    <svg
                                      viewBox="0 0 32 32"
                                      className="scalloppay-s48"
                                    >
                                      <use href="#svg-892036779_709" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-12rfxzq"
                                data-framer-name="4"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Frame"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1t2t180 scalloppay-s46"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer scalloppay-s47">
                                    <svg
                                      viewBox="0 0 32 32"
                                      className="scalloppay-s48"
                                    >
                                      <use href="#svg-1469766317_873" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="framer-1en9xn-container">
                            <div
                              className="framer-onkl2 framer-17syfd5 framer-v-1e308x7 scalloppay-s71"
                              data-framer-name="Desktop - Variant 2"
                            >
                              <div
                                className="framer-d4km2x scalloppay-s69 reveal"
                                data-framer-name="Feature Name"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p
                                  dir="auto"
                                  className="framer-text scalloppay-s70"
                                >
                                  Use one unified balance globally
                                </p>
                              </div>
                              <div
                                className="framer-1txa564"
                                data-framer-name="3"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Frame"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-12c4ez4 scalloppay-s46"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer scalloppay-s47">
                                    <svg
                                      viewBox="0 0 32 32"
                                      className="scalloppay-s48"
                                    >
                                      <use href="#svg-892036779_709" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="framer-12rfxzq"
                                data-framer-name="4"
                              >
                                <div
                                  data-framer-component-type="SVG"
                                  data-framer-name="Frame"
                                  parentsize="0"
                                  _constraints="[object Object]"
                                  rotation="0"
                                  shadows=""
                                  className="framer-1t2t180 scalloppay-s46"
                                  aria-hidden="true"
                                >
                                  <div className="svgContainer scalloppay-s47">
                                    <svg
                                      viewBox="0 0 32 32"
                                      className="scalloppay-s48"
                                    >
                                      <use href="#svg-1469766317_873" />
                                    </svg>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div
                      className="framer-7kl7d6 hidden-1epkjq8 hidden-c4t5yq scalloppay-s72"
                      data-framer-name="Mobile"
                    >
                      <div
                        className="framer-1l33nn3 scalloppay-s49 reveal"
                        data-framer-name="Feature Name"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s73">
                          Zero-Knowledge
                        </p>
                        <p dir="auto" className="framer-text scalloppay-s73">
                          Encryption
                        </p>
                      </div>
                      <div className="framer-zt0oe8" data-framer-name="3">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-igtcm3 scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 32 32" className="scalloppay-s48">
                              <use href="#svg-892036779_709" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="framer-b4zcvw" data-framer-name="4">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-4xrn7a scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 32 32" className="scalloppay-s48">
                              <use href="#svg-1469766317_873" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-vqvd57 hidden-1epkjq8 hidden-c4t5yq scalloppay-s72"
                      data-framer-name="Mobile"
                    >
                      <div
                        className="framer-poz6i1 scalloppay-s49 reveal"
                        data-framer-name="Feature Name"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s73">
                          No need for local
                        </p>
                        <p dir="auto" className="framer-text scalloppay-s73">
                          currency balances
                        </p>
                      </div>
                      <div className="framer-1n3vprm" data-framer-name="3">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-dbhfmu scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 32 32" className="scalloppay-s48">
                              <use href="#svg-892036779_709" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="framer-ei2n7d" data-framer-name="4">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-18xwut2 scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 32 32" className="scalloppay-s48">
                              <use href="#svg-1469766317_873" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1nxcczu hidden-1epkjq8 hidden-c4t5yq scalloppay-s72"
                      data-framer-name="Mobile"
                    >
                      <div
                        className="framer-15ua86u scalloppay-s49 reveal"
                        data-framer-name="Feature Name"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s73">
                          No switching between apps
                        </p>
                      </div>
                      <div className="framer-154av6w" data-framer-name="3">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-vzj6xf scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 32 32" className="scalloppay-s48">
                              <use href="#svg-892036779_709" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="framer-1fyr3y8" data-framer-name="4">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ari5ar scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 32 32" className="scalloppay-s48">
                              <use href="#svg-1469766317_873" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-707f4j hidden-1epkjq8 hidden-c4t5yq scalloppay-s72"
                      data-framer-name="Mobile"
                    >
                      <div
                        className="framer-1gjpszk scalloppay-s49 reveal"
                        data-framer-name="Feature Name"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s73">
                          Use one unified balance globally
                        </p>
                      </div>
                      <div className="framer-15axyup" data-framer-name="3">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1slagqb scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 32 32" className="scalloppay-s48">
                              <use href="#svg-892036779_709" />
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="framer-b2lhka" data-framer-name="4">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="Frame"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1jurkqi scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 32 32" className="scalloppay-s48">
                              <use href="#svg-1469766317_873" />
                            </svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
                <div
                  className="framer-11aaodm scalloppay-s74"
                  data-framer-name="Section/Comparison"
                  id="11aaodm"
                >
                  <div className="scalloppay-s75">
                    <div className="framer-4yzdag" data-framer-name="Container">
                      <div
                        className="framer-194jqig"
                        data-framer-name="Plan Header"
                      >
                        <div
                          className="framer-vcqj1k hidden-xsaq5o scalloppay-s49 reveal"
                          data-framer-name="Title"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s62">
                            <span className="scalloppay-s63">
                              <span className="scalloppay-s64">F</span>
                              <span className="scalloppay-s64">e</span>
                              <span className="scalloppay-s64">a</span>
                              <span className="scalloppay-s64">t</span>
                              <span className="scalloppay-s64">u</span>
                              <span className="scalloppay-s64">r</span>
                              <span className="scalloppay-s64">e</span>
                              <span className="scalloppay-s64">s</span>
                            </span>{' '}
                            <span className="scalloppay-s63">
                              <span className="scalloppay-s64">i</span>
                              <span className="scalloppay-s64">n</span>
                              <span className="scalloppay-s64">c</span>
                              <span className="scalloppay-s64">l</span>
                              <span className="scalloppay-s64">u</span>
                              <span className="scalloppay-s64">d</span>
                              <span className="scalloppay-s64">e</span>
                              <span className="scalloppay-s64">d</span>
                            </span>{' '}
                            <span className="scalloppay-s63">
                              <span className="scalloppay-s64">i</span>
                              <span className="scalloppay-s64">n</span>
                            </span>{' '}
                            <span className="scalloppay-s63">
                              <span className="scalloppay-s64">e</span>
                              <span className="scalloppay-s64">v</span>
                              <span className="scalloppay-s64">e</span>
                              <span className="scalloppay-s64">r</span>
                              <span className="scalloppay-s64">y</span>
                            </span>{' '}
                            <span className="scalloppay-s63">
                              <span className="scalloppay-s64">p</span>
                              <span className="scalloppay-s64">l</span>
                              <span className="scalloppay-s64">a</span>
                              <span className="scalloppay-s64">n</span>
                            </span>
                          </p>
                        </div>
                        <div
                          className="framer-1q7a1e"
                          data-framer-name="Plan Buttons"
                        >
                          <div className="framer-rk9jht-container">
                            <div
                              className="framer-uIx4h framer-ykqhhg framer-v-ykqhhg scalloppay-s76"
                              data-framer-name="Variant 1"
                            >
                              <div className="framer-1wuw3je">
                                <div
                                  className="framer-1uvb7g8 scalloppay-s66 reveal"
                                  data-framer-name="Plan Name"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <h5
                                    dir="auto"
                                    className="framer-text scalloppay-s67"
                                  >
                                    Pay
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="framer-14zvt7h-container">
                            <div
                              className="framer-uIx4h framer-ykqhhg framer-v-ykqhhg scalloppay-s76"
                              data-framer-name="Variant 1"
                            >
                              <div className="framer-1wuw3je">
                                <div
                                  className="framer-1uvb7g8 scalloppay-s66 reveal"
                                  data-framer-name="Plan Name"
                                  data-framer-component-type="RichTextContainer"
                                >
                                  <h5
                                    dir="auto"
                                    className="framer-text scalloppay-s67"
                                  >
                                    Cards
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-7kl7d6 hidden-1epkjq8 hidden-c4t5yq scalloppay-s72"
                        data-framer-name="Mobile"
                      >
                        <div
                          className="framer-1l33nn3 scalloppay-s49 reveal"
                          data-framer-name="Feature Name"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s73">
                            Zero-Knowledge
                          </p>
                          <p dir="auto" className="framer-text scalloppay-s73">
                            Encryption
                          </p>
                        </div>
                        <div className="framer-zt0oe8" data-framer-name="3">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-igtcm3 scalloppay-s46"
                            aria-hidden="true"
                          >
                            <div className="svgContainer scalloppay-s47">
                              <svg
                                viewBox="0 0 32 32"
                                className="scalloppay-s48"
                              >
                                <use href="#svg-892036779_709" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div className="framer-b4zcvw" data-framer-name="4">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-4xrn7a scalloppay-s46"
                            aria-hidden="true"
                          >
                            <div className="svgContainer scalloppay-s47">
                              <svg
                                viewBox="0 0 32 32"
                                className="scalloppay-s48"
                              >
                                <use href="#svg-1469766317_873" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-vqvd57 hidden-1epkjq8 hidden-c4t5yq scalloppay-s72"
                        data-framer-name="Mobile"
                      >
                        <div
                          className="framer-poz6i1 scalloppay-s49 reveal"
                          data-framer-name="Feature Name"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s73">
                            No need for local
                          </p>
                          <p dir="auto" className="framer-text scalloppay-s73">
                            currency balances
                          </p>
                        </div>
                        <div className="framer-1n3vprm" data-framer-name="3">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-dbhfmu scalloppay-s46"
                            aria-hidden="true"
                          >
                            <div className="svgContainer scalloppay-s47">
                              <svg
                                viewBox="0 0 32 32"
                                className="scalloppay-s48"
                              >
                                <use href="#svg-892036779_709" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div className="framer-ei2n7d" data-framer-name="4">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-18xwut2 scalloppay-s46"
                            aria-hidden="true"
                          >
                            <div className="svgContainer scalloppay-s47">
                              <svg
                                viewBox="0 0 32 32"
                                className="scalloppay-s48"
                              >
                                <use href="#svg-1469766317_873" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-1nxcczu hidden-1epkjq8 hidden-c4t5yq scalloppay-s72"
                        data-framer-name="Mobile"
                      >
                        <div
                          className="framer-15ua86u scalloppay-s49 reveal"
                          data-framer-name="Feature Name"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s73">
                            No switching between apps
                          </p>
                        </div>
                        <div className="framer-154av6w" data-framer-name="3">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-vzj6xf scalloppay-s46"
                            aria-hidden="true"
                          >
                            <div className="svgContainer scalloppay-s47">
                              <svg
                                viewBox="0 0 32 32"
                                className="scalloppay-s48"
                              >
                                <use href="#svg-892036779_709" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div className="framer-1fyr3y8" data-framer-name="4">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1ari5ar scalloppay-s46"
                            aria-hidden="true"
                          >
                            <div className="svgContainer scalloppay-s47">
                              <svg
                                viewBox="0 0 32 32"
                                className="scalloppay-s48"
                              >
                                <use href="#svg-1469766317_873" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-707f4j hidden-1epkjq8 hidden-c4t5yq scalloppay-s72"
                        data-framer-name="Mobile"
                      >
                        <div
                          className="framer-1gjpszk scalloppay-s49 reveal"
                          data-framer-name="Feature Name"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s73">
                            Use one unified balance globally
                          </p>
                        </div>
                        <div className="framer-15axyup" data-framer-name="3">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1slagqb scalloppay-s46"
                            aria-hidden="true"
                          >
                            <div className="svgContainer scalloppay-s47">
                              <svg
                                viewBox="0 0 32 32"
                                className="scalloppay-s48"
                              >
                                <use href="#svg-892036779_709" />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div className="framer-b2lhka" data-framer-name="4">
                          <div
                            data-framer-component-type="SVG"
                            data-framer-name="Frame"
                            parentsize="0"
                            _constraints="[object Object]"
                            rotation="0"
                            shadows=""
                            className="framer-1jurkqi scalloppay-s46"
                            aria-hidden="true"
                          >
                            <div className="svgContainer scalloppay-s47">
                              <svg
                                viewBox="0 0 32 32"
                                className="scalloppay-s48"
                              >
                                <use href="#svg-1469766317_873" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="scalloppay-s75" />
                </div>
              </div>
            </div>
            <div className="framer-ielux8" data-framer-name="Pay Global ">
              <div className="framer-389dmo" data-framer-name="Container">
                <div className="framer-t2dpz8" data-framer-name="Container">
                  <div className="ssr-variant hidden-xsaq5o">
                    <div
                      className="framer-ok8ki3 scalloppay-s32 reveal"
                      data-framer-name="One balance"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s77">
                        One balance
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
                    <div
                      className="framer-ok8ki3 scalloppay-s30 reveal"
                      data-framer-name="One balance"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s77">
                        One balance
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-ufuw3s scalloppay-s78 reveal"
                    data-framer-name="Swap between currencies and digital assets in seco"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s79">
                      Use the entire balance in one account instead of spreading
                      funds.
                    </p>
                  </div>
                  <div
                    data-framer-component-type="SVG"
                    data-framer-name="Container"
                    parentsize="0"
                    _constraints="[object Object]"
                    rotation="0"
                    shadows=""
                    className="framer-qlf6in scalloppay-s46"
                    aria-hidden="true"
                  >
                    <div className="svgContainer scalloppay-s47">
                      <svg viewBox="0 0 48 48" className="scalloppay-s48">
                        <use href="#svg350258615_1351" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="framer-qetnoe" data-framer-name="Container">
                  <div className="ssr-variant hidden-xsaq5o">
                    <div
                      className="framer-191onp5 scalloppay-s32 reveal"
                      data-framer-name="No local accounts"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s77">
                        No local accounts
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
                    <div
                      className="framer-191onp5 scalloppay-s30 reveal"
                      data-framer-name="No local accounts"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s77">
                        No local accounts
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-l1ecvc scalloppay-s78 reveal"
                    data-framer-name="Swap between currencies and digital assets in seco"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s79">
                      Access funds locally without needing to open or maintain
                      separate bank accounts.
                    </p>
                  </div>
                  <div
                    data-framer-component-type="SVG"
                    data-framer-name="Container"
                    parentsize="0"
                    _constraints="[object Object]"
                    rotation="0"
                    shadows=""
                    className="framer-qfmmuu scalloppay-s46"
                    aria-hidden="true"
                  >
                    <div className="svgContainer scalloppay-s47">
                      <svg viewBox="0 0 48 48" className="scalloppay-s48">
                        <use href="#svg-1385710129_1267" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="framer-18ba86n" data-framer-name="Container">
                  <div
                    className="framer-1nuiweb scalloppay-s32 reveal"
                    data-framer-name="Automatic FX"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s80">
                      Automatic FX
                    </p>
                  </div>
                  <div
                    className="framer-x7ass5 scalloppay-s78 reveal"
                    data-framer-name="Swap between currencies and digital assets in seco"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s79">
                      Convert different currencies instantly at current exchange
                      rates in real time.
                    </p>
                  </div>
                  <div
                    data-framer-component-type="SVG"
                    data-framer-name="Container"
                    parentsize="0"
                    _constraints="[object Object]"
                    rotation="0"
                    shadows=""
                    className="framer-3h6cql scalloppay-s46"
                    aria-hidden="true"
                  >
                    <div className="svgContainer scalloppay-s47">
                      <svg viewBox="0 0 48 48" className="scalloppay-s48">
                        <use href="#svg585653685_904" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="framer-csfm0h" data-framer-name="Container">
                  <div
                    className="framer-1da6ird scalloppay-s32 reveal"
                    data-framer-name="Fast processing"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s77">
                      Fast processing
                    </p>
                  </div>
                  <div
                    className="framer-qkkjqy scalloppay-s78 reveal"
                    data-framer-name="Swap between currencies and digital assets in seco"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s79">
                      Payments are processed through local networks for faster,
                      reliable transactions.
                    </p>
                  </div>
                  <div
                    data-framer-component-type="SVG"
                    data-framer-name="Container"
                    parentsize="0"
                    _constraints="[object Object]"
                    rotation="0"
                    shadows=""
                    className="framer-14f7ifi scalloppay-s46"
                    aria-hidden="true"
                  >
                    <div className="svgContainer scalloppay-s47">
                      <svg viewBox="0 0 48 48" className="scalloppay-s48">
                        <use href="#svg1436678953_1486" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="framer-uac0i8" data-framer-name="Container">
                  <div
                    className="framer-8y0aqi scalloppay-s32 reveal"
                    data-framer-name="Fully integrated"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s77">
                      Fully integrated
                    </p>
                  </div>
                  <div
                    className="framer-wlhx23 scalloppay-s78 reveal"
                    data-framer-name="Swap between currencies and digital assets in seco"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s79">
                      Everything is managed securely and conveniently within the
                      Scallop app.
                    </p>
                  </div>
                  <div
                    data-framer-component-type="SVG"
                    data-framer-name="Container"
                    parentsize="0"
                    _constraints="[object Object]"
                    rotation="0"
                    shadows=""
                    className="framer-auveah scalloppay-s46"
                    aria-hidden="true"
                  >
                    <div className="svgContainer scalloppay-s47">
                      <svg viewBox="0 0 48 48" className="scalloppay-s48">
                        <use href="#svg1697830745_861" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="framer-ewai7v" data-framer-name="Container">
                  <div className="ssr-variant hidden-xsaq5o">
                    <div
                      className="framer-1l3om3p scalloppay-s32 reveal"
                      data-framer-name="Available to all users"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s77">
                        Available to all users
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
                    <div
                      className="framer-1l3om3p scalloppay-s30 reveal"
                      data-framer-name="Available to all users"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s77">
                        Available to all users
                      </p>
                    </div>
                  </div>
                  <div
                    className="framer-h70wbq scalloppay-s78 reveal"
                    data-framer-name="Swap between currencies and digital assets in seco"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s79">
                      No limits or restrictions based on your selected plan or
                      tier.
                    </p>
                  </div>
                  <div
                    data-framer-component-type="SVG"
                    data-framer-name="Container"
                    parentsize="0"
                    _constraints="[object Object]"
                    rotation="0"
                    shadows=""
                    className="framer-f72srg scalloppay-s46"
                    aria-hidden="true"
                  >
                    <div className="svgContainer scalloppay-s47">
                      <svg viewBox="0 0 48 48" className="scalloppay-s48">
                        <use href="#svg-488446441_777" />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
              <div className="framer-lzo0g1" data-framer-name="Container">
                <div className="ssr-variant hidden-c4t5yq hidden-xsaq5o">
                  <div
                    className="framer-hm5w16 scalloppay-s23 reveal"
                    data-framer-name="One account. One balance. Built for global money."
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s43">
                      Everything you need to Pay Global
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1epkjq8">
                  <div
                    className="framer-hm5w16 scalloppay-s23 reveal"
                    data-framer-name="One account. One balance. Built for global money."
                    data-framer-component-type="RichTextContainer"
                  >
                    <h1
                      className="framer-text framer-styles-preset-18sajzf scalloppay-s44"
                      data-styles-preset="nXmNeSqma"
                      dir="auto"
                    >
                      Everything you need to Pay Global
                    </h1>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div
                    className="framer-10opksa scalloppay-s23 reveal"
                    data-framer-name="52+ fiat currencies and digital assets. One unifie"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s45">
                      Use Scallop Pay where cards don&rsquo;t work
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-1q71wr8" data-framer-name="Section">
              <div
                className="framer-1xky92q hidden-xsaq5o"
                data-framer-name="Container"
              >
                <div
                  className="framer-90mf3b scalloppay-s81"
                  data-border="true"
                  data-framer-name="Container"
                >
                  <div className="framer-1uj9ytt" data-framer-name="Paragraph">
                    <div
                      className="framer-lmp81k scalloppay-s49 reveal"
                      data-framer-name="You always see:"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s82">
                        You always see:
                      </p>
                    </div>
                  </div>
                  <div className="framer-11xrcs1" data-framer-name="Container">
                    <div
                      className="framer-4n3tce"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div className="framer-1abh6hz" data-framer-name="Text">
                        <div
                          className="framer-15mshe3 scalloppay-s49 reveal"
                          data-framer-name="Payment amount"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s82">
                            Payment amount
                          </p>
                        </div>
                      </div>
                      <div className="framer-1fv3wul" data-framer-name="Text">
                        <div
                          className="framer-qhd4ct scalloppay-s49 reveal"
                          data-framer-name="$50.00"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s83">
                            $50.00
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-ayj6ch"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div className="framer-1dh5efe" data-framer-name="Text">
                        <div
                          className="framer-1kb9188 scalloppay-s49 reveal"
                          data-framer-name="Exchange rate"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s82">
                            Exchange rate
                          </p>
                        </div>
                      </div>
                      <div className="framer-8k3jrp" data-framer-name="Text">
                        <div
                          className="framer-z1huk5 scalloppay-s49 reveal"
                          data-framer-name="1 USD = 56.50 PHP"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s83">
                            1 USD = 56.50 PHP
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-68xlo9"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div className="framer-1usk29" data-framer-name="Text">
                        <div
                          className="framer-1hnf9wy scalloppay-s49 reveal"
                          data-framer-name="Fees"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s82">
                            Fees
                          </p>
                        </div>
                      </div>
                      <div className="framer-1jnh6gy" data-framer-name="Text">
                        <div
                          className="framer-1nn7st0 scalloppay-s49 reveal"
                          data-framer-name="$0.99"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s83">
                            $0.99
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="framer-z8ksli" data-framer-name="Container">
                      <div className="framer-1646236" data-framer-name="Text">
                        <div
                          className="framer-wpte02 scalloppay-s49 reveal"
                          data-framer-name="Final total"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s84">
                            Final total
                          </p>
                        </div>
                      </div>
                      <div className="framer-1pdgesc" data-framer-name="Text">
                        <div
                          className="framer-17vkycr scalloppay-s49 reveal"
                          data-framer-name="$50.99"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s85">
                            $50.99
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="framer-166o5nh" data-framer-name="Paragraph">
                    <div
                      className="framer-ou9p4r scalloppay-s49 reveal"
                      data-framer-name="Fees follow standard payout pricing and are shown "
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s86">
                        Fees follow standard payout pricing and are shown before
                        confirmation
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-1rbzk92 scalloppay-s87"
                  data-border="true"
                  data-framer-name="Container"
                >
                  <div className="framer-1aqf09w" data-framer-name="Paragraph">
                    <div
                      className="framer-r1ohmq scalloppay-s49 reveal"
                      data-framer-name="You always see:"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s82">
                        You always see:
                      </p>
                    </div>
                  </div>
                  <div className="framer-i2ai3w" data-framer-name="Container">
                    <div
                      className="framer-1yga6e9"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div className="framer-nnm889" data-framer-name="Text">
                        <div
                          className="framer-1pll386 scalloppay-s49 reveal"
                          data-framer-name="Payment amount"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s82">
                            Payment amount
                          </p>
                        </div>
                      </div>
                      <div className="framer-1tmg5i" data-framer-name="Text">
                        <div
                          className="framer-4t3nly scalloppay-s49 reveal"
                          data-framer-name="$50.00"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s83">
                            $50.00
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1c23fcj"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div className="framer-1001d6p" data-framer-name="Text">
                        <div
                          className="framer-112zgq7 scalloppay-s49 reveal"
                          data-framer-name="Exchange rate"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s82">
                            Exchange rate
                          </p>
                        </div>
                      </div>
                      <div className="framer-1w1aecp" data-framer-name="Text">
                        <div
                          className="framer-140ovk5 scalloppay-s49 reveal"
                          data-framer-name="1 USD = 56.50 PHP"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s83">
                            1 USD = 56.50 PHP
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-wxj9dl"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div className="framer-s1lmek" data-framer-name="Text">
                        <div
                          className="framer-1jlxvlq scalloppay-s49 reveal"
                          data-framer-name="Fees"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s82">
                            Fees
                          </p>
                        </div>
                      </div>
                      <div className="framer-1n928tf" data-framer-name="Text">
                        <div
                          className="framer-1bbvcff scalloppay-s49 reveal"
                          data-framer-name="$0.99"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s83">
                            $0.99
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="framer-ub315e" data-framer-name="Container">
                      <div className="framer-xkmysi" data-framer-name="Text">
                        <div
                          className="framer-19wvxnt scalloppay-s49 reveal"
                          data-framer-name="Final total"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s84">
                            Final total
                          </p>
                        </div>
                      </div>
                      <div className="framer-1ki2r7t" data-framer-name="Text">
                        <div
                          className="framer-1be7jlg scalloppay-s49 reveal"
                          data-framer-name="$50.99"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s85">
                            $50.99
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="framer-129am7y" data-framer-name="Paragraph">
                    <div
                      className="framer-1plsv6m scalloppay-s49 reveal"
                      data-framer-name="Fees follow standard payout pricing and are shown "
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s86">
                        Fees follow standard payout pricing and are shown before
                        confirmation
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-4a14gr"
                  data-border="true"
                  data-framer-name="Frame 1707480008"
                >
                  <div
                    className="framer-4x93le"
                    data-border="true"
                    data-framer-name="Container"
                  >
                    <div className="framer-qscjxi" data-framer-name="Paragraph">
                      <div
                        className="framer-1k1o2ee scalloppay-s49 reveal"
                        data-framer-name="You always see:"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s88">
                          You always see:
                        </p>
                      </div>
                    </div>
                    <div className="framer-cnkjdx" data-framer-name="Container">
                      <div
                        className="framer-1js7i0j"
                        data-border="true"
                        data-framer-name="Container"
                      >
                        <div className="framer-1ns3k2t" data-framer-name="Text">
                          <div
                            className="framer-8qqyb2 scalloppay-s49 reveal"
                            data-framer-name="Payment amount"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s88"
                            >
                              Payment amount
                            </p>
                          </div>
                        </div>
                        <div className="framer-1tigg3e" data-framer-name="Text">
                          <div
                            className="framer-115h5ya scalloppay-s49 reveal"
                            data-framer-name="$50.00"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s89"
                            >
                              $50.00
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-1m921xd"
                        data-border="true"
                        data-framer-name="Container"
                      >
                        <div className="framer-8sgjz7" data-framer-name="Text">
                          <div
                            className="framer-hpggnk scalloppay-s49 reveal"
                            data-framer-name="Exchange rate"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s88"
                            >
                              Exchange rate
                            </p>
                          </div>
                        </div>
                        <div className="framer-hu4mo9" data-framer-name="Text">
                          <div
                            className="framer-1l8ky1q scalloppay-s49 reveal"
                            data-framer-name="1 USD = 56.50 PHP"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s89"
                            >
                              1 USD = 56.50 PHP
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-1yxppq"
                        data-border="true"
                        data-framer-name="Container"
                      >
                        <div className="framer-1fdfoy3" data-framer-name="Text">
                          <div
                            className="framer-12bbsbe scalloppay-s49 reveal"
                            data-framer-name="Fees"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s88"
                            >
                              Fees
                            </p>
                          </div>
                        </div>
                        <div className="framer-1nyc5cm" data-framer-name="Text">
                          <div
                            className="framer-1wqljb0 scalloppay-s49 reveal"
                            data-framer-name="$0.99"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s89"
                            >
                              $0.90
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-11bfk25"
                        data-framer-name="Container"
                      >
                        <div className="framer-v8ixnt" data-framer-name="Text">
                          <div
                            className="framer-1ftfmpv scalloppay-s49 reveal"
                            data-framer-name="Final total"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s90"
                            >
                              Final total
                            </p>
                          </div>
                        </div>
                        <div className="framer-raktje" data-framer-name="Text">
                          <div
                            className="framer-7cmelj scalloppay-s49 reveal"
                            data-framer-name="$50.99"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s91"
                            >
                              $50.90
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1ezj78m"
                      data-framer-name="Paragraph"
                    >
                      <div
                        className="framer-cctrzy scalloppay-s49 reveal"
                        data-framer-name="Fees follow standard payout pricing and are shown "
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s92">
                          Fees follow standard payout pricing and are shown
                          before confirmation
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="framer-1tf32rb" data-framer-name="Container">
                <div className="ssr-variant hidden-c4t5yq hidden-xsaq5o">
                  <div
                    className="framer-16s9aug scalloppay-s23 reveal"
                    data-framer-name="One account. One balance. Built for global money."
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s43">
                      Know exactly what you pay
                    </p>
                  </div>
                </div>
                <div className="ssr-variant hidden-1epkjq8">
                  <div
                    className="framer-16s9aug scalloppay-s23 reveal"
                    data-framer-name="One account. One balance. Built for global money."
                    data-framer-component-type="RichTextContainer"
                  >
                    <h1
                      className="framer-text framer-styles-preset-18sajzf scalloppay-s44"
                      data-styles-preset="nXmNeSqma"
                      dir="auto"
                    >
                      Know exactly what you pay
                    </h1>
                  </div>
                </div>
                <div className="ssr-variant">
                  <div
                    className="framer-hwu8gy scalloppay-s23 reveal"
                    data-framer-name="52+ fiat currencies and digital assets. One unifie"
                    data-framer-component-type="RichTextContainer"
                  >
                    <p dir="auto" className="framer-text scalloppay-s45">
                      Full transparency before every transaction
                    </p>
                  </div>
                </div>
              </div>
              <div
                className="framer-12xwpy3 hidden-1epkjq8 hidden-c4t5yq"
                data-framer-name="Container"
              >
                <div
                  className="framer-5dlv5u scalloppay-s81"
                  data-border="true"
                  data-framer-name="Container"
                >
                  <div className="framer-z7m0kp" data-framer-name="Paragraph">
                    <div
                      className="framer-1cwc6vy scalloppay-s49 reveal"
                      data-framer-name="You always see:"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s93">
                        You always see:
                      </p>
                    </div>
                  </div>
                  <div className="framer-k5mqqk" data-framer-name="Container">
                    <div
                      className="framer-16xhftv"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div className="framer-1bwhf6z" data-framer-name="Text">
                        <div
                          className="framer-4jk0mk scalloppay-s49 reveal"
                          data-framer-name="Payment amount"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s93">
                            Payment amount
                          </p>
                        </div>
                      </div>
                      <div className="framer-1vgtyv4" data-framer-name="Text">
                        <div
                          className="framer-1oeua8m scalloppay-s49 reveal"
                          data-framer-name="$50.00"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s94">
                            $50.00
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-13lkba9"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div className="framer-cz8zjv" data-framer-name="Text">
                        <div
                          className="framer-t2dw9p scalloppay-s49 reveal"
                          data-framer-name="Exchange rate"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s93">
                            Exchange rate
                          </p>
                        </div>
                      </div>
                      <div className="framer-f3zegl" data-framer-name="Text">
                        <div
                          className="framer-t94rgm scalloppay-s49 reveal"
                          data-framer-name="1 USD = 56.50 PHP"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s94">
                            1 USD = 56.50 PHP
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1gshy5j"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div className="framer-1jemhrq" data-framer-name="Text">
                        <div
                          className="framer-1u66pw2 scalloppay-s49 reveal"
                          data-framer-name="Fees"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s93">
                            Fees
                          </p>
                        </div>
                      </div>
                      <div className="framer-cvs0r1" data-framer-name="Text">
                        <div
                          className="framer-14sekwf scalloppay-s49 reveal"
                          data-framer-name="$0.99"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s94">
                            $0.99
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="framer-dez4xx" data-framer-name="Container">
                      <div className="framer-137rvsc" data-framer-name="Text">
                        <div
                          className="framer-19nstnn scalloppay-s49 reveal"
                          data-framer-name="Final total"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s95">
                            Final total
                          </p>
                        </div>
                      </div>
                      <div className="framer-75zn0x" data-framer-name="Text">
                        <div
                          className="framer-1n0mab6 scalloppay-s49 reveal"
                          data-framer-name="$50.99"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s96">
                            $50.99
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="framer-e91bcf" data-framer-name="Paragraph">
                    <div
                      className="framer-1d5ilv0 scalloppay-s49 reveal"
                      data-framer-name="Fees follow standard payout pricing and are shown "
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s97">
                        Fees follow standard payout pricing and are shown before
                        confirmation
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-151gy47 scalloppay-s87"
                  data-border="true"
                  data-framer-name="Container"
                >
                  <div className="framer-llpxzs" data-framer-name="Paragraph">
                    <div
                      className="framer-1owo0lh scalloppay-s49 reveal"
                      data-framer-name="You always see:"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s93">
                        You always see:
                      </p>
                    </div>
                  </div>
                  <div className="framer-s5r2iw" data-framer-name="Container">
                    <div
                      className="framer-1vafgnf"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div className="framer-170n5fq" data-framer-name="Text">
                        <div
                          className="framer-1c8kf1w scalloppay-s49 reveal"
                          data-framer-name="Payment amount"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s93">
                            Payment amount
                          </p>
                        </div>
                      </div>
                      <div className="framer-ugox98" data-framer-name="Text">
                        <div
                          className="framer-1afvwg5 scalloppay-s49 reveal"
                          data-framer-name="$50.00"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s94">
                            $50.00
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-211c92"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div className="framer-kv4fws" data-framer-name="Text">
                        <div
                          className="framer-1bqukf9 scalloppay-s49 reveal"
                          data-framer-name="Exchange rate"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s93">
                            Exchange rate
                          </p>
                        </div>
                      </div>
                      <div className="framer-15m06of" data-framer-name="Text">
                        <div
                          className="framer-1g8aqyv scalloppay-s49 reveal"
                          data-framer-name="1 USD = 56.50 PHP"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s94">
                            1 USD = 56.50 PHP
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-19o51eu"
                      data-border="true"
                      data-framer-name="Container"
                    >
                      <div className="framer-285zka" data-framer-name="Text">
                        <div
                          className="framer-1k05vkn scalloppay-s49 reveal"
                          data-framer-name="Fees"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s93">
                            Fees
                          </p>
                        </div>
                      </div>
                      <div className="framer-iv3ya7" data-framer-name="Text">
                        <div
                          className="framer-10ue4fd scalloppay-s49 reveal"
                          data-framer-name="$0.99"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s94">
                            $0.99
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="framer-1hz4uno"
                      data-framer-name="Container"
                    >
                      <div className="framer-1xe5a0l" data-framer-name="Text">
                        <div
                          className="framer-14o5zps scalloppay-s49 reveal"
                          data-framer-name="Final total"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s95">
                            Final total
                          </p>
                        </div>
                      </div>
                      <div className="framer-gyo7m8" data-framer-name="Text">
                        <div
                          className="framer-1321c4k scalloppay-s49 reveal"
                          data-framer-name="$50.99"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s96">
                            $50.99
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="framer-1c14g3c" data-framer-name="Paragraph">
                    <div
                      className="framer-kdnf5p scalloppay-s49 reveal"
                      data-framer-name="Fees follow standard payout pricing and are shown "
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s97">
                        Fees follow standard payout pricing and are shown before
                        confirmation
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-zneik3"
                  data-border="true"
                  data-framer-name="Frame 1707480008"
                >
                  <div
                    className="framer-1y8qjdc"
                    data-border="true"
                    data-framer-name="Container"
                  >
                    <div
                      className="framer-1ei64ns"
                      data-framer-name="Paragraph"
                    >
                      <div
                        className="framer-1sjv1mf scalloppay-s49 reveal"
                        data-framer-name="You always see:"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s98">
                          You always see:
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-1sl98ea"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-fqtxm"
                        data-border="true"
                        data-framer-name="Container"
                      >
                        <div className="framer-hetju7" data-framer-name="Text">
                          <div
                            className="framer-1wgqk5x scalloppay-s49 reveal"
                            data-framer-name="Payment amount"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s98"
                            >
                              Payment amount
                            </p>
                          </div>
                        </div>
                        <div className="framer-1jp8qd1" data-framer-name="Text">
                          <div
                            className="framer-1al6muq scalloppay-s49 reveal"
                            data-framer-name="$50.00"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s99"
                            >
                              $50.00
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-1m5hezd"
                        data-border="true"
                        data-framer-name="Container"
                      >
                        <div className="framer-4ues77" data-framer-name="Text">
                          <div
                            className="framer-1lhbblo scalloppay-s49 reveal"
                            data-framer-name="Exchange rate"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s98"
                            >
                              Exchange rate
                            </p>
                          </div>
                        </div>
                        <div className="framer-u5el8r" data-framer-name="Text">
                          <div
                            className="framer-g4yh54 scalloppay-s49 reveal"
                            data-framer-name="1 USD = 56.50 PHP"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s99"
                            >
                              1 USD = 56.50 PHP
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-1cfrxd9"
                        data-border="true"
                        data-framer-name="Container"
                      >
                        <div className="framer-1ti5phs" data-framer-name="Text">
                          <div
                            className="framer-zhoefg scalloppay-s49 reveal"
                            data-framer-name="Fees"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s98"
                            >
                              Fees
                            </p>
                          </div>
                        </div>
                        <div className="framer-nfn348" data-framer-name="Text">
                          <div
                            className="framer-1q9ydvk scalloppay-s49 reveal"
                            data-framer-name="$0.99"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s99"
                            >
                              $0.99
                            </p>
                          </div>
                        </div>
                      </div>
                      <div
                        className="framer-s8qybh"
                        data-framer-name="Container"
                      >
                        <div className="framer-wmhas1" data-framer-name="Text">
                          <div
                            className="framer-1pvzk34 scalloppay-s49 reveal"
                            data-framer-name="Final total"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s100"
                            >
                              Final total
                            </p>
                          </div>
                        </div>
                        <div className="framer-1x0pfaz" data-framer-name="Text">
                          <div
                            className="framer-1bq56lz scalloppay-s49 reveal"
                            data-framer-name="$50.99"
                            data-framer-component-type="RichTextContainer"
                          >
                            <p
                              dir="auto"
                              className="framer-text scalloppay-s101"
                            >
                              $50.99
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="framer-r9kvf8" data-framer-name="Paragraph">
                      <div
                        className="framer-ostmeh scalloppay-s49 reveal"
                        data-framer-name="Fees follow standard payout pricing and are shown "
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s102">
                          Fees follow standard payout pricing and are shown
                          before confirmation
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="framer-mb1a7m" data-framer-name="Section">
              <div className="framer-18tznti" data-framer-name="Container" />
              <div className="framer-1fogbcp" data-framer-name="Container" />
              <div className="ssr-variant hidden-c4t5yq">
                <div
                  className="framer-tf80ia scalloppay-s2"
                  data-framer-name="Frame 1707479927"
                >
                  <div className="framer-17bhluj">
                    <div className="framer-giem2o" data-framer-name="Container">
                      <div
                        className="framer-1qwdxyy"
                        data-framer-name="image 1635"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="192"
                            height="192"
                            src="/framerusercontent.com/images/JGMep6QploauvOd9OnSel8QELAA.png"
                            alt=""
                            className="scalloppay-s41"
                          />
                        </div>
                      </div>
                      <div
                        className="framer-v00kup scalloppay-s49 reveal"
                        data-framer-name="Secure infrastructure"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s103">
                          Secure infrastructure
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-16wcoqm"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-z3dagz"
                        data-framer-name="image 1636"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="192"
                            height="192"
                            src="/framerusercontent.com/images/BBUwESXNKsGwkWtuXwmivE6QU.png"
                            alt=""
                            className="scalloppay-s41"
                          />
                        </div>
                      </div>
                      <div
                        className="framer-5jla7k scalloppay-s49 reveal"
                        data-framer-name="Identity verification"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s103">
                          Identity verification
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="framer-kebzvj">
                    <div className="framer-glp5ql" data-framer-name="Container">
                      <div
                        className="framer-162x8k2"
                        data-framer-name="image 1637"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="192"
                            height="192"
                            src="/framerusercontent.com/images/L9oLiolbNLFjukaBhV6yAl5M.png"
                            alt=""
                            className="scalloppay-s41"
                          />
                        </div>
                      </div>
                      <div
                        className="framer-1dzwlwi scalloppay-s49 reveal"
                        data-framer-name="Transaction monitoring"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s103">
                          Transaction monitoring
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-1g081gq"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-134nliu"
                        data-framer-name="image 1639"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="1024"
                            height="1024"
                            sizes="(min-width: 1440px) 48px, (max-width: 809.98px) 48px, (min-width: 810px) and (max-width: 1439.98px) 48px"
                            srcSet="/framerusercontent.com/images/RVxEu7zEx7DMEN7RXXRcM4jRQHI.png 512w,/framerusercontent.com/images/RVxEu7zEx7DMEN7RXXRcM4jRQHI.png 1024w"
                            src="/framerusercontent.com/images/RVxEu7zEx7DMEN7RXXRcM4jRQHI.png"
                            alt=""
                            className="scalloppay-s35"
                          />
                        </div>
                      </div>
                      <div
                        className="framer-8ja6j1 scalloppay-s49 reveal"
                        data-framer-name="Real-time alerts"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s103">
                          Real-time alerts
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-1epkjq8 hidden-xsaq5o">
                <div
                  className="framer-tf80ia"
                  data-framer-name="Frame 1707479927"
                >
                  <div className="framer-17bhluj">
                    <div className="framer-giem2o" data-framer-name="Container">
                      <div
                        className="framer-1qwdxyy"
                        data-framer-name="image 1635"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="192"
                            height="192"
                            src="/framerusercontent.com/images/JGMep6QploauvOd9OnSel8QELAA.png"
                            alt=""
                            className="scalloppay-s41"
                          />
                        </div>
                      </div>
                      <div
                        className="framer-v00kup scalloppay-s49 reveal"
                        data-framer-name="Secure infrastructure"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s103">
                          Secure infrastructure
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-16wcoqm"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-z3dagz"
                        data-framer-name="image 1636"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="192"
                            height="192"
                            src="/framerusercontent.com/images/BBUwESXNKsGwkWtuXwmivE6QU.png"
                            alt=""
                            className="scalloppay-s41"
                          />
                        </div>
                      </div>
                      <div
                        className="framer-5jla7k scalloppay-s49 reveal"
                        data-framer-name="Identity verification"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s103">
                          Identity verification
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="framer-kebzvj">
                    <div className="framer-glp5ql" data-framer-name="Container">
                      <div
                        className="framer-162x8k2"
                        data-framer-name="image 1637"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="192"
                            height="192"
                            src="/framerusercontent.com/images/L9oLiolbNLFjukaBhV6yAl5M.png"
                            alt=""
                            className="scalloppay-s41"
                          />
                        </div>
                      </div>
                      <div
                        className="framer-1dzwlwi scalloppay-s49 reveal"
                        data-framer-name="Transaction monitoring"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s103">
                          Transaction monitoring
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-1g081gq"
                      data-framer-name="Container"
                    >
                      <div
                        className="framer-134nliu"
                        data-framer-name="image 1639"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            loading="lazy"
                            width="1024"
                            height="1024"
                            sizes="(min-width: 1440px) 48px, (max-width: 809.98px) 48px, (min-width: 810px) and (max-width: 1439.98px) 48px"
                            srcSet="/framerusercontent.com/images/RVxEu7zEx7DMEN7RXXRcM4jRQHI.png 512w,/framerusercontent.com/images/RVxEu7zEx7DMEN7RXXRcM4jRQHI.png 1024w"
                            src="/framerusercontent.com/images/RVxEu7zEx7DMEN7RXXRcM4jRQHI.png"
                            alt=""
                            className="scalloppay-s35"
                          />
                        </div>
                      </div>
                      <div
                        className="framer-8ja6j1 scalloppay-s49 reveal"
                        data-framer-name="Real-time alerts"
                        data-framer-component-type="RichTextContainer"
                      >
                        <p dir="auto" className="framer-text scalloppay-s103">
                          Real-time alerts
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="ssr-variant hidden-c4t5yq hidden-xsaq5o">
                <div
                  className="framer-803k0 scalloppay-s30 reveal"
                  data-framer-name="Everything runs in one place. No fragmentation. No"
                  data-framer-component-type="RichTextContainer"
                >
                  <p dir="auto" className="framer-text scalloppay-s104">
                    Every transaction is protected and verified
                  </p>
                </div>
              </div>
              <div className="ssr-variant hidden-1epkjq8">
                <div
                  className="framer-803k0 scalloppay-s32 reveal"
                  data-framer-name="Everything runs in one place. No fragmentation. No"
                  data-framer-component-type="RichTextContainer"
                >
                  <p dir="auto" className="framer-text scalloppay-s104">
                    Every transaction is protected and verified
                  </p>
                </div>
              </div>
              <div className="ssr-variant hidden-c4t5yq hidden-xsaq5o">
                <div
                  className="framer-1isqxfp scalloppay-s105 reveal"
                  data-framer-name="Built for how money actually moves"
                  data-framer-component-type="RichTextContainer"
                >
                  <p dir="auto" className="framer-text scalloppay-s24">
                    Built with Security AT THE cORE
                  </p>
                </div>
              </div>
              <div className="ssr-variant hidden-1epkjq8 hidden-xsaq5o">
                <div
                  className="framer-1isqxfp scalloppay-s105 reveal"
                  data-framer-name="Built for how money actually moves"
                  data-framer-component-type="RichTextContainer"
                >
                  <h1
                    className="framer-text framer-styles-preset-18sajzf scalloppay-s26"
                    data-styles-preset="nXmNeSqma"
                    dir="auto"
                  >
                    Built with Security AT THE cORE
                  </h1>
                </div>
              </div>
              <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
                <div
                  className="framer-1isqxfp scalloppay-s23 reveal"
                  data-framer-name="Built for how money actually moves"
                  data-framer-component-type="RichTextContainer"
                >
                  <h1 dir="auto" className="framer-text scalloppay-s106">
                    Built with Security AT THE cORE
                  </h1>
                </div>
              </div>
            </div>
            <div className="framer-kqastt" data-framer-name="Section">
              <div className="framer-1m5bvlf" data-framer-name="Heading 2">
                <div
                  className="framer-qbnf9a"
                  data-framer-name="Frame 1707480010"
                >
                  <div className="ssr-variant hidden-c4t5yq hidden-xsaq5o">
                    <div
                      className="framer-1edr55y scalloppay-s2"
                      data-framer-name="image 1642"
                    >
                      <div
                        data-framer-background-image-wrapper="true"
                        className="scalloppay-s34"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="400"
                          height="1024"
                          sizes="(min-width: 1440px) 159px, (min-width: 810px) and (max-width: 1439.98px) 159px, (max-width: 809.98px) 101.0758px"
                          srcSet="/framerusercontent.com/images/XBQH44yRRglqVnctKwIVVq3o.png 400w"
                          src="/framerusercontent.com/images/XBQH44yRRglqVnctKwIVVq3o.png"
                          alt=""
                          className="scalloppay-s41"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-1epkjq8">
                    <div
                      className="framer-1edr55y"
                      data-framer-name="image 1642"
                    >
                      <div
                        data-framer-background-image-wrapper="true"
                        className="scalloppay-s34"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="400"
                          height="1024"
                          sizes="(min-width: 1440px) 159px, (min-width: 810px) and (max-width: 1439.98px) 159px, (max-width: 809.98px) 101.0758px"
                          srcSet="/framerusercontent.com/images/XBQH44yRRglqVnctKwIVVq3o.png 400w"
                          src="/framerusercontent.com/images/XBQH44yRRglqVnctKwIVVq3o.png"
                          alt=""
                          className="scalloppay-s41"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="ssr-variant">
                    <div
                      className="framer-1b5e3is"
                      data-framer-name="image 1641"
                    >
                      <div
                        data-framer-background-image-wrapper="true"
                        className="scalloppay-s34"
                      >
                        <img
                          decoding="async"
                          loading="lazy"
                          width="700"
                          height="1308"
                          sizes="(min-width: 1440px) 175px, (min-width: 810px) and (max-width: 1439.98px) 175px, (max-width: 809.98px) 111px"
                          srcSet="/framerusercontent.com/images/1Fd77C99CaM0z4LCY00Cnq0raw.png 548w,/framerusercontent.com/images/1Fd77C99CaM0z4LCY00Cnq0raw.png 700w"
                          src="/framerusercontent.com/images/1Fd77C99CaM0z4LCY00Cnq0raw.png"
                          alt=""
                          className="scalloppay-s41"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className="framer-195in2s"
                  data-framer-name="Frame 1707480011"
                >
                  <div className="ssr-variant hidden-xsaq5o">
                    <div
                      className="framer-1tpktcy scalloppay-s49 reveal"
                      data-framer-name="Everything runs in one place. No fragmentation. No"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s107">
                        One account. One balance. Built for real-world payments.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
                    <div
                      className="framer-1tpktcy scalloppay-s30 reveal"
                      data-framer-name="Everything runs in one place. No fragmentation. No"
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s108">
                        One account. One balance. Built for real-world payments.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-xsaq5o">
                    <div
                      className="framer-187t9ss scalloppay-s23 reveal"
                      data-framer-name="Pay globally. Spend locally."
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s109">
                        Pay globally. Spend locally.
                      </p>
                    </div>
                  </div>
                  <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
                    <div
                      className="framer-187t9ss scalloppay-s23 reveal"
                      data-framer-name="Pay globally. Spend locally."
                      data-framer-component-type="RichTextContainer"
                    >
                      <p dir="auto" className="framer-text scalloppay-s110">
                        Pay globally. Spend locally.
                      </p>
                    </div>
                  </div>
                  <div className="framer-1tq239y">
                    {/*$*/}
                    <a
                      className="framer-19yabk5 framer-ma5p3b"
                      data-framer-name="Appstore"
                      href="https://apps.apple.com/app/scallop/id6746711366"
                      target="_blank"
                      rel="noopener"
                    >
                      <div
                        data-framer-component-type="SVG"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-k8kbr9 scalloppay-s111"
                        aria-hidden="true"
                      >
                        <div className="svgContainer scalloppay-s47">
                          <svg className="scalloppay-s112">
                            <use href="#svg1322499166_10645" />
                          </svg>
                        </div>
                      </div>
                    </a>
                    {/*/$*/}
                    {/*$*/}
                    <a
                      className="framer-1azc1oa framer-ma5p3b"
                      data-framer-name="Playstore"
                      href="https://play.google.com/store/apps/details?id=com.app.scallop"
                      target="_blank"
                      rel="noopener"
                    >
                      <div
                        data-framer-component-type="SVG"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-3rc0ez scalloppay-s111"
                        aria-hidden="true"
                      >
                        <div className="svgContainer scalloppay-s47">
                          <svg className="scalloppay-s112">
                            <use href="#svg-412316951_7924" />
                          </svg>
                        </div>
                      </div>
                    </a>
                    {/*/$*/}
                  </div>
                </div>
              </div>
            </div>
            <div className="ssr-variant hidden-c4t5yq hidden-xsaq5o">
              <div className="framer-16a7wxv-container">
                <div
                  className="framer-60Kb5 framer-1rilglu framer-v-1rilglu scalloppay-s113"
                  data-framer-name="Desktop"
                >
                  <div
                    className="framer-14npji9"
                    data-framer-name="Frame 33595"
                  >
                    <div className="framer-1nbyyte">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1ick3k6 scalloppay-s46"
                        aria-hidden="true"
                      >
                        <div className="svgContainer scalloppay-s47">
                          <svg viewBox="0 0 699 196" className="scalloppay-s48">
                            <use href="#svg-1137231340_6119" />
                          </svg>
                        </div>
                      </div>
                      <div className="framer-6st60f">
                        <div
                          className="framer-9nwe5k scalloppay-s114 reveal"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s115">
                            <strong className="framer-text">
                              One account for all your currencies{' '}
                              <br className="framer-text" />
                            </strong>
                            Manage, send, and receive money globally
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-1d0k7xa"
                        data-framer-name="ICO Logo_Blue"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            width="1440"
                            height="1440"
                            sizes="(min-width: 1440px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px, (max-width: 809.98px) 60px"
                            srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                            src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                            alt=""
                            className="scalloppay-s35"
                          />
                        </div>
                      </div>
                      <div className="scallop-compliance-note">
                        <p>
                          This website is managed by Scallop Pvt Limited, Sri Lanka.
                          <br />
                          Scallop does not provide services in the countries listed on
                          its{' '}
                          <a
                            href="https://docs.scallopx.com/details/onboarding-regions"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Prohibited Countries list
                          </a>
                          .
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-c50yne"
                      data-framer-name="Frame 33594"
                    >
                      <div className="framer-5dec6k" data-framer-name="Menu">
                        <div
                          className="framer-nmphiu scalloppay-s116 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s117">
                            Programs
                          </p>
                        </div>
                        <div className="framer-1odpfed" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-1tz9h0j-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/ambassador"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/ambassador"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Ambassador
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                      <div className="framer-a8htgk" data-framer-name="Menu">
                        <div
                          className="framer-1rugbzn scalloppay-s116 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s117">
                            Products
                          </p>
                        </div>
                        <div className="framer-1oe4fxe" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-153yqwe-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/accounts"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/accounts"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Accounts
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1di1zw4-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/cards"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/cards"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Cards
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-165n05h-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/scallop-pay"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/scallop-pay"
                                    data-framer-page-link-current="true"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Pay
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1ddhrxh-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/scallop-plus"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/scallop-plus"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Plus
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          <div className="framer-nsl31k-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="https://blog.scallopx.com/"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="https://blog.scallopx.com/"
                                    rel="noopener"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Blogs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                        </div>
                      </div>
                      <div className="framer-bcfdyi" data-framer-name="Menu">
                        <div
                          className="framer-cv5tks scalloppay-s116 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s117">
                            Support
                          </p>
                        </div>
                        <div className="framer-16j5a70" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-1apiy1v-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/support"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/support"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Contact Us
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-650678-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/helpcenter"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/helpcenter"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    FAQs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          <div className="framer-1935128-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="https://docs.scallopx.com/"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="https://docs.scallopx.com/"
                                    rel="noopener"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Docs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-1l4w042"
                    data-framer-name="Frame 33831"
                  >
                    <div className="framer-jk8g5w" data-framer-name="Link">
                      <div className="framer-80yh0c">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="ic:baseline-copyright"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-m3skko scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 20 20" className="scalloppay-s48">
                              <use href="#svg-1839680863_948" />
                            </svg>
                          </div>
                        </div>
                        <div
                          className="framer-hv1cvb scalloppay-s119 reveal"
                          data-framer-name="Item"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s120">
                            2026 Scallop Group. All rights reserved.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1c28m8b">
                      {/*$*/}
                      <a
                        data-framer-component-type="SVG"
                        as="a"
                        data-framer-name="X"
                        href="https://x.com/Scallopcom"
                        target="_blank"
                        rel="noopener"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-dziac9 framer-1d3y7cu scalloppay-s121"
                        aria-hidden="true"
                      />
                      {/*/$*/}
                      {/*$*/}
                      <a
                        className="framer-n9nhin framer-1d3y7cu"
                        data-framer-name="LinkdIn"
                        href="https://www.linkedin.com/company/scallopcom"
                        target="_blank"
                        rel="noopener"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="linkd"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ggemab scalloppay-s122"
                          aria-hidden="true"
                        />
                      </a>
                      {/*/$*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ssr-variant hidden-1epkjq8 hidden-xsaq5o">
              <div className="framer-16a7wxv-container">
                <div
                  className="framer-60Kb5 framer-1rilglu framer-v-183e6ee scalloppay-s113"
                  data-framer-name="Tablet"
                >
                  <div
                    className="framer-14npji9"
                    data-framer-name="Frame 33595"
                  >
                    <div className="framer-1nbyyte">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1ick3k6 scalloppay-s46"
                        aria-hidden="true"
                      >
                        <div className="svgContainer scalloppay-s47">
                          <svg viewBox="0 0 699 196" className="scalloppay-s48">
                            <use href="#svg-1137231340_6119" />
                          </svg>
                        </div>
                      </div>
                      <div className="framer-6st60f">
                        <div
                          className="framer-9nwe5k scalloppay-s114 reveal"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s115">
                            <strong className="framer-text">
                              One account for all your currencies{' '}
                              <br className="framer-text" />
                            </strong>
                            Manage, send, and receive money globally
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-1d0k7xa"
                        data-framer-name="ICO Logo_Blue"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            width="1440"
                            height="1440"
                            sizes="(min-width: 1440px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px, (max-width: 809.98px) 60px"
                            srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                            src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                            alt=""
                            className="scalloppay-s35"
                          />
                        </div>
                      </div>
                      <div className="scallop-compliance-note">
                        <p>
                          This website is managed by Scallop Pvt Limited, Sri Lanka.
                          <br />
                          Scallop does not provide services in the countries listed on
                          its{' '}
                          <a
                            href="https://docs.scallopx.com/details/onboarding-regions"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Prohibited Countries list
                          </a>
                          .
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-c50yne"
                      data-framer-name="Frame 33594"
                    >
                      <div className="framer-5dec6k" data-framer-name="Menu">
                        <div
                          className="framer-nmphiu scalloppay-s116 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s117">
                            Programs
                          </p>
                        </div>
                        <div className="framer-1odpfed" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-1tz9h0j-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/ambassador"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/ambassador"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Ambassador
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                      <div className="framer-a8htgk" data-framer-name="Menu">
                        <div
                          className="framer-1rugbzn scalloppay-s116 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s117">
                            Products
                          </p>
                        </div>
                        <div className="framer-1oe4fxe" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-153yqwe-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/accounts"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/accounts"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Accounts
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1di1zw4-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/cards"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/cards"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Cards
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-165n05h-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/scallop-pay"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/scallop-pay"
                                    data-framer-page-link-current="true"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Pay
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1ddhrxh-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/scallop-plus"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/scallop-plus"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Plus
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          <div className="framer-nsl31k-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="https://blog.scallopx.com/"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="https://blog.scallopx.com/"
                                    rel="noopener"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Blogs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                        </div>
                      </div>
                      <div className="framer-bcfdyi" data-framer-name="Menu">
                        <div
                          className="framer-cv5tks scalloppay-s116 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s117">
                            Support
                          </p>
                        </div>
                        <div className="framer-16j5a70" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-1apiy1v-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/support"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/support"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Contact Us
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-650678-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/helpcenter"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/helpcenter"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    FAQs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          <div className="framer-1935128-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="https://docs.scallopx.com/"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="https://docs.scallopx.com/"
                                    rel="noopener"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Docs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-1l4w042"
                    data-framer-name="Frame 33831"
                  >
                    <div className="framer-jk8g5w" data-framer-name="Link">
                      <div className="framer-80yh0c">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="ic:baseline-copyright"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-m3skko scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 20 20" className="scalloppay-s48">
                              <use href="#svg-1839680863_948" />
                            </svg>
                          </div>
                        </div>
                        <div
                          className="framer-hv1cvb scalloppay-s119 reveal"
                          data-framer-name="Item"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s120">
                            2026 Scallop Group. All rights reserved.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1c28m8b">
                      {/*$*/}
                      <a
                        data-framer-component-type="SVG"
                        as="a"
                        data-framer-name="X"
                        href="https://x.com/Scallopcom"
                        target="_blank"
                        rel="noopener"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-dziac9 framer-1d3y7cu scalloppay-s121"
                        aria-hidden="true"
                      />
                      {/*/$*/}
                      {/*$*/}
                      <a
                        className="framer-n9nhin framer-1d3y7cu"
                        data-framer-name="LinkdIn"
                        href="https://www.linkedin.com/company/scallopcom"
                        target="_blank"
                        rel="noopener"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="linkd"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ggemab scalloppay-s122"
                          aria-hidden="true"
                        />
                      </a>
                      {/*/$*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="ssr-variant hidden-c4t5yq hidden-1epkjq8">
              <div className="framer-16a7wxv-container">
                <div
                  className="framer-60Kb5 framer-1rilglu framer-v-ltf6f8 scalloppay-s113"
                  data-framer-name="Mobile"
                >
                  <div
                    className="framer-14npji9"
                    data-framer-name="Frame 33595"
                  >
                    <div className="framer-1nbyyte">
                      <div
                        data-framer-component-type="SVG"
                        data-framer-name="Logo + Logo Type"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-1ick3k6 scalloppay-s46"
                        aria-hidden="true"
                      >
                        <div className="svgContainer scalloppay-s47">
                          <svg viewBox="0 0 699 196" className="scalloppay-s48">
                            <use href="#svg-1137231340_6119" />
                          </svg>
                        </div>
                      </div>
                      <div className="framer-6st60f">
                        <div
                          className="framer-9nwe5k scalloppay-s114 reveal"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s115">
                            <strong className="framer-text">
                              One account for all your currencies{' '}
                              <br className="framer-text" />
                            </strong>
                            Manage, send, and receive money globally
                          </p>
                        </div>
                      </div>
                      <div
                        className="framer-1d0k7xa"
                        data-framer-name="ICO Logo_Blue"
                      >
                        <div
                          data-framer-background-image-wrapper="true"
                          className="scalloppay-s34"
                        >
                          <img
                            decoding="async"
                            width="1440"
                            height="1440"
                            sizes="(min-width: 1440px) 60px, (min-width: 810px) and (max-width: 1439.98px) 60px, (max-width: 809.98px) 60px"
                            srcSet="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 512w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1024w,/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png 1440w"
                            src="/framerusercontent.com/images/eFAqz3bGw0AvBGw3Cz1JaKPyTI.png"
                            alt=""
                            className="scalloppay-s35"
                          />
                        </div>
                      </div>
                      <div className="scallop-compliance-note">
                        <p>
                          This website is managed by Scallop Pvt Limited, Sri Lanka.
                          <br />
                          Scallop does not provide services in the countries listed on
                          its{' '}
                          <a
                            href="https://docs.scallopx.com/details/onboarding-regions"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Prohibited Countries list
                          </a>
                          .
                        </p>
                      </div>
                    </div>
                    <div
                      className="framer-c50yne"
                      data-framer-name="Frame 33594"
                    >
                      <div className="framer-5dec6k" data-framer-name="Menu">
                        <div
                          className="framer-nmphiu scalloppay-s116 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s117">
                            Programs
                          </p>
                        </div>
                        <div className="framer-1odpfed" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-1tz9h0j-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/ambassador"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/ambassador"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Ambassador
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                        </div>
                      </div>
                      <div className="framer-a8htgk" data-framer-name="Menu">
                        <div
                          className="framer-1rugbzn scalloppay-s116 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s117">
                            Products
                          </p>
                        </div>
                        <div className="framer-1oe4fxe" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-153yqwe-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/accounts"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/accounts"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Accounts
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1di1zw4-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/cards"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/cards"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Cards
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-165n05h-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/scallop-pay"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/scallop-pay"
                                    data-framer-page-link-current="true"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Pay
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-1ddhrxh-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/scallop-plus"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/scallop-plus"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Plus
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          <div className="framer-nsl31k-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="https://blog.scallopx.com/"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="https://blog.scallopx.com/"
                                    rel="noopener"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Blogs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                        </div>
                      </div>
                      <div className="framer-bcfdyi" data-framer-name="Menu">
                        <div
                          className="framer-cv5tks scalloppay-s116 reveal"
                          data-framer-name="Heading"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s117">
                            Support
                          </p>
                        </div>
                        <div className="framer-16j5a70" data-framer-name="List">
                          {/*$*/}
                          <div className="framer-1apiy1v-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/support"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/support"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Contact Us
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          {/*$*/}
                          <div className="framer-650678-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="/helpcenter"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="/helpcenter"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    FAQs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                          {/*/$*/}
                          <div className="framer-1935128-container">
                            {/*$*/}
                            <a
                              className="framer-A3ctK framer-6lXp4 framer-xhaz2i framer-v-xhaz2i framer-l5iotj"
                              data-framer-name="Link"
                              href="https://docs.scallopx.com/"
                            >
                              <div
                                className="framer-wlx7jb scalloppay-s116 reveal"
                                data-framer-name="Item"
                                data-framer-component-type="RichTextContainer"
                              >
                                <p className="framer-text scalloppay-s118">
                                  {/*$*/}
                                  <span
                                    className="framer-text framer-styles-preset-11r53mh"
                                    data-styles-preset="LO9i42feF"
                                    href="https://docs.scallopx.com/"
                                    rel="noopener"
                                    data-nested-link="true"
                                    role="link"
                                    tabIndex={0}
                                  >
                                    Scallop Docs
                                  </span>
                                  {/*/$*/}
                                </p>
                              </div>
                            </a>
                            {/*/$*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="framer-1l4w042"
                    data-framer-name="Frame 33831"
                  >
                    <div className="framer-jk8g5w" data-framer-name="Link">
                      <div className="framer-80yh0c">
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="ic:baseline-copyright"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-m3skko scalloppay-s46"
                          aria-hidden="true"
                        >
                          <div className="svgContainer scalloppay-s47">
                            <svg viewBox="0 0 20 20" className="scalloppay-s48">
                              <use href="#svg-1839680863_948" />
                            </svg>
                          </div>
                        </div>
                        <div
                          className="framer-hv1cvb scalloppay-s119 reveal"
                          data-framer-name="Item"
                          data-framer-component-type="RichTextContainer"
                        >
                          <p dir="auto" className="framer-text scalloppay-s120">
                            2026 Scallop Group. All rights reserved.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="framer-1c28m8b">
                      {/*$*/}
                      <a
                        data-framer-component-type="SVG"
                        as="a"
                        data-framer-name="X"
                        href="https://x.com/Scallopcom"
                        target="_blank"
                        rel="noopener"
                        parentsize="0"
                        _constraints="[object Object]"
                        rotation="0"
                        shadows=""
                        className="framer-dziac9 framer-1d3y7cu scalloppay-s121"
                        aria-hidden="true"
                      />
                      {/*/$*/}
                      {/*$*/}
                      <a
                        className="framer-n9nhin framer-1d3y7cu"
                        data-framer-name="LinkdIn"
                        href="https://www.linkedin.com/company/scallopcom"
                        target="_blank"
                        rel="noopener"
                      >
                        <div
                          data-framer-component-type="SVG"
                          data-framer-name="linkd"
                          parentsize="0"
                          _constraints="[object Object]"
                          rotation="0"
                          shadows=""
                          className="framer-1ggemab scalloppay-s122"
                          aria-hidden="true"
                        />
                      </a>
                      {/*/$*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="framer-swsn81-container">
            {/*$*/}
            {/*/$*/}
          </div>
        </div>
        <div id="overlay" />
        {/*/$*/}
      </>
    </div>
  );
}

export default ScallopPay;
